(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.nbUtils = {}));
}(this, (function (exports) { 'use strict';

    /*
     * @module:
     * @Descripttion:
     * @Author: jinxueqiang
     * @Date: 2021-10-28 17:50:44
     * @LastEditors: jinxueqiang
     * @LastEditTime: 2021-12-24 12:44:59
     */
    var GlobalSetting = /** @class */ (function () {
        function GlobalSetting() {
        }
        return GlobalSetting;
    }());
    // 创建全局 global (global|window|self)
    (function () {
        if (typeof global !== "undefined") ;
        else if (typeof window !== "undefined") {
            // @ts-ignore
            window['global'] = window;
        }
        else if (typeof self !== "undefined") {
            // @ts-ignore
            self.global = self;
        }
        // 一些常用方法
        global['each'] = function (arr, func, _this) {
            var i;
            var len = arr.length;
            for (i = 0; i < len; i++) {
                var re = null;
                if (_this) {
                    re = func.call(_this, i, arr[i]);
                }
                else {
                    re = func.call(arr[i], i, arr[i]);
                }
                if (re === false) {
                    break;
                }
            }
        };
        Date.prototype['pattern'] = function (fmt) {
            var o = {
                "M+": this.getMonth() + 1,
                "d+": this.getDate(),
                "h+": this.getHours() % 12 == 0 ? 12 : this.getHours() % 12,
                "H+": this.getHours(),
                "m+": this.getMinutes(),
                "s+": this.getSeconds(),
                "q+": Math.floor((this.getMonth() + 3) / 3),
                "S": this.getMilliseconds() //毫秒
            };
            var week = {
                "0": "/u65e5",
                "1": "/u4e00",
                "2": "/u4e8c",
                "3": "/u4e09",
                "4": "/u56db",
                "5": "/u4e94",
                "6": "/u516d"
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
            }
            if (/(E+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? "/u661f/u671f" : "/u5468") : "") + week[this.getDay() + ""]);
            }
            for (var k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                }
            }
            return fmt;
        };
    })();

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    }

    var NumberUtilities = /** @class */ (function () {
        function NumberUtilities() {
        }
        /**
         *  Round a number. By default the number is rounded to the nearest
         *  integer. Specifying a roundToInterval parameter allows you to round
         *  to the nearest of a specified interval.
         *  @param  number             The number you want to round.
         *  @param  nRoundToInterval   (optional) The interval to which you want to
         *                             round the number. The default is 1.
         *  @return                    The number rounded to the nearest interval.
         */
        NumberUtilities.round = function (nNumber, nRoundToInterval) {
            if (nRoundToInterval === void 0) {
                nRoundToInterval = 1;
            }
            // Return the result
            return Math.round(nNumber / nRoundToInterval) * nRoundToInterval;
        };
        /**
         *  Get the floor part of a number. By default the integer part of the
         *  number is returned just as if calling Math.floor( ). However, by specifying
         *  a roundToInterval, you can get non-integer floor parts.
         *  to the nearest of a specified interval.
         *  @param  number             The number for which you want the floor part.
         *  @param  nRoundToInterval   (optional) The interval to which you want to
         *                             get the floor part of the number. The default is 1.
         *  @return                    The floor part of the number.
         */
        NumberUtilities.floor = function (nNumber, nRoundToInterval) {
            if (nRoundToInterval === void 0) {
                nRoundToInterval = 1;
            }
            // Return the result
            return Math.floor(nNumber / nRoundToInterval) * nRoundToInterval;
        };
        /**
         *  Get the ceiling part of a number. By default the next highested integer
         *  number is returned just as if calling Math.ceil( ). However, by specifying
         *  a roundToInterval, you can get non-integer ceiling parts.
         *  to the nearest of a specified interval.
         *  @param  number             The number for which you want the ceiling part.
         *  @param  nRoundToInterval   (optional) The interval to which you want to
         *                             get the ceiling part of the number. The default is 1.
         *  @return                    The ceiling part of the number.
         */
        NumberUtilities.ceil = function (nNumber, nRoundToInterval) {
            if (nRoundToInterval === void 0) {
                nRoundToInterval = 1;
            }
            // Return the result
            return Math.ceil(nNumber / nRoundToInterval) * nRoundToInterval;
        };
        /**
         *  Generate a random number within a specified range. By default the value
         *  is rounded to the nearest integer. You can specify an interval to which
         *  to round the value.
         *  @param  minimum            The minimum value in the range.
         *  @param  maximum            (optional) The maxium value in the range. If
         omitted, the minimum value is used as the maximum,
         and 0 is used as the minimum.
         *  @param  roundToInterval    (optional) The interval to which to round.
         *  @return                    The random number.
         */
        NumberUtilities.random = function (nMinimum, nMaximum, nRoundToInterval) {
            if (nMaximum === void 0) {
                nMaximum = 0;
            }
            if (nRoundToInterval === void 0) {
                nRoundToInterval = 1;
            }
            // If the minimum is greater than the maximum, switch the two.
            if (nMinimum > nMaximum) {
                var nTemp = nMinimum;
                nMinimum = nMaximum;
                nMaximum = nTemp;
            }
            // Calculate the range by subtracting the minimum from the maximum. Add
            // 1 times the round to interval to ensure even distribution.
            var nDeltaRange = (nMaximum - nMinimum) + (1 * nRoundToInterval);
            // Multiply the range by Math.random(). This generates a random number
            // basically in the range, but it won't be offset properly, nor will it
            // necessarily be rounded to the correct number of places yet.
            var nRandomNumber = Math.random() * nDeltaRange;
            // Add the minimum to the random offset to generate a random number in the correct range.
            nRandomNumber += nMinimum;
            // Return the random value. Use the custom floor( ) method to ensure the
            // result is rounded to the proper number of decimal places.
            return NumberUtilities.floor(nRandomNumber, nRoundToInterval);
        };
        /**
         * 返回唯一字符串形式的id
         * @return
         *
         */
        NumberUtilities.getUniqueID = function () {
            return NumberUtilities.getUnique() + "";
        };
        /**
         *  Generate a unique number.
         *  @return                    The unique number
         */
        NumberUtilities.getUnique = function () {
            if (NumberUtilities._aUniqueIDs == null) {
                NumberUtilities._aUniqueIDs = new Array();
            }
            // Create a number based on the current date and time. This will be unique
            // in most cases.
            var dCurrent = new Date();
            var nID = dCurrent.getTime();
            // It is possible that the value may not be unique if it was generated
            // within the same millisecond as a previous number. Therefore, check to
            // make sure. If it is not unique, then generate a random value and concatenate
            // it with the previous one.
            while (!NumberUtilities.isUnique(nID)) {
                nID += NumberUtilities.random(dCurrent.getTime(), 2 * dCurrent.getTime());
            }
            NumberUtilities._aUniqueIDs.push(nID);
            // Return the number.
            return nID;
        };
        /**
         *  Check to see if a number is unique within the array of stored numbers.
         *  @param  number            The number to compare.
         *  @return                   True or false
         */
        NumberUtilities.isUnique = function (nNumber) {
            for (var i = 0; i < NumberUtilities._aUniqueIDs.length; i++) {
                if (NumberUtilities._aUniqueIDs[i] == nNumber) {
                    return false;
                }
            }
            return true;
        };
        return NumberUtilities;
    }());

    var Point = /** @class */ (function () {
        function Point(x, y) {
            if (x === void 0) { x = 0; }
            if (y === void 0) { y = 0; }
            this.x = 0;
            this.y = 0;
            this.x = x;
            this.y = y;
        }
        /**
         * Vec2转Point
         * @param vec2
         * @returns {Point}
         */
        Point.vec2ToPoint = function (vec2) {
            var p = new Point(vec2.get_x(), vec2.get_y());
            return p;
        };
        Point.interpolate = function (pt1, pt2, f) {
            var xDis = (pt2.x - pt1.x);
            var yDis = (pt2.y - pt1.y);
            return new Point(pt1.x + (xDis * f), pt1.y + (yDis * f));
        };
        Point.distance = function (pt1, pt2) {
            var a = pt1.x - pt2.x;
            var b = pt1.y - pt2.y;
            return Math.sqrt(a * a + b * b);
        };
        Point.prototype.clone = function () {
            return new Point(this.x, this.y);
        };
        Point.prototype.normalize = function (thickness) {
            var len = this.length;
            if (len === 0)
                return;
            this.x *= thickness / len;
            this.y *= thickness / len;
        };
        Object.defineProperty(Point.prototype, "length", {
            get: function () {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            enumerable: false,
            configurable: true
        });
        Point.prototype.add = function (v) {
            return new Point(this.x + v.x, this.y + v.y);
        };
        Point.prototype.subtract = function (v) {
            return new Point(this.x - v.x, this.y - v.y);
        };
        Point.prototype.sub = function (v) {
            return this.subtract(v);
        };
        Point.prototype.equals = function (toCompare) {
            return (this.x === toCompare.x && this.y === toCompare.y);
        };
        Point.prototype.toString = function () {
            return "{x:" + this.x + ", y:" + this.y + "}";
        };
        Point.prototype.setTo = function (xa, ya) {
            this.x = xa;
            this.y = ya;
        };
        return Point;
    }());

    var Rectangle = /** @class */ (function () {
        function Rectangle(x, y, width, height) {
            if (x === void 0) { x = 0; }
            if (y === void 0) { y = 0; }
            if (width === void 0) { width = 0; }
            if (height === void 0) { height = 0; }
            this.x = x;
            this.y = y;
            this.width = width;
            this.height = height;
            this.topLeftPoint = new Point();
            this.sizePoint = new Point();
        }
        Rectangle.prototype.clone = function () {
            return new Rectangle(this.x, this.y, this.width, this.height);
        };
        Rectangle.prototype.copyFrom = function (sourceRect) {
            this.x = sourceRect.x;
            this.y = sourceRect.y;
            this.width = sourceRect.width;
            this.height = sourceRect.height;
        };
        /**
         * 通过填充两个矩形之间的水平和垂直空间，将这两个矩形组合在一起以创建一个新的 Rectangle 对象。
         * @param toUnion  Rectangle
         * @returns {Rectangle}
         */
        Rectangle.prototype.union = function (toUnion) {
            if (toUnion.width === 0 || toUnion.height === 0)
                return this;
            var leftX = Math.min(this.x, toUnion.x);
            var leftY = Math.min(this.y, toUnion.y);
            var newW = Math.max(this.x + this.width, toUnion.x + toUnion.width) - leftX;
            var newH = Math.max(this.y + this.height, toUnion.y + toUnion.height) - leftY;
            return new Rectangle(leftX, leftY, newW, newH);
        };
        /**
         * 按指定量增加 Rectangle 对象的大小（以像素为单位）。
         * @param dx
         * @param dy
         */
        Rectangle.prototype.inflate = function (dx, dy) {
            this.x -= dx;
            this.width += 2 * dx;
            this.y -= dy;
            this.height += 2 * dy;
        };
        Rectangle.prototype.contains = function (cx, cy) {
            return (cx >= this.x && cx <= this.right
                && cy >= this.y && cy <= this.bottom);
        };
        Rectangle.prototype.containsPoint = function (point) {
            return this.contains(point.x, point.y);
        };
        Rectangle.prototype.offset = function (dx, dy) {
            this.x += dx;
            this.y += dy;
        };
        /**
         * 确定在 toIntersect 参数中指定的对象是否与此 Rectangle 对象相交。
         * 此方法检查指定的 Rectangle 对象的 x、y、width 和 height 属性，以查看它是否与此 Rectangle 对象相交。
         * @param toIntersect Rectangle
         * @param notEdge 设置只挨着边的不算相交(默认算相交)
         * @returns {boolean}
         */
        Rectangle.prototype.intersects = function (toIntersect, notEdge) {
            if (notEdge) {
                return !(toIntersect.left >= this.right ||
                    toIntersect.right <= this.left ||
                    toIntersect.top >= this.bottom ||
                    toIntersect.bottom <= this.top);
            }
            else {
                return !(toIntersect.left > this.right ||
                    toIntersect.right < this.left ||
                    toIntersect.top > this.bottom ||
                    toIntersect.bottom < this.top);
            }
        };
        /**
         * 如果在 toIntersect 参数中指定的 Rectangle 对象与此 Rectangle 对象相交，
         * 则返回交集区域作为 Rectangle 对象。
         * 如果矩形不相交，则此方法返回一个空的 Rectangle 对象，其属性设置为 0。
         * @param toIntersect  Rectangle
         * @param notEdge 设置只挨着边的不算相交(默认算相交)
         * @returns {Rectangle}
         */
        Rectangle.prototype.intersection = function (toIntersect, notEdge) {
            var rect = new Rectangle();
            if (this.intersects(toIntersect, notEdge)) {
                if (toIntersect.left <= this.right) {
                    rect.x = toIntersect.left;
                    rect.width = this.right - rect.x;
                }
                else {
                    rect.x = this.left;
                    rect.width = toIntersect.right - rect.x;
                }
                rect.y = (toIntersect.top < this.top) ? this.top : toIntersect.top;
                rect.height = (toIntersect.bottom < this.bottom) ? toIntersect.bottom : this.bottom;
                rect.height = rect.height - rect.y;
            }
            return rect;
        };
        Rectangle.prototype.isEmpty = function () {
            return this.width <= 0 || this.height <= 0;
        };
        Rectangle.prototype.setEmpty = function () {
            this.x = 0;
            this.y = 0;
            this.width = 0;
            this.height = 0;
        };
        Rectangle.prototype.setTo = function (xa, ya, widtha, heighta) {
            this.x = xa;
            this.y = ya;
            this.width = widtha;
            this.height = heighta;
        };
        Object.defineProperty(Rectangle.prototype, "left", {
            /*****************************************************
             *                              getter/setter
             *****************************************************/
            get: function () {
                return this.x;
            },
            set: function (value) {
                this.x = value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Rectangle.prototype, "top", {
            get: function () {
                return this.y;
            },
            set: function (value) {
                this.y = value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Rectangle.prototype, "right", {
            get: function () {
                return this.x + this.width;
            },
            set: function (value) {
                this.width = value - this.x;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Rectangle.prototype, "bottom", {
            get: function () {
                return this.y + this.height;
            },
            set: function (value) {
                this.height = value - this.y;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Rectangle.prototype, "topLeft", {
            get: function () {
                this.topLeftPoint.x = this.x;
                this.topLeftPoint.y = this.y;
                return this.topLeftPoint;
            },
            set: function (value) {
                this.x = value.x;
                this.y = value.y;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Rectangle.prototype, "size", {
            get: function () {
                this.sizePoint.x = this.width;
                this.sizePoint.y = this.height;
                return this.sizePoint;
            },
            set: function (value) {
                this.width = value.x;
                this.height = value.y;
            },
            enumerable: false,
            configurable: true
        });
        return Rectangle;
    }());

    /**
     * 数组工具类
     * @author Administrator
     *
     */
    var ArrayUtil = /** @class */ (function () {
        function ArrayUtil() {
        }
        /**
         * arr中是否包含value
         * @param arr
         * @param value
         * @return
         *
         */
        ArrayUtil.arrayContainsValue = function (arr, value) {
            return (arr.indexOf(value) != -1);
        };
        /**
         * 数组 arr 是否完全包含数组 valueArr
         * @param arr
         * @param valueArr
         * @return
         *
         */
        ArrayUtil.arrayContainsArray = function (arr, valueArr) {
            var has_ = true;
            var i;
            var len = valueArr.length;
            for (i = 0; i < len; i++) {
                var c = valueArr[i];
                if (!ArrayUtil.arrayContainsValue(arr, c)) {
                    has_ = false;
                    break;
                }
            }
            return has_;
        };
        /**
         * 去掉 arr中指定元素
         * @param arr
         * @param value
         *
         */
        ArrayUtil.removeValueFromArray = function (arr, value) {
            var len = arr.length;
            var i;
            for (i = len; i > -1; i--) {
                if (arr[i] == value) {
                    arr.splice(i, 1);
                    return true;
                }
            }
            return false;
        };
        /**
         * 向数组arr不重复添加元素obj(保证数组中值obj的唯一)
         * @param arr
         * @param obj
         *
         */
        ArrayUtil.addSingleArr = function (arr, obj) {
            if (!ArrayUtil.arrayContainsValue(arr, obj)) {
                arr.push(obj);
                return true;
            }
            return false;
        };
        /**
         * 去掉 arr 中指定位置的元素
         * @param arr
         * @param index_
         * @return 返回删除的元素
         *
         */
        ArrayUtil.removeValueFromIndex = function (arr, index_) {
            var len = arr.length;
            var reValue;
            if (index_ >= 0 && index_ < len) {
                reValue = arr[index_];
                arr.splice(index_, 1);
            }
            return reValue;
        };
        /**
         * 从数组 arr 中去掉 removeArr_包含的元素
         * @param arr
         * @param removeArr_
         * @return
         *
         */
        ArrayUtil.removeArrayFromArray = function (arr, removeArr_) {
            var len = removeArr_.length;
            var i;
            for (i = 0; i < len; i++) {
                var c = removeArr_[i];
                ArrayUtil.removeValueFromArray(arr, c);
            }
        };
        /**
         * 单一复制,去掉重复元素
         * @param a
         * @return
         *
         */
        ArrayUtil.createUniqueCopy = function (a) {
            var newArray = new Array();
            var len = a.length;
            var item;
            var i;
            for (i = 0; i < len; ++i) {
                item = a[i];
                if (ArrayUtil.arrayContainsValue(newArray, item)) {
                    continue;
                }
                newArray.push(item);
            }
            return newArray;
        };
        /**
         * 指定的两个数组元素是否完全相等
         * @param arr1
         * @param arr2
         * @return
         *
         */
        ArrayUtil.arraysAreEqual = function (arr1, arr2) {
            if (arr1.length != arr2.length) {
                return false;
            }
            var len = arr1.length;
            var i;
            for (i = 0; i < len; i++) {
                if (arr1[i] !== arr2[i]) {
                    return false;
                }
            }
            return true;
        };
        /**
         * 清空数组但不改变其地址
         *
         * @param arr 已分配内存地址的数组，不能为NULL
         *
         */
        ArrayUtil.clear = function (arr) {
            if (!arr || arr.length == 0)
                return;
            arr.splice(0, arr.length);
            return;
        };
        /**
         * 遍历数组并用trace输出
         *
         * @param arr 要遍历的数组
         *
         */
        ArrayUtil.print = function (arr) {
            for (var prop in arr) {
                console.log(prop + ":" + arr[prop]);
            }
        };
        /**
         * 取得 arr_ 中元素value_的下标位置
         * @param arr_
         * @param value_
         * @return
         *
         */
        ArrayUtil.getIndexFromValue = function (arr_, value_) {
            var ind_ = -1;
            var i;
            var len = arr_.length;
            for (i = 0; i < len; i++) {
                if (value_ == arr_[i]) {
                    ind_ = i;
                    break;
                }
            }
            return ind_;
        };
        /**
         * 两个对象互换值
         * @param obj1
         * @param obj2
         *
         */
        ArrayUtil.swapObj = function (obj1, obj2) {
        };
        /**
         * 互换arr中指定两个元素的位置
         * @param arr
         * @param obj1
         * @param obj2
         *
         */
        ArrayUtil.swapArrObj = function (arr, obj1, obj2) {
            var ind1 = ArrayUtil.getIndexFromValue(arr, obj1);
            var ind2 = ArrayUtil.getIndexFromValue(arr, obj2);
            if (ind1 > -1 && ind2 > -1) {
                arr[ind1] = obj2;
                arr[ind2] = obj1;
            }
        };
        /**
         * 互换arr中指定位置的两个元素的位置
         * @param arr
         * @param obj1
         * @param obj2
         *
         */
        ArrayUtil.swapArrInd = function (arr, ind1, ind2) {
            var obj1 = arr[ind1];
            var obj2 = arr[ind2];
            if (ind1 > -1 && ind2 > -1) {
                arr[ind1] = obj2;
                arr[ind2] = obj1;
            }
        };
        /**
         * 将 ind1位置的元素插入到ind2位置,ind2之后的元素都向后移动
         * @param arr
         * @param ind1 要移动的元素位置
         * @param ind2 要插入的位置
         * @return 调整后的新数组
         *
         */
        ArrayUtil.swapChaArrInd = function (arr, ind1, ind2) {
            var newArr = [];
            // 要移动的元素
            var obj1;
            // 要插入的位置
            var obj2;
            var i;
            var j;
            var len = arr.length;
            if (ind1 < 0 || ind1 >= len) {
                return arr;
            }
            if (ind2 >= 0 && ind2 < len) {
                // 要移动的元素
                obj1 = arr[ind1];
                // 要插入的位置
                obj2 = arr[ind2];
                // 将要移动的元素给拿出来
                ArrayUtil.removeValueFromIndex(arr, ind1);
                // 插入位置元素在修改数组后的位置
                var chaInd_ = ArrayUtil.getIndexFromValue(arr, obj2);
                for (i = 0; i < chaInd_; i++) {
                    newArr[i] = arr[i];
                }
                newArr[chaInd_] = obj1;
                for (j = chaInd_ + 1; j < len + 1; j++) {
                    newArr[j] = arr[j - 1];
                }
            }
            else if (ind2 >= len) {
                // 要移动的元素
                obj1 = arr[ind1];
                // 将要移动的元素给拿出来
                ArrayUtil.removeValueFromIndex(arr, ind1);
                // 添加到末尾
                arr.push(obj1);
                newArr = ArrayUtil.copyArray(arr);
            }
            else if (ind2 < 0) {
                // 要移动的元素
                obj1 = arr[ind1];
                // 将要移动的元素给拿出来
                ArrayUtil.removeValueFromIndex(arr, ind1);
                // 添加到末尾
                arr.unshift(obj1);
                newArr = ArrayUtil.copyArray(arr);
            }
            return newArr;
        };
        /**
         * 获取数组的字符串格式
         * @param arr
         * @param join
         * @returns {*}
         */
        ArrayUtil.getString = function (arr, join) {
            if (!arr || arr.length === 0)
                return "";
            join = join || ',';
            return arr.join(join);
        };
        ArrayUtil.copy = function (arr) {
            if (!arr)
                return null;
            return arr.slice();
        };
        /**
         * 复制数组
         * @param arr
         * @returns {*}
         */
        ArrayUtil.copyArray = function (arr) {
            return ArrayUtil.copy(arr);
        };
        /**
         * 判断指定对象是否为数组
         * @param o
         * @returns {boolean}
         */
        ArrayUtil.isArray = function (o) {
            return Object.prototype.toString.call(o) === '[object Array]';
        };
        return ArrayUtil;
    }());

    var ObjTree = /** @class */ (function () {
        function ObjTree() {
            this.xmlDecl = '<?xml version="1.0" encoding="UTF-8" ?>\n';
            this.attr_prefix = '-';
        }
        ObjTree.prototype.parseXML = function (xml) {
            var root;
            var xmldom;
            if (window.DOMParser) {
                xmldom = new DOMParser();
                //      xmldom.async = false;           // DOMParser is always sync-mode
                var dom = xmldom.parseFromString(xml, "application/xml");
                if (!dom)
                    return;
                root = dom.documentElement;
            }
            else if (window.ActiveXObject) {
                xmldom = new window.ActiveXObject('Microsoft.XMLDOM');
                xmldom.async = false;
                xmldom.loadXML(xml);
                root = xmldom.documentElement;
            }
            if (!root)
                return;
            return this.parseDOM(root);
        };
        //  method: parseHTTP( url, options, callback )
        ObjTree.prototype.parseHTTP = function (url, options, callback) {
            var myopt = {};
            for (var key in options) {
                myopt[key] = options[key]; // copy object
            }
            if (!myopt.method) {
                if (typeof (myopt.postBody) === "undefined" &&
                    typeof (myopt.postbody) === "undefined" &&
                    typeof (myopt.parameters) === "undefined") {
                    myopt.method = "get";
                }
                else {
                    myopt.method = "post";
                }
            }
            if (callback) {
                myopt.asynchronous = true; // async-mode
                var __this_1 = this;
                var __func_1 = callback;
                var __save_1 = myopt.onComplete;
                myopt.onComplete = function (trans) {
                    var tree;
                    if (trans && trans.responseXML && trans.responseXML.documentElement) {
                        tree = __this_1.parseDOM(trans.responseXML.documentElement);
                    }
                    __func_1(tree, trans);
                    if (__save_1)
                        __save_1(trans);
                };
            }
            else {
                myopt.asynchronous = false; // sync-mode
            }
            var trans;
            if (typeof (HTTP) !== "undefined" && HTTP.Request) {
                myopt.uri = url;
                var req = new HTTP.Request(myopt); // JSAN
                if (req)
                    trans = req.transport;
            }
            else if (typeof (Ajax) !== "undefined" && Ajax.Request) {
                var req = new Ajax.Request(url, myopt); // ptorotype.js
                if (req)
                    trans = req.transport;
            }
            if (callback)
                return trans;
            if (trans && trans.responseXML && trans.responseXML.documentElement) {
                return this.parseDOM(trans.responseXML.documentElement);
            }
        };
        //  method: parseDOM( documentroot )
        ObjTree.prototype.parseDOM = function (root) {
            if (!root)
                return;
            this.__force_array = {};
            if (this.force_array) {
                for (var i = 0; i < this.force_array.length; i++) {
                    this.__force_array[this.force_array[i]] = 1;
                }
            }
            var json = this.parseElement(root); // parse root node
            if (this.__force_array[root.nodeName]) {
                json = [json];
            }
            if (root.nodeType !== 11) { // DOCUMENT_FRAGMENT_NODE
                var tmp = {};
                tmp[root.nodeName] = json; // root nodeName
                json = tmp;
            }
            return json;
        };
        //  method: parseElement( element )
        ObjTree.prototype.parseElement = function (elem) {
            //  COMMENT_NODE
            if (elem.nodeType === 7) {
                return;
            }
            //  TEXT_NODE CDATA_SECTION_NODE
            if (elem.nodeType === 3 || elem.nodeType === 4) {
                var bool = elem.nodeValue.match(/[^\x00-\x20]/);
                if (bool === null)
                    return; // ignore white spaces
                return elem.nodeValue;
            }
            var retval;
            var cnt = {};
            //  parse attributes
            if (elem.attributes && elem.attributes.length) {
                retval = {};
                for (var i = 0; i < elem.attributes.length; i++) {
                    var key = elem.attributes[i].nodeName;
                    if (typeof (key) !== "string")
                        continue;
                    var val = elem.attributes[i].nodeValue;
                    if (!val)
                        continue;
                    key = this.attr_prefix + key;
                    if (typeof (cnt[key]) === "undefined")
                        cnt[key] = 0;
                    cnt[key]++;
                    this.addNode(retval, key, cnt[key], val);
                }
            }
            //  parse child nodes (recursive)
            if (elem.childNodes && elem.childNodes.length) {
                var textonly = true;
                if (retval)
                    textonly = false; // some attributes exists
                for (var i = 0; i < elem.childNodes.length && textonly; i++) {
                    var ntype = elem.childNodes[i].nodeType;
                    if (ntype === 3 || ntype === 4)
                        continue;
                    textonly = false;
                }
                if (textonly) {
                    if (!retval)
                        retval = "";
                    for (var i = 0; i < elem.childNodes.length; i++) {
                        retval += elem.childNodes[i].nodeValue;
                    }
                }
                else {
                    if (!retval)
                        retval = {};
                    for (var i = 0; i < elem.childNodes.length; i++) {
                        var key = elem.childNodes[i].nodeName;
                        if (typeof (key) !== "string")
                            continue;
                        var val = this.parseElement(elem.childNodes[i]);
                        if (!val)
                            continue;
                        if (typeof (cnt[key]) === "undefined")
                            cnt[key] = 0;
                        cnt[key]++;
                        this.addNode(retval, key, cnt[key], val);
                    }
                }
            }
            return retval;
        };
        //  method: addNode( hash, key, count, value )
        ObjTree.prototype.addNode = function (hash, key, cnts, val) {
            if (this.__force_array[key]) {
                if (cnts === 1)
                    hash[key] = [];
                hash[key][hash[key].length] = val; // push
            }
            else if (cnts === 1) { // 1st sibling
                hash[key] = val;
            }
            else if (cnts === 2) { // 2nd sibling
                hash[key] = [hash[key], val];
            }
            else { // 3rd sibling and more
                hash[key][hash[key].length] = val;
            }
        };
        //  method: writeXML( tree )
        ObjTree.prototype.writeXML = function (tree) {
            var xml = this.hash_to_xml(null, tree);
            return this.xmlDecl + xml;
        };
        //  method: hash_to_xml( tagName, tree )
        ObjTree.prototype.hash_to_xml = function (name, tree) {
            var elem = [];
            var attr = [];
            for (var key in tree) {
                if (!tree.hasOwnProperty(key))
                    continue;
                var val = tree[key];
                if (key.charAt(0) !== this.attr_prefix) {
                    if (typeof (val) === "undefined" || !val) {
                        elem[elem.length] = "<" + key + " />";
                    }
                    else if (typeof (val) === "object" && val.constructor === Array) {
                        elem[elem.length] = this.array_to_xml(key, val);
                    }
                    else if (typeof (val) === "object") {
                        elem[elem.length] = this.hash_to_xml(key, val);
                    }
                    else {
                        elem[elem.length] = this.scalar_to_xml(key, val);
                    }
                }
                else {
                    attr[attr.length] = " " + (key.substring(1)) + '="' + (this.xml_escape(val)) + '"';
                }
            }
            var jattr = attr.join("");
            var jelem = elem.join("");
            if (typeof (name) === "undefined" || !name) ;
            else if (elem.length > 0) {
                if (jelem.match(/\n/)) {
                    jelem = "<" + name + jattr + ">\n" + jelem + "</" + name + ">\n";
                }
                else {
                    jelem = "<" + name + jattr + ">" + jelem + "</" + name + ">\n";
                }
            }
            else {
                jelem = "<" + name + jattr + " />\n";
            }
            return jelem;
        };
        //  method: array_to_xml( tagName, array )
        ObjTree.prototype.array_to_xml = function (name, array) {
            var out = [];
            for (var i = 0; i < array.length; i++) {
                var val = array[i];
                if (typeof (val) === "undefined" || !val) {
                    out[out.length] = "<" + name + " />";
                }
                else if (typeof (val) === "object" && val.constructor === Array) {
                    out[out.length] = this.array_to_xml(name, val);
                }
                else if (typeof (val) === "object") {
                    out[out.length] = this.hash_to_xml(name, val);
                }
                else {
                    out[out.length] = this.scalar_to_xml(name, val);
                }
            }
            return out.join("");
        };
        //  method: scalar_to_xml( tagName, text )
        ObjTree.prototype.scalar_to_xml = function (name, text) {
            if (name === "#text") {
                return this.xml_escape(text);
            }
            else {
                return "<" + name + ">" + this.xml_escape(text) + "</" + name + ">\n";
            }
        };
        //  method: xml_escape( text )
        ObjTree.prototype.xml_escape = function (text) {
            return (text + '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        };
        return ObjTree;
    }());

    var StringUtil = /** @class */ (function () {
        function StringUtil() {
        }
        StringUtil.stringsAreEqual = function (s1, s2, caseSensitive) {
            if (caseSensitive) {
                return (s1 === s2);
            }
            else {
                return (s1.toUpperCase() === s2.toUpperCase());
            }
        };
        /**
         *	Removes whitespace from the front and the end of the specified
         *	string.
         *
         *	@param input The String whose beginning and ending whitespace will
         *	will be removed.
         *
         *	@returns A String with whitespace removed from the begining and end
         *
         * 	@langversion ActionScript 3.0
         *	@playerversion Flash 9.0
         *	@tiptext
         */
        StringUtil.trim = function (input) {
            return StringUtil.ltrim(StringUtil.rtrim(input));
        };
        /**
         *	Removes whitespace from the front of the specified string.
         *
         *	@param input The String whose beginning whitespace will will be removed.
         *
         *	@returns A String with whitespace removed from the begining
         *
         * 	@langversion ActionScript 3.0
         *	@playerversion Flash 9.0
         *	@tiptext
         */
        StringUtil.ltrim = function (input) {
            var size = input.length;
            for (var i = 0; i < size; i++) {
                if (input.charCodeAt(i) > 32) {
                    return input.substring(i);
                }
            }
            return "";
        };
        /**
         *	Removes whitespace from the end of the specified string.
         *
         *	@param input The String whose ending whitespace will will be removed.
         *
         *	@returns A String with whitespace removed from the end
         *
         * 	@langversion ActionScript 3.0
         *	@playerversion Flash 9.0
         *	@tiptext
         */
        StringUtil.rtrim = function (input) {
            var size = input.length;
            for (var i = size; i > 0; i--) {
                if (input.charCodeAt(i - 1) > 32) {
                    return input.substring(0, i);
                }
            }
            return "";
        };
        /**
         *	Determines whether the specified string begins with the spcified prefix.
         *
         *	@param input The string that the prefix will be checked against.
         *
         *	@param prefix The prefix that will be tested against the string.
         *
         *	@returns True if the string starts with the prefix, false if it does not.
         *
         * 	@langversion ActionScript 3.0
         *	@playerversion Flash 9.0
         *	@tiptext
         */
        StringUtil.beginsWith = function (input, prefix) {
            return (prefix === input.substring(0, prefix.length));
        };
        /**
         *	Determines whether the specified string ends with the spcified suffix.
         *
         *	@param input The string that the suffic will be checked against.
         *
         *	@param prefix The suffic that will be tested against the string.
         *
         *	@returns True if the string ends with the suffix, false if it does not.
         *
         * 	@langversion ActionScript 3.0
         *	@playerversion Flash 9.0
         *	@tiptext
         */
        StringUtil.endsWith = function (input, suffix) {
            return (suffix === input.substring(input.length - suffix.length));
        };
        /**
         *	Removes all instances of the remove string in the input string.
         *
         *	@param input The string that will be checked for instances of remove
         *	string
         *
         *	@param remove The string that will be removed from the input string.
         *
         *	@returns A String with the remove string removed.
         *
         * 	@langversion ActionScript 3.0
         *	@playerversion Flash 9.0
         *	@tiptext
         */
        StringUtil.remove = function (input, remove) {
            return StringUtil.replace(input, remove, "");
        };
        /**
         *	Replaces all instances of the replace string in the input string
         *	with the replaceWith string.
         *
         *	@param input The string that instances of replace string will be
         *	replaces with removeWith string.
         *
         *	@param replace The string that will be replaced by instances of
         *	the replaceWith string.
         *
         *	@param replaceWith The string that will replace instances of replace
         *	string.
         *
         *	@returns A new String with the replace string replaced with the
         *	replaceWith string.
         *
         * 	@langversion ActionScript 3.0
         *	@playerversion Flash 9.0
         *	@tiptext
         */
        StringUtil.replace = function (input, replace, replaceWith) {
            return input.split(replace).join(replaceWith);
        };
        /**
         *	Specifies whether the specified string is either non-null, or contains
         *  	characters (i.e. length is greater that 0)
         *
         *	@param s The string which is being checked for a value
         *
         * 	@langversion ActionScript 3.0
         *	@playerversion Flash 9.0
         *	@tiptext
         */
        StringUtil.stringHasValue = function (s) {
            return (s !== null && s.length > 0);
        };
        /**
         * 字符串allStr_是否包含字符串childStr_
         * @param	allStr_
         * @param	childStr_
         * @return
         */
        StringUtil.contains = function (allStr_, childStr_) {
            if (allStr_ === "" && childStr_ === "")
                return true;
            if (!allStr_)
                return false;
            return allStr_.indexOf(childStr_) > -1;
        };
        /**
         * 补全字符串
         * @param str_ 要补的字符串
         * @param len_ 最后的字符串长度
         * @param dot_ 每次补充的字符串
         * @return
         *
         */
        StringUtil.addString = function (str_, len_, dot_) {
            if (dot_ === void 0) {
                dot_ = "0";
            }
            var nStr_ = str_;
            while (nStr_.length < len_) {
                nStr_ += dot_;
            }
            return nStr_;
        };
        return StringUtil;
    }());

    //  全局 PIXI TouchEvent
    var TouchEvent = {};
    TouchEvent.TOUCH_BEGIN = 'pointerdown';
    TouchEvent.TOUCH_MOVE = 'pointermove';
    TouchEvent.TOUCH_END = 'pointerup';
    TouchEvent.TAP = 'tap';
    TouchEvent.TOUCH_END_OUTSIDE = 'pointerupoutside';
    /**
     * types 位置: @nobook/nb-utils/dist/types
     *
     * js 使用方式:
     * var M = require('@nobook/nb-utils');
     * 或
     * var M = require('@nobook/nb-utils/nobook/M');
     *
     * ts 使用方式:
     * import {M} from '@nobook/nb-utils';
     *
     */
    var M = /** @class */ (function () {
        function M() {
        }
        /**
         * 返回t的绝对值的平方
         * @param  t
         * @return null
         */
        M.sq = function (t) {
            return Math.pow(Math.abs(t), 2);
        };
        /**
         * 勾股定理求斜边
         * @param a
         * @param b
         * @returns {number}
         */
        M.bevel = function (a, b) {
            return Math.sqrt(a * a + b * b);
        };
        /**
         * 返回数组中最大的数值
         * @param arr
         * @return null
         *
         */
        M.max = function (arr) {
            return Math.max.apply(null, arr);
        };
        /**
         * 平均数
         * @param arr
         * @return null
         *
         */
        M.ping = function (arr) {
            var sum_ = 0;
            for (var i = 0; i < arr.length; i++) {
                var num_ = arr[i];
                sum_ += num_;
            }
            return sum_ / arr.length;
        };
        /**
         * 得到基于毫秒的唯一id
         * @return null
         *
         */
        M.getUnique = function () {
            return NumberUtilities.getUnique();
        };
        /**
         * 返回唯一字符串形式的id
         * @return null
         */
        M.getUniqueID = function () {
            return NumberUtilities.getUniqueID();
        };
        /**
         * 返回base64格式唯一字符串形式的id
         * @return null
         */
        M.getBase64UniqueID = function () {
            return btoa(Math.random().toString());
        };
        /**
         * 返回数组内rectangle组合成的最大矩形
         * @param arr
         * @return {*}
         */
        M.getBoundsFromArray = function (arr) {
            var bounds = new Rectangle();
            var left = 100000000;
            var right = -100000000;
            var top = 10000000000;
            var bot = -1000000000;
            for (var i = 0; i < arr.length; i++) {
                var rect = arr[i];
                if (rect.x < left) {
                    left = rect.x;
                }
                if (rect.y < top) {
                    top = rect.y;
                }
                if (rect.x + rect.width > right) {
                    right = rect.x + rect.width;
                }
                if (rect.y + rect.height > bot) {
                    bot = rect.y + rect.height;
                }
            }
            bounds.x = left;
            bounds.y = top;
            bounds.width = right - left;
            bounds.height = bot - top;
            return bounds;
        };
        /**
         * 返回两个点的中心点
         * @param point1
         * @param point2
         * @return null
         *
         */
        M.getCenP = function (point1, point2) {
            return new Point((point1.x + point2.x) / 2, (point1.y + point2.y) / 2);
        };
        /**
         * 平面两点的距离公式
         * @param  p1
         * @param  p2
         * @return null
         */
        M.getPointLen = function (p1, p2) {
            return Point.distance(p1, p2);
        };
        /**
         * 返回符号 +-1
         * @param  num
         * @return null
         */
        M.getFuhao = function (num) {
            if (num >= 0) {
                return 1;
            }
            else {
                return -1;
            }
        };
        /**
         * 点与点的距离
         * 返回点<x1,y1>与点<x2,y2>的距离
         * @param x1    A点x值
         * @param y1    A点y值
         * @param x2    B点x值
         * @param y2    B点y值
         * @return number   A、B两点间的距离值
         *
         */
        M.getXYLen = function (x1, y1, x2, y2) {
            return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
        };
        /**
         * 根据线上的两点求出该线上的第三点
         * @param  m 距离pA点的距离
         * @param  isNei 是否为线内的一点
         * @param  pA 线上两点端的一个点
         * @param  pB 线上两点端的另一个点
         * @return Point 所求的点
         */
        M.getXianDianByDis = function (m, isNei, pA, pB) {
            var k;
            if (pA.x === pB.x && pA.y === pB.y)
                return M.getSPPoint(pA);
            if (Math.abs(pB.x - pA.x) < 0.000001) {
                if ((isNei && pA.y > pB.y) || (!isNei && pA.y < pB.y)) {
                    return new Point(pA.x, pA.y - m);
                }
                else if ((!isNei && pA.y > pB.y) || (isNei && pA.y < pB.y)) {
                    return new Point(pA.x, pA.y + m);
                }
            }
            k = (pB.y - pA.y) / (pB.x - pA.x);
            var x1 = Math.sqrt(m * m / (1 + k * k)) + pA.x;
            var x2 = -Math.sqrt(m * m / (1 + k * k)) + pA.x;
            var y1 = k * (x1 - pA.x) + pA.y;
            var y2 = k * (x2 - pA.x) + pA.y;
            var dis1 = M.sq(x1 - pB.x) + M.sq(y1 - pB.y);
            var dis2 = M.sq(x2 - pB.x) + M.sq(y2 - pB.y);
            //
            var reP;
            if (isNei) {
                if (dis1 > dis2) {
                    // dis1,即(x1,y1)为外点
                    reP = new Point(x2, y2);
                }
                else {
                    reP = new Point(x1, y1);
                }
            }
            else {
                if (dis1 > dis2) {
                    // dis1,即(x1,y1)为外点
                    reP = new Point(x1, y1);
                }
                else {
                    reP = new Point(x2, y2);
                }
            }
            return reP;
        };
        /**
         * 根据比例求出两点间的距离
         * (由pt1开始, 沿着 pt1->pt2 延长 f 倍)
         * @param pt1 左边的点
         * @param pt2 右边的点
         * @param f  靠近左端的比例(占pt1,pt2距离的比例)
         * @returns {*}
         */
        M.interpolate = function (pt1, pt2, f) {
            var xDis = (pt2.x - pt1.x);
            var yDis = (pt2.y - pt1.y);
            return new Point(pt1.x + (xDis * f), pt1.y + (yDis * f));
        };
        /**
         * 比较亮的随机颜色
         * @return null
         */
        M.getRandColor = function () {
            return (Math.random() * 0xffffff + 0xff000000);
        };
        /**
         * 获取有几位小数
         * @param num_
         * @return null
         *
         */
        M.getDecimalNum = function (num_) {
            var s = "" + num_;
            if (StringUtil.contains(s, ".")) {
                s = s.substring(s.indexOf(".") + 1);
                return s.length;
            }
            return 0;
        };
        /**
         * 现在先算平面的(z=0)
         * 逆时针旋转为正值
         * <p1,p2>向量
         * 返回角度
         * @param p1 (主动偏移向量)
         * @param p2 (参照向量,默认为x轴正方向)
         * @return null  正数表逆时针旋转角度,负的表顺时针旋转
         *
         */
        M.getAngleP = function (p1, p2) {
            if (!p2) {
                // 默认为y轴正方向
                p2 = new Point(0, 0);
            }
            var x = p1.x - p2.x;
            var y = p1.y - p2.y;
            var angle = Math.atan2(y, x) * (180 / Math.PI);
            return angle;
        };
        M.getAngleP1 = function (p1, p2) {
            var angle1 = Math.atan2(p1.y, p1.x) * (180.0 / Math.PI);
            if (!p2) {
                return angle1;
            }
            var angle2 = Math.atan2(p2.y, p2.x) * (180.0 / Math.PI);
            return (angle1 - angle2);
        };
        /**
         * 利用两点之间距离公式，求出三角形的三边长a，b，c后，
         * 令p = (a+b+c)/2。再套入以下公式就可以求出三角形的面积S :
         * S = sqrt(p*(p-a)*(p-b)*(p-c))
         * @param  p1
         * @param  p2
         * @param  p3
         * @return null
         */
        M.getAreaByPoints = function (p1, p2, p3) {
            var dx = p1.x - p2.x;
            var dy = p1.y - p2.y;
            var p1Len = Math.sqrt(dx * dx + dy * dy);
            dx = p2.x - p3.x;
            dy = p2.y - p3.y;
            var p2Len = Math.sqrt(dx * dx + dy * dy);
            dx = p3.x - p1.x;
            dy = p3.y - p1.y;
            //
            var p3Len = Math.sqrt(dx * dx + dy * dy);
            var p = (p1Len + p2Len + p3Len) / 2;
            return Math.sqrt(p * (p - p1Len) * (p - p2Len) * (p - p3Len));
        };
        /**
         * 判断点tp是否在p1、p2、p3三点构成的三角形内
         * @param  tp
         * @param  p1
         * @param  p2
         * @param  p3
         * @return null
         */
        M.checkPointIn = function (tp, p1, p2, p3) {
            var area = M.getAreaByPoints(p1, p2, p3);
            var targetThreeTimesArea = 0;
            targetThreeTimesArea += M.getAreaByPoints(tp, p1, p2);
            targetThreeTimesArea += M.getAreaByPoints(tp, p2, p3);
            targetThreeTimesArea += M.getAreaByPoints(tp, p3, p1);
            return targetThreeTimesArea === area || Math.abs(targetThreeTimesArea - area) < 0.0001;
        };
        /**
         * 根据三角形的三个顶点求出角度
         * 返回点verA的角度值(0~180)
         * 根据余弦公式
         * cosA = (b^2 + c^2 - a^2) / (2·b·c)
         * @param  PA
         * @param  PB
         * @param  PC
         * @return null 返回点pA的角度值(0~180)
         */
        M.getAngleByP = function (pA, pB, pC) {
            // verA点对应的边a的长度
            var a = M.getPointLen(pB, pC);
            var b = M.getPointLen(pA, pC);
            var c = M.getPointLen(pA, pB);
            var bcL_ = 2 * b * c;
            if (bcL_ === 0) {
                bcL_ = 0.000000001;
            }
            var cosA = (b * b + c * c - a * a) / bcL_;
            cosA = M.range(cosA, 0, 1); // 取合理的范围
            return Math.acos(cosA) * 180 / Math.PI;
        };
        /**
         * 平面三角形内心公式
         * @param  p1 (x1,y1,z1)
         * @param  p2 (x2,y2,z2)
         * @param  p3 (x3,y3,z3)
         * @return null
         */
        M.getPoint_NeiXin = function (p1, p2, p3) {
            var a = M.getPointLen(p1, p2);
            var b = M.getPointLen(p2, p3);
            var c = M.getPointLen(p1, p3);
            var tP = new Point();
            tP.x = (a * p1.x + b * p2.x + c * p3.x) / (a + b + c);
            tP.y = (a * p1.y + b * p2.y + c * p3.y) / (a + b + c);
            return tP;
        };
        /**
         * 返回 sp的(x,y)位置坐标点
         * @param sp
         * @return null
         *
         */
        M.getSPPoint = function (sp) {
            return new Point(sp.x, sp.y);
        };
        /**
         * 设置 sp的(x,y)位置坐标点
         * @param sp
         * @return null
         *
         */
        M.setSPPoint = function (sp, point_) {
            if (sp && point_) {
                sp.x = point_.x;
                sp.y = point_.y;
            }
        };
        /**
         * 设置 sp的(x,y)位置坐标点
         * @param sp
         * @param x_
         * @param y_
         *
         */
        M.setSPPointXY = function (sp, x_, y_) {
            if (sp) {
                sp.x = x_;
                sp.y = y_;
            }
        };
        /**
         * 点p围绕点fP逆时针旋转angle (弧度)
         * @param  p
         * @param  fP
         * @param  angle
         * @return null
         */
        M.rotaPointFromP = function (p, fP, angle) {
            if (fP.y === p.y) {
                fP.y = p.y + M.MIN;
            }
            var np = new Point(p.x - fP.x, p.y - fP.y);
            var rp = M.rotaPoint(np, angle);
            rp.x += fP.x;
            rp.y += fP.y;
            return rp;
        };
        /**
         * 返回向量<p1,p2>的角度
         * x轴负方向为0度角,负值代表顺时针旋转,正值为逆时针旋转
         * @param  p1
         * @param  p2
         * @return null 返回角度值
         */
        M.atan = function (p1, p2) {
            return M.getAngleP(p1, p2);
        };
        /**
         * 根据三角形的两个顶点和两个角得到第三个顶点
         * @param  p1 修改角度的点
         * @param  p2 逆时针第一个点
         * @param  angle1 为p1的角(角度值)
         * @param  angle2 为p2的角(角度值)
         * @return null
         */
        M.getPFrom2DianAndAngle = function (p1, p2, angle1, angle2) {
            // 先顺时针转过去,此为顺时针旋转的角度(角度值)
            var roAngle = 180 + M.atan(p2, p1) - angle2;
            // 转弧度
            var roAngleHu = M.toHu(roAngle);
            //let roAngleHu:Number = roAngle;
            // 旋转后的两个点
            p1 = M.rotaPoint(p1, -roAngleHu);
            p2 = M.rotaPoint(p2, -roAngleHu);
            // 求出p1和p2两点的距离
            var cLen = Math.sqrt(M.sq(p2.x - p1.x) + M.sq(p2.y - p1.y));
            // 求出1点对应的边的长度
            var p1Len = cLen * Math.sin(M.toHu(angle1)) / Math.sin(M.toHu(180 - angle1 - angle2));
            // 求出旋转后新点的坐标
            var cx = p1Len + p2.x;
            var cy = p2.y;
            // 旋转后的新点
            var xp = new Point(cx, cy);
            // 还逆时针旋转回去
            // 转弧度
            xp = M.rotaPoint(xp, roAngleHu);
            //
            return xp;
        };
        /**
         * 转弧度
         * @param  num
         * @return null
         */
        M.toHu = function (num) {
            return num / 180 * Math.PI;
        };
        /**
         * 转角度
         * @param  num
         * @return null
         */
        M.toAngle = function (num) {
            return num / Math.PI * 180;
        };
        /**
         * 得到字符串中的数字
         * @param  str
         * @return null
         */
        M.getNumStr = function (str) {
            str = str.toString();
            if (!str)
                return "";
            // 数字
            var numReg = /(-?\d+)(\.\d+)?/;
            var arr = numReg.exec(str);
            if (arr === null)
                return 0;
            var numStr = (numReg.exec(str)[0] || 0) - 0;
            return numStr;
        };
        /**
         * 得到字符串中 "'" 符号
         * @param  str
         * @return null
         */
        M.getPStr = function (str) {
            // '''''
            var pReg = /'+/;
            var pNumStr = pReg.exec(str);
            return pNumStr;
        };
        /**
         * 返回当前字符串中的字母名
         * @param  str
         * @return null
         */
        M.getFAStr = function (str) {
            var mReg = /[ABC]+/;
            var mStr = mReg.exec(str);
            return mStr;
        };
        /**
         * p在直线 <p1, p2> 的上方还是下方
         * @param p
         * @param p1
         * @param p2
         * @returns {number}
         */
        M.checkPointOnLineLeftOrRight = function (p, p1, p2) {
            var result = (p.x - p1.x) * (p.y - p2.y) - (p.x - p2.x) * (p.y - p1.y);
            return result;
        };
        /**
         * 点p是否在<p1,p2>直线上
         * 即<p1,p2>直线延长线经过点p
         * @param  p
         * @param  p1
         * @param  p2
         * @param  secNum_ 修正值(距离此范围内则为满足条件)
         * @return null
         */
        M.checkOnLineAB = function (p, p1, p2, secNum_) {
            if (!secNum_) {
                secNum_ = 0.5;
            }
            return Math.abs(((p.y - p1.y) * (p.x - p2.x) - (p.y - p2.y) * (p.x - p1.x))) < secNum_;
        };
        /**
         * 点p是否在<p1,p2>线段内部
         * @param  p
         * @param  p1
         * @param  p2
         * @return null
         */
        M.checkInLineAB = function (p, p1, p2, checkNum) {
            if (!checkNum) {
                checkNum = 0.1;
            }
            var boo = false;
            if (!p) {
                boo = false;
            }
            else {
                // 是否在内部  <p,p1>与<p,p2>距离之和跟<p1,p2>相比，差值在checkNum内则合格
                if (M.getPointLen(p, p1) + M.getPointLen(p, p2) - M.getPointLen(p1, p2) < checkNum) {
                    boo = true;
                }
            }
            return boo;
        };
        /**
         * 直线<p1,p2>与直线<p3,p4>是否平行
         * @param p1
         * @param p2
         * @param p3
         * @param p4
         * @return null
         *
         */
        M.isPingxing = function (p1, p2, p3, p4) {
            var reBoo_ = false;
            var x1 = p1.x;
            var y1 = p1.y;
            var x2 = p2.x;
            var y2 = p2.y;
            var x3 = p3.x;
            var y3 = p3.y;
            var x4 = p4.x;
            var y4 = p4.y;
            // 斜率一样
            if ((y2 - y1) * (x4 - x3) === (x2 - x1) * (y4 - y3)) {
                reBoo_ = true;
            }
            return reBoo_;
        };
        /**
         * 得到两条线相交的焦点
         * p1、p2、p3、p4顺序为左右上下四点
         * <p1,p2>与<p3,p4>
         * @param  p1
         * @param  p2
         * @param  p3
         * @param  p4
         * @return null
         */
        M.getJiaoP = function (p1, p2, p3, p4) {
            var rp = new Point();
            var x1 = p1.x;
            var y1 = p1.y;
            var x2 = p2.x;
            var y2 = p2.y;
            var x3 = p3.x;
            var y3 = p3.y;
            var x4 = p4.x;
            var y4 = p4.y;
            var c = 0.0000001;
            var m;
            if (x2 === x1) {
                m = (y2 - y1) / (x2 - x1 + c);
            }
            else {
                m = (y2 - y1) / (x2 - x1);
            }
            var n;
            if (x4 === x3) {
                n = (y4 - y3) / (x4 - x3 + c);
            }
            else {
                n = (y4 - y3) / (x4 - x3);
            }
            if (m === n) {
                rp.x = (m * x1 - n * x3 + y3 - y1) / (m - n + c);
            }
            else {
                rp.x = (m * x1 - n * x3 + y3 - y1) / (m - n);
            }
            rp.y = m * rp.x - m * x1 + y1;
            //let c:Number = 0.0000001;
            //rp.x = ((y2 - y1) / (x2 - x1+c) * x1 - (y4 - y3) / (x4 - x3+c) * x3 + y3 - y1) / ((y2 - y1+c) / (x2 - x1+c) - (y4 - y3) / (x4 - x3+c)+c);
            //rp.y = (y2 - y1) / (x2 - x1+c) * rp.x - (y2 - y1) / (x2 - x1+c) * x1 + y1;
            //trace("**rp="+rp);;
            return rp;
        };
        /**
         * 检测<p1,p2>与<p3,p4>的焦点是否位于<p1,p2>线段内
         * @param  p1
         * @param  p2
         * @param  p3
         * @param  p4
         * @return null
         */
        M.checkJPIsInAB = function (p1, p2, p3, p4) {
            var boo = false;
            // 得到<p1,p2>与<p3,p4>的焦点
            var jp = M.getJiaoP(p1, p2, p3, p4);
            boo = M.checkInLineAB(jp, p1, p2);
            return boo;
        };
        /**
         * 检测<p1,p2>与<p3,p4>的焦点是否位于<p1,p2>线段内且在<p3,p4>线段内
         * @param  p1
         * @param  p2
         * @param  p3
         * @param  p4
         * @return null
         */
        M.checkJPIsInABCD = function (p1, p2, p3, p4) {
            var boo = false;
            // 得到<p1,p2>与<p3,p4>的焦点
            var jp = M.getJiaoP(p1, p2, p3, p4);
            boo = M.checkInLineAB(jp, p1, p2) && M.checkInLineAB(jp, p3, p4) // 交点在两条线内部
                || M.checkInLineAB(p1, p3, p4) || M.checkInLineAB(p2, p3, p4) // <p1,p2>的一个端点在<p3,p4>上
                || M.checkInLineAB(p3, p1, p2)
                || M.checkInLineAB(p4, p1, p2); // <p3,p4>的一个端点在<p1,p2>上
            return boo;
        };
        /**
         *  pointArr点数组中是否包含tp点
         * @param pointArr
         * @param tp
         * @return null
         *
         */
        M.hasPoint = function (pointArr, tp) {
            var boo = false;
            for (var i = 0; i < pointArr.length; i++) {
                var cp = pointArr[i];
                if (cp.x === tp.x && cp.y === tp.y) {
                    boo = true;
                    break;
                }
            }
            return boo;
        };
        /**
         * 将一个点p相对于轴原点逆时针旋转angle
         * @param  p
         * @param  angle 弧度值
         * @return null
         */
        M.rotaPoint = function (p, angle) {
            var p0 = new Point();
            p0.x = Math.cos(angle) * p.x - Math.sin(angle) * p.y;
            p0.y = Math.cos(angle) * p.y + Math.sin(angle) * p.x;
            return p0;
        };
        /**
         * 返回集合点的矩形区域
         * @param pArr
         * @return null
         *
         */
        M.getPArrRect = function (pArr) {
            var lP;
            var rP;
            for (var i = 0; i < pArr.length; i++) {
                var p = pArr[i];
                if (!lP) {
                    lP = new Point(p.x, p.y);
                }
                else {
                    lP.x = Math.min(lP.x, p.x);
                    lP.y = Math.min(lP.y, p.y);
                }
                if (!rP) {
                    rP = new Point(lP.x, lP.y);
                }
                else {
                    rP.x = Math.max(rP.x, p.x);
                    rP.y = Math.max(rP.y, p.y);
                }
            }
            return new Rectangle(lP.x, lP.y, rP.x - lP.x, rP.y - lP.y);
        };
        /**
         * 返回矩形区域的中心点坐标
         * @param rect
         * @return null
         *
         */
        M.getRectCen = function (rect) {
            var p = new Point();
            p.x = (rect.left + rect.right) / 2;
            p.y = (rect.top + rect.bottom) / 2;
            return p;
        };
        /**
         * 根据两个对角的Point返回Rectangle
         * @param p1
         * @param p2
         * @return null
         *
         */
        M.getRectFromDuiP = function (p1, p2) {
            var x_ = Math.min(p1.x, p2.x);
            var y_ = Math.min(p1.y, p2.y);
            var w_ = Math.abs(p2.x - p1.x);
            var h_ = Math.abs(p2.y - p1.y);
            return new Rectangle(x_, y_, w_, h_);
        };
        /**
         * 返回等比例变化的点(等比例缩放比例算法)
         * @param gp 固定点(原点)
         * @param oriP 原始对比点
         * @param dp 移动后对比点
         * @param p 原始要修改的点
         * @return null 移动后要修改的点
         *
         */
        M.getZoomPoint = function (gP, oriP, dP, p) {
            // gP点
            var x1 = gP.x;
            var y1 = gP.y;
            // oriP点
            var x2 = oriP.x;
            var y2 = oriP.y;
            // dP点
            var x3 = dP.x;
            var y3 = dP.y;
            // 要缩放的点
            var m = p.x;
            var n = p.y;
            // x轴缩小比例
            var a = (x3 - x1) / (x2 - x1);
            var b = (y3 - y1) / (y2 - y1);
            // 返回的点
            var x_ = a * (m - x1) + x1;
            var y_ = b * (n - y1) + y1;
            return new Point(x_, y_);
        };
        M.getZoomPointA = function (gP, oriP, dP, p, angle) {
            //			rP.x = p.x*Math.cos(M.toHu(-angle))+p.y*Math.sin(M.toHu(-angle));
            //			rP.y = p.y*Math.cos(M.toHu(-angle))-p.x*Math.sin(M.toHu(-angle));
            // gP点
            var x1 = gP.x;
            var y1 = gP.y;
            // oriP点
            var x2 = oriP.x;
            var y2 = oriP.y;
            // dP点
            var x3 = dP.x;
            var y3 = dP.y;
            // 要缩放的点
            var m = p.x;
            var n = p.y;
            //
            var cha1P = new Point(x3 - x1, y3 - y1);
            var cha2P = new Point(x2 - x1, y2 - y1);
            var cha3P = new Point(m - x1, n - y1);
            //			cha1P = M.getRoZoomP(cha1P,angle);
            //			cha2P = M.getRoZoomP(cha2P,angle);
            //			cha3P = M.getRoZoomP(cha3P,angle);
            // x轴缩小比例
            var a = cha1P.x / cha2P.x;
            var b = cha1P.y / cha2P.y;
            //
            var tcha = new Point(a * (cha3P.x), b * (cha3P.y));
            //
            var x1_ = tcha.x + x1;
            var y1_ = tcha.y + y1;
            var hcha = new Point(x1_ - m, y1_ - n);
            hcha = M.getRoZoomP(hcha, angle);
            // 返回的点
            //			let x_:Number =tcha.x+x1;
            //			let y_:Number = tcha.y+y1;
            var x_ = hcha.x + m;
            var y_ = hcha.y + n;
            return new Point(x_, y_);
        };
        /**
         * p是否在向量<pA,pB>逆时针方向上
         * @param p
         * @param pA
         * @param pB
         * @return null
         *
         */
        M.isPointNi = function (p, pA, pB) {
            var x1 = pA.x;
            var y1 = pA.y;
            var x2 = pB.x;
            var y2 = pB.y;
            var m = p.x;
            var n = p.y;
            return (m - x1) * (y2 - y1) < (n - y1) * (x2 - x1);
        };
        /**
         * 返回rotation为angle的p(差值向量)的对应坐Point(差值向量)
         * @param p
         * @param angle
         * @return null
         *
         */
        M.getRoZoomP = function (p, angle) {
            var rP = new Point();
            rP.x = p.x * Math.cos(M.toHu(-angle)) + p.y * Math.sin(M.toHu(-angle));
            rP.y = p.y * Math.cos(M.toHu(-angle)) - p.x * Math.sin(M.toHu(-angle));
            return rP;
        };
        /**
         * 绘制椭圆坐标点
         * @param  w_ 整个椭圆的宽度
         * @param  h_ 整个椭圆的高度
         * @param  zhongXinP 椭圆中心点(默认为<0,0>点)
         * @return null 椭圆坐标点集合
         */
        M.getOvalPoint = function (w_, h_, zhongXinP) {
            if (zhongXinP === undefined) {
                zhongXinP = null;
            }
            var reArr = [];
            //
            var a_ = w_ / 2;
            var b_ = h_ / 2;
            var i = 0;
            var x1;
            var y1;
            if (!zhongXinP) {
                zhongXinP = new Point(0, 0);
            }
            while (i < Math.PI * 2) {
                x1 = zhongXinP.x + a_ * Math.sin(i);
                y1 = zhongXinP.y + b_ * Math.cos(i);
                reArr.push(new Point(x1, y1));
                i += (2 / 180 * Math.PI);
            }
            return reArr;
        };
        /**
         * 返回正多边形顶点 [Point]
         * @param n_ 定点数(边数)
         * @param zhongXinP 中心点
         * @param radius_ 外接圆半径
         * @return null
         *
         */
        M.getRegPolygon = function (n_, zhongXinP, radius_) {
            var arr_ = [];
            // 如果边数为一,则返回中心点
            if (n_ === 1) {
                return [zhongXinP];
            }
            for (var i = 0; i < n_; i++) {
                var tP_ = new Point();
                tP_.x = zhongXinP.x + radius_ * Math.cos(Math.PI * 2 / n_ * i);
                tP_.y = zhongXinP.y + radius_ * Math.sin(Math.PI * 2 / n_ * i);
                if (Math.abs(tP_.x) < 0.00001) {
                    tP_.x = 0;
                }
                if (Math.abs(tP_.y) < 0.00001) {
                    tP_.y = 0;
                }
                arr_.push(tP_);
            }
            return arr_;
        };
        /**
         * 封装关联点对象
         * @param p1
         * @param p2
         * @return null
         *
         */
        M.getLianPObj = function (p1_, p2_) {
            return {
                p1: p1_,
                p2: p2_
            };
        };
        /**
         *
         * @param n_
         * @param zhongXinP
         * @param radius_
         * @return null
         *
         */
        M.getRegPolygonRay = function (n_, zhongXinP, radius_) {
            // 坐标点
            var pArr_ = M.getRegPolygon(n_, zhongXinP, radius_);
            /*----------------------计算箭头坐标----------------------*/
            // 关联数组{p1:Point, p2:Point}
            var lianArr_ = [];
            if (n_ === 2) {
                lianArr_.push(M.getLianPObj(pArr_[0], pArr_[1]));
            }
            else if (n_ > 2) {
                for (var i = 0; i < pArr_.length - 1; i++) {
                    lianArr_.push({
                        p1: pArr_[i],
                        p2: pArr_[i + 1]
                    });
                }
                lianArr_.push({
                    p1: pArr_[pArr_.length - 1],
                    p2: pArr_[0]
                });
            }
            return {
                pArr: pArr_,
                lianArr: lianArr_
            };
        };
        /**
         * 返回三射线坐标顶点
         * @param n_ 顶点数
         * @param zhongXinP 中心点
         * @param pDis_ 两点间的间距
         * @return null
         *
         */
        M.getThreeRay = function (n_, zhongXinP, pDis_) {
            // 坐标点
            var arr_ = [];
            // 关联数组{p1:Point, p2:Point}
            var lianArr_ = [];
            //
            var tNum = 0;
            // 先放进中心点
            arr_.push(zhongXinP);
            tNum++;
            // 从上开始逆时针放入点
            // 圈数
            var quanNum_ = Math.ceil((n_ - 1) / 3);
            for (var i = 0; i < quanNum_; i++) {
                for (var j = 0; j < 3; j++) {
                    if (tNum === n_) {
                        break;
                    }
                    // 第一个点对应的内环点(上一个点)
                    var lastP_ = void 0;
                    if (arr_.length === 1) {
                        lastP_ = arr_[0];
                    }
                    else {
                        lastP_ = arr_[arr_.length - 3];
                    }
                    // 第一个点,上方的点
                    var p1_ = new Point(lastP_.x, lastP_.y - pDis_);
                    arr_.push(p1_);
                    tNum++;
                    if (tNum === n_) {
                        break;
                    }
                    // 第二个点, 左下方的点
                    var p2_ = M.rotaPointFromP(p1_, zhongXinP, -Math.PI * 2 / 3);
                    arr_.push(p2_);
                    tNum++;
                    if (tNum === n_) {
                        break;
                    }
                    // 第二个点, 左下方的点
                    var p3_ = M.rotaPointFromP(p1_, zhongXinP, Math.PI * 2 / 3);
                    arr_.push(p3_);
                    tNum++;
                    if (tNum === n_) {
                        break;
                    }
                }
            }
            /*----------------------计算箭头坐标----------------------*/
            if (n_ === 2) {
                lianArr_.push(M.getLianPObj(arr_[0], arr_[1]));
            }
            else if (n_ === 3) {
                lianArr_.push(M.getLianPObj(arr_[0], arr_[1]));
                lianArr_.push(M.getLianPObj(arr_[0], arr_[2]));
            }
            else if (n_ > 3) {
                lianArr_.push(M.getLianPObj(arr_[0], arr_[1]));
                lianArr_.push(M.getLianPObj(arr_[0], arr_[2]));
                for (var ii = 0; ii <= arr_.length - 4; ii++) {
                    lianArr_.push(M.getLianPObj(arr_[ii], arr_[ii + 3]));
                }
            }
            //
            return {
                pArr: arr_,
                lianArr: lianArr_
            };
        };
        /**
         * 返回四射线坐标顶点
         * @param n_
         * @param zhongXinP
         * @param pDis_
         * @return null
         *
         */
        M.getCrossRay = function (n_, zhongXinP, pDis_) {
            // 坐标点
            var arr_ = [];
            // 关联数组{p1:Point, p2:Point}
            var lianArr_ = [];
            //
            var tNum = 0;
            // 先放进中心点
            arr_.push(zhongXinP);
            tNum++;
            // 从上开始逆时针放入点
            // 圈数
            var quanNum_ = Math.ceil((n_ - 1) / 3);
            for (var i = 0; i < quanNum_; i++) {
                for (var j = 0; j < 4; j++) {
                    if (tNum === n_) {
                        break;
                    }
                    // 第一个点对应的内环点(上一个点)
                    var lastP_ = void 0;
                    if (arr_.length === 1) {
                        lastP_ = arr_[0];
                    }
                    else {
                        lastP_ = arr_[arr_.length - 4];
                    }
                    // 第一个点,上方的点
                    var p1_ = new Point(lastP_.x, lastP_.y - pDis_);
                    arr_.push(p1_);
                    tNum++;
                    if (tNum === n_) {
                        break;
                    }
                    // 第二个点, 左方的点
                    var p2_ = M.rotaPointFromP(p1_, zhongXinP, -Math.PI / 2);
                    arr_.push(p2_);
                    tNum++;
                    if (tNum === n_) {
                        break;
                    }
                    // 第三个点, 下方的点
                    var p3_ = M.rotaPointFromP(p1_, zhongXinP, -Math.PI);
                    arr_.push(p3_);
                    tNum++;
                    if (tNum === n_) {
                        break;
                    }
                    // 第四个点, 右方的点
                    var p4_ = M.rotaPointFromP(p1_, zhongXinP, Math.PI / 2);
                    arr_.push(p4_);
                    tNum++;
                    if (tNum === n_) {
                        break;
                    }
                }
            }
            /*----------------------计算箭头坐标----------------------*/
            if (n_ === 2) {
                lianArr_.push(M.getLianPObj(arr_[0], arr_[1]));
            }
            else if (n_ === 3) {
                lianArr_.push(M.getLianPObj(arr_[0], arr_[1]));
                lianArr_.push(M.getLianPObj(arr_[0], arr_[2]));
            }
            else if (n_ === 4) {
                lianArr_.push(M.getLianPObj(arr_[0], arr_[1]));
                lianArr_.push(M.getLianPObj(arr_[0], arr_[2]));
                lianArr_.push(M.getLianPObj(arr_[0], arr_[3]));
            }
            else if (n_ > 4) {
                lianArr_.push(M.getLianPObj(arr_[0], arr_[1]));
                lianArr_.push(M.getLianPObj(arr_[0], arr_[2]));
                lianArr_.push(M.getLianPObj(arr_[0], arr_[3]));
                for (var ii = 0; ii <= arr_.length - 5; ii++) {
                    lianArr_.push(M.getLianPObj(arr_[ii], arr_[ii + 4]));
                }
            }
            //
            return {
                pArr: arr_,
                lianArr: lianArr_
            };
        };
        /**
         * 返回横线坐标顶点
         * @param n_
         * @param zhongXinP
         * @param pDis_
         * @return null
         *
         */
        M.getHorizontalRay = function (n_, zhongXinP, pDis_) {
            // 坐标点
            var arr_ = [];
            // 关联数组{p1:Point, p2:Point}
            var lianArr_ = [];
            //
            var tNum = 0;
            // 先放进中心点
            arr_.push(zhongXinP);
            tNum++;
            // 从上开始逆时针放入点
            // 圈数
            var quanNum_ = Math.ceil((n_ - 1) / 3);
            for (var i = 0; i < quanNum_; i++) {
                for (var j = 0; j < 3; j++) {
                    if (tNum === n_) {
                        break;
                    }
                    // 第一个点对应的内环点(上一个点)
                    var lastP_ = void 0;
                    if (arr_.length === 1) {
                        lastP_ = arr_[0];
                    }
                    else {
                        lastP_ = arr_[arr_.length - 2];
                    }
                    // 第一个点,左边的点
                    var p1_ = new Point(lastP_.x - pDis_, lastP_.y);
                    arr_.push(p1_);
                    tNum++;
                    if (tNum === n_) {
                        break;
                    }
                    // 第二个点, 右边的点
                    var p2_ = M.rotaPointFromP(p1_, zhongXinP, Math.PI);
                    arr_.push(p2_);
                    tNum++;
                    if (tNum === n_) {
                        break;
                    }
                }
            }
            /*----------------------计算箭头坐标----------------------*/
            if (n_ === 2) {
                lianArr_.push(M.getLianPObj(arr_[0], arr_[1]));
            }
            else if (n_ > 2) {
                lianArr_.push(M.getLianPObj(arr_[0], arr_[1]));
                for (var ii = 0; ii <= arr_.length - 3; ii++) {
                    lianArr_.push(M.getLianPObj(arr_[ii], arr_[ii + 2]));
                }
            }
            //
            return {
                pArr: arr_,
                lianArr: lianArr_
            };
        };
        /**
         * 返回竖线坐标顶点
         * @param n_
         * @param zhongXinP
         * @param pDis_
         * @return null
         *
         */
        M.getVerticalRay = function (n_, zhongXinP, pDis_) {
            // 坐标点
            var arr_ = [];
            // 关联数组{p1:Point, p2:Point}
            var lianArr_ = [];
            //
            var tNum = 0;
            // 先放进中心点
            arr_.push(zhongXinP);
            tNum++;
            // 从上开始逆时针放入点
            // 圈数
            var quanNum_ = Math.ceil((n_ - 1) / 3);
            for (var i = 0; i < quanNum_; i++) {
                for (var j = 0; j < 3; j++) {
                    if (tNum === n_) {
                        break;
                    }
                    // 第一个点对应的内环点(上一个点)
                    var lastP_ = void 0;
                    if (arr_.length === 1) {
                        lastP_ = arr_[0];
                    }
                    else {
                        lastP_ = arr_[arr_.length - 2];
                    }
                    // 第一个点,上边的点
                    var p1_ = new Point(lastP_.x, lastP_.y - pDis_);
                    arr_.push(p1_);
                    tNum++;
                    if (tNum === n_) {
                        break;
                    }
                    // 第二个点, 下边的点
                    var p2_ = M.rotaPointFromP(p1_, zhongXinP, Math.PI);
                    arr_.push(p2_);
                    tNum++;
                    if (tNum === n_) {
                        break;
                    }
                }
            }
            /*----------------------计算箭头坐标----------------------*/
            if (n_ === 2) {
                lianArr_.push(M.getLianPObj(arr_[0], arr_[1]));
            }
            else if (n_ > 2) {
                lianArr_.push(M.getLianPObj(arr_[0], arr_[1]));
                for (var ii = 0; ii <= arr_.length - 3; ii++) {
                    lianArr_.push(M.getLianPObj(arr_[ii], arr_[ii + 2]));
                }
            }
            //
            return {
                pArr: arr_,
                lianArr: lianArr_
            };
        };
        /**
         * 根据上点xianS与下点xianX构成的线段,返回dian的对称空间点
         * @param  dian 要进行对称的顶点
         * @param  xianS 一个顶点
         * @param  xianX 另一个顶点
         * @return null
         */
        M.getDuiDianP = function (dian, xianS, xianX) {
            var xdian = new Point();
            // 顶点dian到线段<xianS,xianX>映射的高点
            var gaoDian = M.getGaoDianFrom3Dian(dian, xianS, xianX);
            xdian.x = 2 * gaoDian.x - dian.x;
            xdian.y = 2 * gaoDian.y - dian.y;
            return xdian;
        };
        /**
         * 返回点dian相对于 duiDian 的对称点
         * @param dian
         * @param duiDian
         * @return null
         *
         */
        M.getDuiDianDian = function (dian, duiDian) {
            return new Point(duiDian.x * 2 - dian.x, duiDian.y * 2 - dian.y);
        };
        /**
         * 保留几位小数
         * @param  num
         * @param  wei
         * @return nullgetNumStr
         */
        M.getNumJie = function (num, wei) {
            if (wei === undefined) {
                wei = 0;
            }
            num -= 0;
            var bei = Math.pow(10, wei);
            var str = Math.round(num * bei) / bei + "";
            var sl = str.split('.');
            if (wei === 0) {
                return sl[0];
            }
            var add0 = 0;
            if (sl.length === 2) { //有点
                add0 = wei - sl[1].length;
            }
            else {
                add0 = wei;
                str += ".";
            }
            var step = 0;
            while (step < add0) {
                str += "0";
                step++;
            }
            // 0.00 这种就直接返回 0
            if (str - 0 === 0) {
                return 0;
            }
            return str;
        };
        /**
         * 小数直接舍掉小数点取整
         * @param  num
         * @return {Int}
         */
        M.getNumToInt = function (num) {
            var str = num + "";
            var index = str.indexOf('.');
            if (index === -1) {
                return str - 0;
            }
            str = str.slice(0, index);
            return str - 0;
        };
        /**
         * 以p1_为顶点引出到p1_对面边的高线与对面线相交的高点
         * (暂时不考虑z轴,z设定为0)
         *
         * @param  p1_ 顶点
         * @param  p2_ 线段一个顶点
         * @param  p3_ 线段另一个顶点
         * @return null
         */
        M.getGaoDianFrom3Dian = function (p1_, p2_, p3_) {
            if (!p1_ || !p2_ || !p3_) {
                console.error('nb-utils:getGaoDianFrom3Dian 参数不能为空');
                return null;
            }
            if (p2_.x === p3_.x && p2_.y === p3_.y) {
                return new Point(p2_.x, p2_.y);
            }
            /**** 三个顶点 ****/
            var m1 = p1_.x;
            var n1 = p1_.y;
            var m2 = p2_.x;
            var n2 = p2_.y;
            var m3 = p3_.x;
            var n3 = p3_.y;
            /**** 计算 ****/
            var x = ((n3 - n2) * (n3 - n2) * m2 + (m3 - m2) * (m3 - m2) * m1 + (n1 - n2) * (m3 - m2) * (n3 - n2)) * 1 / ((n3 - n2) * (n3 - n2) + (m3 - m2) * (m3 - m2));
            var y = ((m1 - m2) * (m3 - m2) * (n3 - n2) + (n1 - n2) * (n3 - n2) * (n3 - n2)) / ((n3 - n2) * (n3 - n2) + (m3 - m2) * (m3 - m2)) + n2;
            //
            return new Point(x, y);
        };
        /**
         *  点到直线的距离
         *  点p1_ 到 直线<p2_, p3_> 的距离
         * @param  p1_ 顶点
         * @param  p2_ 线段一个顶点
         * @param  p3_ 线段另一个顶点
         * @return null
         */
        M.getDisFrom3Dian = function (p1_, p2_, p3_) {
            var gaoP = M.getGaoDianFrom3Dian(p1_, p2_, p3_);
            return M.getPointLen(p1_, gaoP);
        };
        /**
         * 得到逆时针方向上垂直于p1_的且距离为dis_的点
         * @param  p1_ 线段的一个端点
         * @param  p2_ 线段的另一个端点
         * @param  isUp_ 是否朝上垂直(否则就朝下)
         * @param  dis_ 距离
         * @return null
         */
        M.getXianDuanGaoXianDian = function (p1_, p2_, dis_, isUp_) {
            if (isUp_ === undefined) {
                isUp_ = true;
            }
            // 内部距离的点
            var pt_ = M.getXianDianByDis(dis_, true, p1_, p2_);
            // pt_绕cenP_逆时针旋转90度
            var reP_;
            if (isUp_) {
                reP_ = M.rotaPointFromP(pt_, p1_, -Math.PI / 2);
            }
            else {
                reP_ = M.rotaPointFromP(pt_, p1_, Math.PI / 2);
            }
            //
            return reP_;
        };
        /**
         * 已知矩形三个点,求第四个点
         * @param p1  所求点的相邻点
         * @param p2   所求点的另一个相邻点
         * @param duiP 所求点的对角点
         * @returns {*}
         */
        M.getRectOneP = function (p1, p2, duiP) {
            return new Point(p1.x + p2.x - duiP.x, p1.y + p2.y - duiP.y);
        };
        /**
         * 'FFFFFF' / '#FFFFFF' / 0xFFFFFF => [r, g, b]
         * 输入一个颜色,将它拆成三个部分:红色,绿色和蓝色
         * @param  color
         * @return null
         */
        M.retrieveRGBComponent = function (color) {
            if (Object.prototype.toString.call(color) === '[object String]') {
                color = color.substring(0, 1) === '#' ? color.substring(1) : color;
                color = ('0x' + color) - 0;
            }
            var r = color >> 16;
            var g = (color >> 8) & 0xff;
            var b = color & 0xff;
            return [r, g, b];
        };
        /**
         * 红色,绿色和蓝色三色组合
         * @param  rgb
         * @return null 返回组合后的16进制
         */
        M.generateFromRGBComponent = function (rgb) {
            if (rgb === null || rgb.length !== 3 ||
                rgb[0] < 0 || rgb[0] > 255 ||
                rgb[1] < 0 || rgb[1] > 255 ||
                rgb[2] < 0 || rgb[2] > 255)
                return 0xFFFFFF;
            return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
        };
        /**
         * 颜色渐变
         * color1是浅色,color2是深色,实现渐变
         * 返回数组长度为 steps-2
         * @param  color1 浅色
         * @param  color2 深色
         * @param  steps 在多大的区域中渐变(次数)
         * @return null 返回渐变颜色数组
         */
        M.generateTransitionalColor = function (color1, color2, steps) {
            if (steps === 1) {
                return [color1];
            }
            else if (steps === 2) {
                return [color1, color2];
            }
            var color1RGB = M.retrieveRGBComponent(color1);
            var color2RGB = M.retrieveRGBComponent(color2);
            var colors = [];
            colors.push(color1);
            steps = steps - 2;
            var redDiff = color2RGB[0] - color1RGB[0];
            var greenDiff = color2RGB[1] - color1RGB[1];
            var blueDiff = color2RGB[2] - color1RGB[2];
            for (var i = 1; i < steps - 1; i++) {
                var tmpRGB = [
                    color1RGB[0] + redDiff * i / steps,
                    color1RGB[1] + greenDiff * i / steps,
                    color1RGB[2] + blueDiff * i / steps
                ];
                colors.push(M.generateFromRGBComponent(tmpRGB));
            }
            colors.push(color2);
            return colors;
        };
        /**
         * 画弧/扇形
         * @param g  PIXI.Graphics
         * @param x  圆心X
         * @param y  圆心Y
         * @param r  圆心半径
         * @param angle 圆心角
         * @param angleOfSlope起始点与最右端(X轴)的角度差 (默认为从最右端开始)
         */
        M.drawArc = function (g, x, y, r, angle, angleOfSlope) {
            /*
             g.beginFill(0xFF0000, 0.8);
             // g.lineStyle(1,0xFF0000)
             M.drawArc(g, 0, 0, 100, 270);
             g.endFill();
             */
            var newDot = [x, y];
            if (!angleOfSlope) {
                angleOfSlope = 0;
            }
            var aos = angleOfSlope * Math.PI / 180;
            var aos2 = (angleOfSlope + angle) * Math.PI / 180;
            var pstart = [newDot[0] + r * Math.cos(aos), newDot[1] + r * Math.sin(aos)]; //弧线的起点
            g.moveTo(pstart[0], pstart[1]);
            var pend = [newDot[0] + r * Math.cos(aos2), newDot[1] + r * Math.sin(aos2)]; //弧线的终点
            var pre = pstart;
            for (var i = 0; i < angle; i += 2) { //在angle范围内画弧
                var rad = (i + angleOfSlope) * Math.PI / 180;
                var cur = [r * Math.cos(rad) + newDot[0], r * Math.sin(rad) + newDot[1]];
                //
                g.moveTo(pre[0], pre[1]);
                g.lineTo(cur[0], cur[1]);
                if (g.filling) {
                    g.lineTo(newDot[0], newDot[1]);
                    g.lineTo(pre[0], pre[1]);
                }
                pre = cur;
            }
            g.lineTo(pend[0], pend[1]);
            if (g.filling) {
                g.lineTo(newDot[0], newDot[1]);
                g.lineTo(pre[0], pre[1]);
            }
        };
        /**
         * 返回弧线路径点
         * @param x
         * @param y
         * @param r
         * @param angle  弧度
         * @param angleOfSlope 弧度
         * @returns {Array}
         */
        M.getArcPoints = function (x, y, r, angle, angleOfSlope) {
            angle = M.toAngle(angle);
            angleOfSlope = M.toAngle(angleOfSlope);
            var pArr = [];
            var newDot = [x, y];
            if (!angleOfSlope) {
                angleOfSlope = 0;
            }
            var aos = angleOfSlope * Math.PI / 180;
            var pstart = [newDot[0] + r * Math.cos(aos), newDot[1] + r * Math.sin(aos)]; //弧线的起点
            pArr.push(new Point(pstart[0], pstart[1]));
            for (var i = 0; i < angle; i += 1) { //在angle范围内画弧
                var rad = (i + angleOfSlope) * Math.PI / 180;
                var cur = [r * Math.cos(rad) + newDot[0], r * Math.sin(rad) + newDot[1]];
                //
                pArr.push(new Point(cur[0], cur[1]));
            }
            return pArr;
        };
        /**
         * ==>判断一个点是否是落在一个封闭多边形形中<br>
         * 算法:
         *  把该点与多边形的各个顶点连接，相邻的连线所产生的夹角:<br>
         *      1、若没有一个等于180°且它们的和为360°，那么点就在多边形内;<br>
         *      2、若有一个等于180°，那点就在多边形边上;<br>
         *      3、若它们的和不为360°，那么点就在多边形外;<br>
         *  (返回: 1在内,2在边上,3在外)
         * @param p_ Point
         * @param pArr_ [Point]
         * @return null 返回: 1在内,2在边上,3在外;
         *
         */
        M.checkPolygonPointArr = function (p_, pArr_) {
            return this.checkPolygonPointArr3(p_, pArr_);
            // let reNum_ = 0;
            // // 多边形内角和、一个内角等允许的差值
            // let chaAngleNum_ = .2;
            // // 多边形内角和
            // let allAngle = 0;
            // // 其中的一个内角
            // let oneAngle_;
            // // 是否有一个角为180度
            // let has180_ = false;
            // // 遍历每一个相连的内角
            // for (let i = 0; i < pArr_.length; i++) {
            //     let p1_;
            //     let p2_;
            //     if (i === pArr_.length - 1) {
            //         p1_ = pArr_[i];
            //         p2_ = pArr_[0];
            //     }
            //     else {
            //         // 为中间的点
            //         p1_ = pArr_[i];
            //         p2_ = pArr_[i + 1];
            //     }
            //     //
            //     oneAngle_ = M.getAngleByP(p_, p1_, p2_);
            //     if (Math.abs(oneAngle_ - 180) < chaAngleNum_) {
            //         has180_ = true;
            //     }
            //     allAngle += oneAngle_;
            // }
            // //
            // if (has180_) {
            //     // 若有一个等于180°，那点就在多边形边上
            //     reNum_ = 2;
            // }
            // else if (!has180_ && Math.abs(allAngle - 360) < chaAngleNum_) {
            //     reNum_ = 1;
            // }
            // else if (Math.abs(allAngle - 360) > chaAngleNum_) {
            //     // 若它们的和不为360°，那么点就在多边形外;
            //     reNum_ = 3;
            // }
            // //
            // return reNum_;
        };
        /**
         * 返回pointArr的副本(内部点均为原点的副本)
         * @param pointArr
         * @return null
         *
         */
        M.clonePointArr = function (pointArr) {
            if (!pointArr) {
                return null;
            }
            var arr = [];
            for (var i = 0; i < pointArr.length; i++) {
                var p_ = pointArr[i];
                arr.push(new Point(p_.x, p_.y));
            }
            return arr;
        };
        /**
         * 比较两个闭合多边形是否相等
         * @param pointArr1 第一个多边形
         * @param pointArr2 第二个多边形
         * @param checkDis 两个点默认相等的有效距离
         * @return null
         *
         */
        M.checkArrEqual = function (pointArr1, pointArr2, checkDis) {
            if (checkDis === undefined) {
                checkDis = 5;
            }
            pointArr1 = M.clonePointArr(pointArr1);
            pointArr2 = M.clonePointArr(pointArr2);
            //
            var cen1 = M.getRectCen(M.getPArrRect(pointArr1));
            var cen2 = M.getRectCen(M.getPArrRect(pointArr2));
            // 将pointArr1移动到pointArr2
            var chaX = cen2.x - cen1.x;
            var chaY = cen2.y - cen1.y;
            var i;
            var j;
            for (i = 0; i < pointArr1.length; i++) {
                var p_ = pointArr1[i];
                p_.x += chaX;
                p_.y += chaY;
            }
            // 进行比较
            for (i = 0; i < pointArr1.length; i++) {
                var p1 = pointArr1[i];
                var boo_ = false;
                for (j = 0; j < pointArr2.length; j++) {
                    var p2 = pointArr2[j];
                    if (M.getPointLen(p1, p2) <= checkDis) {
                        boo_ = true;
                        break;
                    }
                }
                if (!boo_) {
                    return false;
                }
            }
            return {
                chaX: chaX,
                chaY: chaY
            };
        };
        /**
         * 比较两个点是否相等
         * @param p1_
         * @param p1_
         * @param checkDis
         * @return null
         *
         */
        M.checkPointEqual = function (p1_, p2_, checkDis) {
            if (checkDis === undefined) {
                checkDis = 0.1;
            }
            if (M.getPointLen(p1_, p2_) < checkDis) {
                return true;
            }
            return false;
        };
        /**
         * 点p是否在多边形polygon内部--(点在所有直线同侧判断法, 包括在多边形边上的点, 准确)
         * 如果判断点在所有边界线的同侧，就能判定该点在多边形内部。
         * 判断方法就是判断两条同起点射线斜率差。
         * @param p    Point
         * @param polygon  [Point]
         * @return null
         *
         */
        M.checkPolygonPointArr2 = function (p, polygon) {
            return this.checkPolygonPointArr3(p, polygon);
            // let inside = false;
            // let count1 = 0;
            // let count2 = 0;
            // let N = polygon.length;
            // let i = 0;
            // let j = N - 1;
            // for (; i < N; j = i++) {
            //     let value = (p.x - polygon[j].x) * (polygon[i].y - polygon[j].y) - (p.y - polygon[j].y) * (polygon[i].x - polygon[j].x);
            //     if (value > 0)
            //         ++count1;
            //     else if (value < 0)
            //         ++count2;
            // }
            // if (0 === count1 || 0 === count2) {
            //     inside = true;
            // }
            // return inside;
        };
        /**
         * 绘制多边形
         * @param g   PIXI.Graphics
         * @param pArr    [Point]
         */
        M.drawPolygonPArr = function (g, pArr) {
            g.moveTo(pArr[0].x, pArr[0].y);
            $.each(pArr, function (i, item) {
                if (i > 0) {
                    g.lineTo(pArr[i].x, pArr[i].y);
                }
            });
            g.lineTo(pArr[0].x, pArr[0].y);
        };
        /**
         * 将Vec3转为Vec2
         * @param vec
         */
        M.vec3ToVec2 = function (vec) {
            var nape = window.nape;
            return nape.geom.Vec2.get(vec.zpp_inner.x, vec.zpp_inner.y);
        };
        /**
         * 得到直线与多边形的交点
         * @param p1_ 直线的一端
         * @param p2_ 直线的另一端
         * @param pArr1_ 多边形
         * @return null
         */
        M.getJiao_polygon_line = function (p1_, p2_, pArr1_) {
            var rePArr = [];
            for (var i = 0; i < pArr1_.length; i++) {
                // 多边形的每一条边
                var pp1_ = pArr1_[i];
                var pp2_ = i === pArr1_.length - 1 ? pArr1_[0] : pArr1_[i + 1];
                // 计算是否平行, 平行没有交点
                if (M.isPingxing(pp1_, pp2_, p1_, p2_)) {
                    continue;
                }
                // 计算交点
                var jiaoP_ = M.getJiaoP(p1_, p2_, pp1_, pp2_);
                // 交点是否在多边形边上
                if (M.checkInLineAB(jiaoP_, pp1_, pp2_, 0.1)) {
                    rePArr.push(jiaoP_);
                }
            }
            return rePArr;
        };
        /**
         * 点集合pArr_是否包含点p_
         * @param pArr_
         * @param p_
         * @param checkNum
         * @return null
         *
         */
        M.containtsP = function (pArr_, p_, checkNum) {
            if (checkNum === undefined) {
                checkNum = 0.1;
            }
            var boo_ = false;
            for (var i = 0; i < pArr_.length; i++) {
                var cp_ = pArr_[i];
                if (M.getPointLen(cp_, p_) < checkNum) {
                    boo_ = true;
                    break;
                }
            }
            return boo_;
        };
        /**
         * 找出pArr_中距离 p_ 最近的点
         * @param pArr_
         * @param p_
         * @return null
         *
         */
        M.getNearP = function (pArr_, p_) {
            var nearLen_ = 100000;
            var nearP_;
            var i;
            for (i = 0; i < pArr_.length; i++) {
                var cp_ = pArr_[i];
                var cLen_ = M.getPointLen(p_, cp_);
                if (cLen_ < nearLen_) {
                    nearLen_ = cLen_;
                    nearP_ = cp_;
                }
            }
            return nearP_;
        };
        M.checkPolygonPointArr3 = function (p, vertexList) {
            if (vertexList === null)
                return false;
            var n = vertexList.length;
            var i = 0;
            var p1;
            var p2;
            var counter = 0;
            var xinters = 0;
            p1 = vertexList[0];
            for (i = 1; i <= n; i++) {
                p2 = vertexList[i % n];
                if (p.y > Math.min(p1.y, p2.y)) {
                    if (p.y <= Math.max(p1.y, p2.y)) {
                        if (p.x <= Math.max(p1.x, p2.x)) {
                            if (p1.y !== p2.y) {
                                xinters = (p.y - p1.y) * (p2.x - p1.x) / (p2.y - p1.y) + p1.x;
                                if (p1.x === p2.x || p.x <= xinters)
                                    counter++;
                            }
                        }
                    }
                }
                p1 = p2;
            }
            return counter % 2 !== 0;
        };
        /**
         * 绕中心点旋转
         *
         * @param   mc  元件
         * @param   angle   角度
         */
        M.centerRotate = function (mc, angle) {
            var currentRotation = mc.rotation;
            //获取mc不旋转时候的尺寸
            mc.rotation = 0;
            var mcWidth = mc.width;
            var mcHeight = mc.height;
            mc.rotation = currentRotation;
            //获取mc当前中心点坐标
            var pointO = mc.localToGlobal(new Point(mcWidth / 2, mcHeight / 2));
            //旋转mc
            mc.rotation = angle;
            //获取mc旋转后中心点坐标
            var pointO2 = mc.localToGlobal(new Point(mcWidth / 2, mcHeight / 2));
            //平移到原来中心点O
            var p3 = pointO.subtract(pointO2);
            var matrix = mc.transform.matrix;
            matrix.translate(p3.x, p3.y);
            mc.transform.matrix = matrix;
        };
        /**
         * 返回 sp_ 的所有子元件
         * @param sp_
         * @return null
         *
         */
        M.getAllChildren = function (sp_) {
            if (!sp_) {
                return null;
            }
            var spArr_ = [];
            for (var i = 0; i < sp_.numChildren; i++) {
                spArr_.push(sp_.getChildAt(i));
            }
            return spArr_;
        };
        /**
         * 返回函数名称
         * 在要调查的函数内部执行此函数
      
         * @return null
         */
        M.getFnName = function (callee) {
            var _callee = callee.toString().replace(/[\s\?]*/g, ""), comb = _callee.length >= 50 ? 50 : _callee.length;
            _callee = _callee.substring(0, comb);
            var name = _callee.match(/^function([^\(]+?)\(/);
            if (name && name[1]) {
                return name[1];
            }
            var caller = callee.caller, _caller = caller.toString().replace(/[\s\?]*/g, "");
            var last = _caller.indexOf(_callee), str = _caller.substring(last - 30, last);
            name = str.match(/([^\=]+?)\=/);
            if (name && name[1]) {
                return name[1];
            }
            return "anonymous";
        };
        /**
         * 由于touch分鼠标和触屏两种
         * @param value {String} 要判断的值
         * @param type {String} 是否为某种类型
         * @returns {boolean}
         * @example M.touchIsType(evt.type, TouchEvent.TOUCH_BEGIN))
         */
        M.touchIsType = function (value, type) {
            if (value === type)
                return true;
            var boo = false;
            switch (type) {
                case TouchEvent.TOUCH_BEGIN:
                    boo = value === "touchstart";
                    break;
                case TouchEvent.TOUCH_MOVE:
                    boo = value === "touchmove";
                    break;
                case TouchEvent.TOUCH_END:
                    boo = value === "touchend";
                    break;
                case TouchEvent.TOUCH_END_OUDSIDE:
                    boo = value === "touchendoutside";
                    break;
                case TouchEvent.TAP:
                    boo = value === "tap";
                    break;
            }
            return boo;
        };
        /******************************************
         *      阻止dom标签(如canvas)接受事件
         * ****************************************/
        M.addDenyDB = function (mc_) {
            ArrayUtil.addSingleArr(M.__bdArr, mc_);
        };
        M.removeDenyDB = function (mc_) {
            ArrayUtil.removeValueFromArray(M.__bdArr, mc_);
        };
        M._checkIsDBMC = function (mc_) {
            return ArrayUtil.arrayContainsValue(M.__bdArr, mc_);
        };
        /******************************************
         *      Dom点击工具(超过一定的距离则失效)
         * ****************************************/
        /**
         *
         * @param mc   jquery 对象
         * @param funcObj    move2:非按下也可触发
         * @param this_
         * @param outData_
         * @deprecated 修改为TouchUtil.addTouch
         * @returns {string}
         */
        M.addDomTouch = function (mc, funcObj, this_, outData_) {
            if (!mc || !funcObj)
                return;
            var funcID = "_M" + M.getUnique() + "_";
            funcObj.mc = mc;
            funcObj.this = this_;
            mc[funcID] = funcObj;
            mc[funcID].downTime = new Date().getTime();
            mc[funcID].downP = new Point();
            mc.$document = $(document);
            if (mc[0]) {
                mc[0][funcID] = mc[funcID];
            }
            if (!outData_) {
                outData_ = {
                    time: 500,
                    dis: 15
                };
            }
            if (outData_) {
                funcObj.outData = outData_;
                funcObj.outData.canTab = true;
            }
            if (funcObj.tab) {
                mc[funcID + "touchTab"] = function (evt) {
                    evt.t = "tab";
                    if (!this[funcID]) {
                        return;
                    }
                    if (this[funcID].this) {
                        this[funcID].tab.call(this[funcID].this, evt, this);
                    }
                    else {
                        this[funcID].tab.call(this, evt, this);
                    }
                };
                mc.on("click." + funcID + " touchend.tab" + funcID, mc[funcID + "touchTab"]);
            }
            // touchstart直接加上
            mc[funcID + "touchStart"] = function (evt) {
                if (!this[funcID]) {
                    return;
                }
                this.$document.on("mousemove." + funcID + " touchmove." + funcID, this[funcID + "touchMove"]);
                evt.t = "begin";
                this._isDown = true;
                var charTime_;
                var charLen_;
                var isSend_dbtab = false;
                if (M._checkIsDBMC(this)) {
                    M.__isDenyDB = true;
                }
                if (this[funcID].dbtab) {
                    charTime_ = new Date().getTime() - this[funcID].downTime;
                    charLen_ = Math.abs(M.getPointLen(this[funcID].downP, M.getCanvasP(evt)));
                    //
                    if (charTime_ < 300 && charLen_ < 50) {
                        // 双击
                        isSend_dbtab = true;
                        if (this[funcID].this) {
                            this[funcID].dbtab.call(this[funcID].this, evt, this);
                        }
                        else {
                            this[funcID].dbtab.call(this, evt, this);
                        }
                    }
                }
                this[funcID].downTime = new Date().getTime();
                this[funcID].downP = M.getSPPoint(M.getMouseXY(evt));
                if (!isSend_dbtab && this[funcID].begin) {
                    if (!this[funcID].isAddDB || (this[funcID].isAddDB && !M.__isDenyDB)) {
                        if (this[funcID].this) {
                            this[funcID].begin.call(this[funcID].this, evt, this);
                        }
                        else {
                            this[funcID].begin.call(this, evt, this);
                        }
                    }
                }
            }.bind(mc);
            // touchMove 直接加上
            mc[funcID + "touchMove"] = function (evt) {
                if (!this._isDown)
                    return;
                evt.t = "move";
                //
                if (!this[funcID]) {
                    return;
                }
                if (M._checkIsDBMC(this)) {
                    M.__isDenyDB = true;
                }
                if (this[funcID]) {
                    evt.outData = this[funcID].outData;
                    if (this[funcID].outData) {
                        var charDis = Math.abs(M.getPointLen(this[funcID].downP, M.getMouseXY(evt)));
                        if (this[funcID].outData.dis && charDis > this[funcID].outData.dis) {
                            this[funcID].outData.canTab = false;
                        }
                    }
                }
                if (this._isDown) {
                    if (this[funcID] && this[funcID].move) {
                        if (!this[funcID].isAddDB || (this[funcID].isAddDB && !M.__isDenyDB)) {
                            if (this[funcID].this) {
                                this[funcID].move.call(this[funcID].this, evt, this);
                            }
                            else {
                                this[funcID].move.call(this, evt, this);
                            }
                        }
                    }
                }
                if (this[funcID] && this[funcID].move2) {
                    if (!this[funcID].isAddDB || (this[funcID].isAddDB && !M.__isDenyDB)) {
                        if (this[funcID].this) {
                            this[funcID].move2.call(this[funcID].this, evt, this);
                        }
                        else {
                            this[funcID].move2.call(this, evt, this);
                        }
                    }
                }
            }.bind(mc);
            //
            mc[funcID + "touchEnd"] = function (evt) {
                evt.t = "end";
                if (!this[funcID]) {
                    return;
                }
                this.$document.off("mousemove." + funcID, this[funcID + "touchMove"]);
                this.$document.off("touchmove." + funcID, this[funcID + "touchMove"]);
                this._isDown = false;
                if (funcObj.end) {
                    if (!this[funcID].isAddDB || (this[funcID].isAddDB && !M.__isDenyDB)) {
                        if (this[funcID].this) {
                            this[funcID].end.call(this[funcID].this, evt, this);
                        }
                        else {
                            this[funcID].end.call(this, evt, this);
                        }
                    }
                }
                // 解除阻值
                if (this[funcID] && this[funcID].isAddDB && M.__isDenyDB) {
                    M.__isDenyDB = false;
                }
            }.bind(mc);
            //
            mc.on("mousedown." + funcID + " touchstart." + funcID, mc[funcID + "touchStart"]);
            mc.on("mouseup." + funcID + " touchend." + funcID, mc[funcID + "touchEnd"]);
            return funcID;
        };
        M.removeDomTouch = function (mc, funcID) {
            if (!mc || !funcID)
                return;
            if (mc[funcID + "touchTab"]) {
                mc.off("click." + funcID + " touchend.tab" + funcID, mc[funcID + "touchTab"]);
                delete mc[funcID + "touchTab"];
            }
            //
            mc.off("mousedown." + funcID + " touchstart." + funcID, mc[funcID + "touchStart"]);
            if (mc.$document)
                mc.$document.off("mousemove." + funcID + " touchmove." + funcID, mc[funcID + "touchMove"]);
            mc.off("mouseup." + funcID + " touchend." + funcID, mc[funcID + "touchEnd"]);
            delete mc[funcID + "touchStart"];
            delete mc[funcID + "touchMove"];
            delete mc[funcID + "touchEnd"];
            //
            if (mc[funcID]) {
                delete mc[funcID];
            }
        };
        /******************************************
         *      SVG点击工具(超过一定的距离则失效)  {time:毫秒, dis:XXX}
         * ****************************************/
        M.addSVGTouch = function (mc, funcObj, this_, outData_) {
            if (!mc)
                return;
            if (!funcObj)
                return;
            var funcID = "_MSVG" + M.getUnique() + "_";
            this_ = this_ === undefined ? mc : this_;
            funcObj.this = this_;
            funcObj.mc = mc;
            mc.data(funcID, funcObj);
            mc.data("funcID", funcID);
            //
            if (!outData_) {
                outData_ = {
                    time: 300,
                    dis: 15
                };
            }
            if (outData_) {
                funcObj.outData = outData_;
                funcObj.outData.canTab = true;
            }
            ///////////////////////////////////
            funcObj._svg_tabFunc = function (evt) {
                // this为mc, this.data(funcID) 为 funcObj
                var funcID_ = this.data("funcID");
                var funcObj_ = this.data(funcID_);
                evt.t = "tab";
                evt.mc = this;
                funcObj_.tab.call(funcObj_.this, evt);
            };
            //
            funcObj._svg_beginFunc = function (evt) {
                // this.data(funcID) 为 funcObj
                var funcID_ = this.data("funcID");
                this._isDown = true;
                var funcObj_ = this.data(funcID_);
                evt.t = "begin";
                evt.mc = this;
                funcObj_.begin.call(funcObj_.this, evt);
            };
            funcObj._svg_moveFunc = function (evt) {
                if (this._isDown) {
                    var funcID_ = this.data("funcID");
                    var funcObj_ = this.data(funcID_);
                    evt.t = "move";
                    evt.mc = this;
                    funcObj_.move.call(funcObj_.this, evt);
                }
            };
            funcObj._svg_endFunc = function (evt) {
                var funcID_ = this.data("funcID");
                var funcObj_ = this.data(funcID_);
                this._isDown = false;
                evt.t = "end";
                evt.mc = this;
                funcObj_.end.call(funcObj_.this, evt);
            };
            ///////////////////////////////////
            if (funcObj.tab) {
                mc.click(funcObj._svg_tabFunc);
            }
            var isMobile = M.isMobileBrowser();
            if (isMobile) {
                if (funcObj.begin) {
                    mc.touchstart(funcObj._svg_beginFunc);
                }
                if (funcObj.move) {
                    mc.touchmove(funcObj._svg_moveFunc);
                }
                if (funcObj.end) {
                    mc.touchend(funcObj._svg_endFunc);
                }
            }
            else {
                if (funcObj.begin) {
                    mc.mousedown(funcObj._svg_beginFunc);
                }
                if (funcObj.move) {
                    mc.mousemove(funcObj._svg_moveFunc);
                }
                if (funcObj.end) {
                    mc.mouseup(funcObj._svg_endFunc);
                }
            }
            ///////////////
            return funcID;
        };
        M.isMobileBrowser = function () {
            var isMobile = false;
            if (navigator) {
                var userAgent = navigator.userAgent;
                isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent));
            }
            return isMobile;
        };
        M.removeSVGTouch = function (mc, funcID) {
            if (!mc || !funcID)
                return;
            var funcObj = mc.data(funcID);
            if (funcObj.tab) {
                mc.unclick(funcObj._svg_tabFunc);
            }
            if (funcObj.begin) {
                mc.untouchstart(funcObj._svg_beginFunc);
                mc.unmousedown(funcObj._svg_beginFunc);
            }
            if (funcObj.move) {
                mc.untouchmove(funcObj._svg_moveFunc);
                mc.unmousemove(funcObj._svg_moveFunc);
            }
            if (funcObj.end) {
                mc.untouchend(funcObj._svg_endFunc);
                mc.unmouseup(funcObj._svg_endFunc);
            }
            mc.data(funcID, null);
        };
        /******************************************
         *      PIXI点击工具(超过一定的距离则失效)
         * ****************************************/
        /**
         *
         * @param mc
         * @param funcObj     isAddDB:为true则代表canvas,需要添加双份响应
         * @param this_  作用域,不写则为元件mc自己
         * @param outData_ 时长限制与距离限制(超过多长时间失效于超出多长距离失效)
         * @param useCapture
         * @return null 添加的响应的ID(删除时需要此ID)
         * @example M.addTouch(target, {tab:XXX, begin:XXX, move:按下移动, end:XXX, globalMove:全局移动, dbtab:双击}, this, {time:300, dis:15});
         */
        M.addTouch = function (mc, funcObj, this_, outData_, useCapture) {
            if (useCapture === void 0) { useCapture = false; }
            // funcObj:  {tab:XXX, begin:XXX, move:XXX, end:XXX}
            // outData_: {time:毫秒, dis:XXX}
            if (!funcObj) {
                return;
            }
            var funcID = "_M" + M.getUnique() + "_";
            funcObj.mc = mc;
            funcObj.this = this_;
            mc[funcID] = funcObj;
            mc[funcID].downTime = new Date().getTime();
            mc[funcID].downP = new Point();
            if (!outData_) {
                outData_ = {
                    time: 300,
                    dis: 15
                };
            }
            if (outData_) {
                funcObj.outData = outData_;
                funcObj.outData.canTab = true;
            }
            if (funcObj.tab) {
                mc[funcID + "touchTab"] = function (evt) {
                    evt.t = "tab";
                    if (!this[funcID]) {
                        return;
                    }
                    if (this[funcID].outData) {
                        var charTime = new Date().getTime() - this[funcID].downTime;
                        if (this[funcID].outData.time > 0 && this[funcID].outData.time && charTime > this[funcID].outData.time) {
                            this[funcID].outData.canTab = false;
                        }
                    }
                    //
                    if (!this[funcID].outData || (this[funcID].outData && this[funcID].outData.canTab)) {
                        if (this[funcID].this) {
                            this[funcID].tab.call(this[funcID].this, evt, this);
                        }
                        else {
                            this[funcID].tab.call(this, evt, this);
                        }
                    }
                    if (this[funcID] && this[funcID].outData) {
                        this[funcID].outData.canTab = true;
                        this[funcID].outData.downP = M.getSPPoint(M.getMouseXY(evt));
                    }
                };
                mc.addEventListener(TouchEvent.TOUCH_END, mc[funcID + "touchTab"], useCapture);
                mc.addEventListener(TouchEvent.TOUCH_END_OUTSIDE, mc[funcID + "touchTab"], useCapture);
            }
            // touchstart直接加上
            mc[funcID + "touchStart"] = function (evt) {
                evt.t = "begin";
                this._isDown = true;
                var charTime_;
                var charLen_;
                var isSend_dbtab = false;
                if (M._checkIsDBMC(this)) {
                    M.__isDenyDB = true;
                }
                if (this[funcID].dbtab) {
                    charTime_ = new Date().getTime() - this[funcID].downTime;
                    charLen_ = Math.abs(M.getPointLen(this[funcID].downP, M.getMouseXY(evt)));
                    //
                    if (charTime_ < 300 && charLen_ < 50) {
                        // 双击
                        isSend_dbtab = true;
                        if (this[funcID].this) {
                            this[funcID].dbtab.call(this[funcID].this, evt, this);
                        }
                        else {
                            this[funcID].dbtab.call(this, evt, this);
                        }
                    }
                }
                this[funcID].downTime = new Date().getTime();
                this[funcID].downP = M.getSPPoint(M.getMouseXY(evt));
                if (!isSend_dbtab && this[funcID].begin) {
                    if (this[funcID].this) {
                        this[funcID].begin.call(this[funcID].this, evt, this);
                    }
                    else {
                        this[funcID].begin.call(this, evt, this);
                    }
                }
            };
            mc.addEventListener(TouchEvent.TOUCH_BEGIN, mc[funcID + "touchStart"], useCapture);
            // touchMove 直接加上
            mc[funcID + "touchMove"] = function (evt) {
                evt.t = "move";
                // 全局移动监控
                if (this[funcID].globalMove) {
                    if (this[funcID].this) {
                        this[funcID].globalMove.call(this[funcID].this, evt, this);
                    }
                    else {
                        this[funcID].globalMove.call(this, evt, this);
                    }
                }
                if (this._isDown) {
                    if (M._checkIsDBMC(this)) {
                        M.__isDenyDB = true;
                    }
                    evt.outData = this[funcID].outData;
                    if (this[funcID].outData) {
                        var charDis = Math.abs(M.getPointLen(this[funcID].downP, M.getMouseXY(evt)));
                        if (this[funcID].outData.dis && charDis > this[funcID].outData.dis) {
                            this[funcID].outData.canTab = false;
                        }
                    }
                    if (this[funcID].move) {
                        if (this[funcID].this) {
                            this[funcID].move.call(this[funcID].this, evt, this);
                        }
                        else {
                            this[funcID].move.call(this, evt, this);
                        }
                    }
                }
            };
            mc.addEventListener(TouchEvent.TOUCH_MOVE, mc[funcID + "touchMove"], useCapture);
            mc[funcID + "touchEnd"] = function (evt) {
                evt.t = "end";
                this._isDown = false;
                if (funcObj.end) {
                    if (this[funcID].this) {
                        this[funcID].end.call(this[funcID].this, evt, this);
                    }
                    else {
                        this[funcID].end.call(this, evt, this);
                    }
                }
            };
            mc.addEventListener(TouchEvent.TOUCH_END, mc[funcID + "touchEnd"], useCapture);
            mc.addEventListener(TouchEvent.TOUCH_END_OUTSIDE, mc[funcID + "touchEnd"], useCapture);
            return funcID;
        };
        M.removeTouch = function (mc, funcID) {
            if (!mc || !funcID)
                return;
            if (mc[funcID]) {
                var funcObj = mc[funcID];
                for (var _i = 0, _a = Object.keys(funcObj); _i < _a.length; _i++) {
                    var t = _a[_i];
                    funcObj[t] = null;
                }
            }
            delete mc[funcID];
            if (mc[funcID + "touchTab"]) {
                mc.removeEventListener(TouchEvent.TOUCH_END, mc[funcID + "touchTab"]);
                mc.removeEventListener(TouchEvent.TOUCH_END_OUTSIDE, mc[funcID + "touchTab"]);
                delete mc[funcID + "touchTab"];
            }
            // touchstart直接删除
            mc.removeEventListener(TouchEvent.TOUCH_BEGIN, mc[funcID + "touchStart"]);
            delete mc[funcID + "touchStart"];
            // touchMove直接删除
            mc.removeEventListener(TouchEvent.TOUCH_MOVE, mc[funcID + "touchMove"]);
            delete mc[funcID + "touchMove"];
            //
            if (mc[funcID + "touchEnd"]) {
                mc.removeEventListener(TouchEvent.TOUCH_END, mc[funcID + "touchEnd"]);
                mc.removeEventListener(TouchEvent.TOUCH_END_OUTSIDE, mc[funcID + "touchEnd"]);
                delete mc[funcID + "touchEnd"];
            }
            if (mc[funcID]) {
                mc[funcID].this = null;
            }
        };
        /**
         *nape中Vec2 没有length属性
         * @param v 所求长度的Vec2
         * @returns {number}
         */
        M.vec2Length = function (v) {
            return Math.sqrt(v.get_x() * v.get_x() + v.get_y() * v.get_y());
        };
        /**
         * Vec3 的长度
         * @param v
         * @returns {number}
         */
        M.vec3Length = function (v) {
            return Math.sqrt(v.zpp_inner.x * v.zpp_inner.x + v.zpp_inner.y * v.zpp_inner.y + v.zpp_inner.z * v.zpp_inner.z);
        };
        /**
         * 获取过点pStart 射入pEnd的射线长度为len的点
         */
        M.getRayPoint = function (pStart, pEnd, len) {
            var p = Point.interpolate(pEnd, pStart, 1 / Point.distance(pStart, pEnd));
            return new Point(pStart.x + (p.x - pStart.x) * len, pStart.y + (p.y - pStart.y) * len);
        };
        /**
         * 添加拖拽
         * @param mc
         * @param mcRect Rectangle,相对于mc的parent, 为空则不限制
         * @param funcObj
         * @return null
         * @example funcObj触发函数: {tab:XXX, begin:XXX, move:XXX, end:XXX, dbtab:双击, isLock:false}
         *   outData_:{time:毫秒, dis:XXX}
         *   isLock: 临时锁定(拖拽失效)
         *   mc.getMScale() {
            return AppStr.main.view.scale;
      
        }
         */
        M.addDrag = function (mc, mcRect, funcObj, _this, outData_) {
            if (!_this) {
                _this = mc;
            }
            if (mcRect && funcObj.dragRectEnable === undefined) {
                funcObj.dragRectEnable = mcRect && mcRect.width >= 0 && mcRect.height >= 0;
            }
            var toLocal;
            if (funcObj.toLocal) {
                toLocal = function (p) {
                    return mc.parent.toLocal(p);
                };
            }
            else {
                toLocal = function (p) {
                    return p;
                };
            }
            //
            var funcID = M.addTouch(mc, {
                begin: function (evt) {
                    mc[funcID + "_dragData"].isDown = true;
                    M.setSPPoint(mc[funcID + "_dragData"].p, toLocal(M.getMouseXY(evt)));
                    if (funcObj && funcObj.begin) {
                        funcObj.begin.call(_this, evt);
                    }
                },
                move: function (evt) {
                    if (mc[funcID + "_dragData"].isDown) {
                        var chaX = toLocal(M.getMouseXY(evt)).x - mc[funcID + "_dragData"].p.x;
                        var chaY = toLocal(M.getMouseXY(evt)).y - mc[funcID + "_dragData"].p.y;
                        if (mc.getMScale) { // 缩放值函数
                            var scaleM = mc.getMScale();
                            chaX /= scaleM.x;
                            chaY /= scaleM.y;
                        }
                        //
                        var toX = mc.x + chaX;
                        var toY = mc.y + chaY;
                        if (funcObj && funcObj.dragRectEnable) {
                            var toX2 = M.range(toX, mcRect.x, mcRect.x + mcRect.width);
                            chaX -= (toX - toX2);
                            toX = toX2;
                            var toY2 = M.range(toY, mcRect.y, mcRect.y + mcRect.height);
                            chaY -= toY - toY2;
                            toY = toY2;
                        }
                        if (!funcObj.isLock && (mc.x !== toX || mc.y !== toY)) {
                            if (!funcObj.notSetPoint)
                                M.setSPPointXY(mc, toX, toY);
                            M.setSPPoint(mc[funcID + "_dragData"].p, toLocal(M.getMouseXY(evt)));
                            if (funcObj && funcObj.move) {
                                evt.chaX = chaX;
                                evt.chaY = chaY;
                                evt.toX = toX;
                                evt.toY = toY;
                                funcObj.move.call(_this, evt);
                            }
                        }
                    }
                },
                end: function (evt) {
                    mc[funcID + "_dragData"].isDown = false;
                    if (funcObj && funcObj.end) {
                        funcObj.end.call(_this, evt);
                    }
                },
                tab: function (evt) {
                    if (funcObj && funcObj.tab) {
                        funcObj.tab.call(_this, evt);
                    }
                },
                dbtab: function (evt) {
                    if (funcObj && funcObj.dbtab) {
                        funcObj.dbtab.call(_this, evt);
                    }
                }
            }, _this, outData_);
            mc[funcID + "_dragData"] = { p: new Point(0, 0) };
            return funcID;
        };
        /**
         * 删除拖拽
         * @param mc
         * @param funcID
         */
        M.removeDrag = function (mc, funcID) {
            delete mc[funcID + "_dragData"];
            M.removeTouch(mc, funcID);
        };
        /**
         * 将2帧的MovieClip设置为按钮(按下第为2帧,弹起为第1帧)
         * @param mc 2帧的MovieClip
         * @param clickFunc
         * @param _this 作用域(不传则作用域this为当前按钮mc)
         * @example  M.setButton(this.addBtn, this.clickHandle, this);
         */
        M.setButton = function (mc, clickFunc, _this) {
            if (!mc.totalFrames) {
                throw new Error("it is not MovieClip");
            }
            if (mc.totalFrames !== 2) {
                throw new Error("totalFrames is not equals 2");
            }
            mc.____setButton_touchID = M.addTouch(mc, {
                begin: function (evt) {
                    this.currentFrame = 1;
                },
                end: function (evt) {
                    this.currentFrame = 0;
                },
                tab: function (evt) {
                    if (clickFunc) {
                        if (_this) {
                            clickFunc.call(_this, { target: this });
                        }
                        else {
                            clickFunc.call(this, { target: this });
                        }
                    }
                }
            }, null, { time: -1 });
        };
        M.removeButton = function (mc) {
            if (!mc)
                return;
            M.removeTouch(mc, mc.____setButton_touchID);
        };
        /**
         * 横向 toggle 按钮(滑到右侧代表true)
         * 先加点击以后再加拖动
         * @param mc
         * @param data_
         * @param _this
         * @example data_数据:{w:XXX, toggle:XXX, toggled:false}
         */
        M.setToggle = function (mc, data_, _this) {
            mc.data = data_;
            mc.data.target = mc;
            var this_ = _this ? _this : mc;
            if (mc.toggled) {
                mc.x += mc.data.w;
            }
            M.addTouch(mc, {
                tab: function (evt) {
                    mc.data.toggled = !mc.data.toggled;
                    if (mc.data.toggled) {
                        mc.x += mc.data.w;
                    }
                    else {
                        mc.x -= mc.data.w;
                    }
                    if (mc.data.toggle) {
                        mc.data.toggle.call(this_, mc.data.toggled);
                    }
                }
            });
        };
        /**
         *  向本地保存文本
         * @param name_ 文件名如 abd.txt
         * @param text_ 文本内容
         */
        M.writeTxt = function (name_, text_) {
            /*  let blob = new Blob(["Hello, world!"], {type: "text/plain;charset=utf-8"});
             *  saveAs(blob, "hello world.txt");*/
            var blob = new Blob([text_], { type: "text/plain;charset=utf-8" });
            window.FileSaver.saveAs(blob, name_);
        };
        /**
         * 将 setObj_ 的属性全部赋值给 obj_
         * @param obj_
         * @param setObj_
         */
        M.setObjProperties = function (obj_, setObj_) {
            for (var t in setObj_) {
                obj_[t] = setObj_[t];
            }
        };
        /**
         * 返回url的绝对路径
         * @param url
         * @return nulls {*}
         */
        M.getAbsoluteUrl = function (url) {
            var a = document.createElement('A');
            a.href = url;
            url = a.href;
            return url;
        };
        /**
         * 绘制虚线
         * @param graphics_ 画笔对象
         * @param p1_ 起始点
         * @param p2_ 终止点
         * @param len_ 虚线的一截长度
         * @param gap_ 虚线间隔
         */
        M.drawDashed = function (graphics, p1, p2, len, gap) {
            if (!len) {
                len = 5;
            }
            if (!gap) {
                gap = 5;
            }
            var max = M.getPointLen(p1, p2), l = 0, p3, p4;
            while (l < max) {
                p3 = Point.interpolate(p2, p1, l / max);
                l += len;
                if (l > max) {
                    l = max;
                }
                p4 = Point.interpolate(p2, p1, l / max);
                graphics.moveTo(p3.x, p3.y);
                graphics.lineTo(p4.x, p4.y);
                l += gap;
            }
        };
        /**
         * 绘制虚线矩形
         * @param graphics
         * @param p1
         * @param p2
         * @param p3
         * @param p4
         * @param len
         */
        M.drawDashedRect = function (graphics, p1, p2, p3, p4, len, gap) {
            M.drawDashed(graphics, p1, p2, len, gap);
            M.drawDashed(graphics, p2, p3, len, gap);
            M.drawDashed(graphics, p3, p4, len, gap);
            M.drawDashed(graphics, p4, p1, len, gap);
        };
        /**
         * 绘制虚线
         * @param p1_ 起始点
         * @param p2_ 终止点
         * @param len_ 虚线的一截长度
         * @param gap_ 虚线间隔
         * @returns {string} 返回path命令
         */
        M.drawSVGDashed = function (p1, p2, len, gap) {
            if (!len) {
                len = 5;
            }
            if (!gap) {
                gap = 5;
            }
            var max = M.getPointLen(p1, p2), l = 0, p3, p4;
            var str = "";
            while (l < max) {
                p3 = Point.interpolate(p2, p1, l / max);
                l += len;
                if (l > max) {
                    l = max;
                }
                p4 = Point.interpolate(p2, p1, l / max);
                str += "M" + p3.x + " " + p3.y;
                str += "L" + p4.x + " " + p4.y;
                l += gap;
            }
            return str;
        };
        /**
         * 绘制虚线方框
         * @param p1
         * @param p2
         * @param p3
         * @param p4
         * @param len
         * @param gap
         * @returns {string}
         */
        M.drawSVGDashedRect = function (p1, p2, p3, p4, len, gap) {
            var str = "";
            str += M.drawSVGDashed(p1, p2, len, gap);
            str += M.drawSVGDashed(p2, p3, len, gap);
            str += M.drawSVGDashed(p3, p4, len, gap);
            str += M.drawSVGDashed(p4, p1, len, gap);
            return str;
        };
        /**
         * xml转json对象
         * @param xml
         * @return nulls {*}
         */
        M.parseXML = function (xml_) {
            return new ObjTree().parseXML(xml_);
        };
        /**
         * 删除 sp 的所有子元件
         * @param sp
         */
        M.removeAllChild = function (sp) {
            if (!sp || !sp.children.length) {
                return;
            }
            while (sp.children.length > 0) {
                sp.removeChildAt(0);
            }
        };
        /**
         * Calculate the points for a quadratic bezier curve and then draws it.
         * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
         *
         * @param cpX {number} Control point x
         * @param cpY {number} Control point y
         * @param toX {number} Destination point x
         * @param toY {number} Destination point y
         * @return null {PIXI.Graphics}
         */
        M.get_quadraticCurveTo_points = function (fromX_, fromY_, cpX, cpY, toX, toY) {
            var xa, ya, n = 20, points = [];
            //points = [new Point(fromX_, fromY_)];
            var fromX = fromX_;
            var fromY = fromY_;
            var j = 0;
            for (var i = 1; i <= n; ++i) {
                j = i / n;
                xa = fromX + ((cpX - fromX) * j);
                ya = fromY + ((cpY - fromY) * j);
                points.push(new Point(xa + (((cpX + ((toX - cpX) * j)) - xa) * j), ya + (((cpY + ((toY - cpY) * j)) - ya) * j)));
            }
            return points;
        };
        /**
         * 类继承(构造函数下方)
         * @param thisClass
         * @param baseClass
         */
        M.extends = function (thisClass, baseClass) {
            thisClass.prototype = Object.create(baseClass.prototype);
            thisClass.constructor = thisClass;
        };
        /**
         * 获取范围内的 num
         * @param num
         * @param min_
         * @param max_
         * @returns {number|*}
         */
        M.range = function (num, min_, max_) {
            num = Math.max(min_, num);
            num = Math.min(max_, num);
            return num;
        };
        /**
         * 获取有效角度(0~360)
         * @param angle_  角度
         * @return null  角度
         */
        M.getValidAngle = function (angle_) {
            var num = Math.abs(angle_);
            if (angle_ < 0) {
                var tm = Math.floor(num / 360 + 1) * 360 + angle_;
                return tm;
            }
            if (num === 0)
                return 0;
            return num % 360;
        };
        /**
         *求两向量的夹角平分线的单位向量, A/|A| + B/|B|, A和B的单位向量和就是角平分线方向
         * @param p1
         * @param p2
         * @param p3
         * @param p4
         * @return {Point}
         */
        M.angleSplitLine = function (p1, p2, p3, p4) {
            var a = new Point(p2.x - p1.x, p2.y - p1.y);
            var b = new Point(p4.x - p3.x, p4.y - p3.y);
            var a1 = Math.sqrt(a.x * a.x + a.y * a.y);
            var b1 = Math.sqrt(b.x * b.x + b.y * b.y);
            var una = new Point(1 / a1 * a.x, 1 / a1 * a.y);
            var unb = new Point(1 / b1 * b.x, 1 / b1 * b.y);
            var und = new Point(una.x + unb.x, una.y + unb.y);
            return und;
        };
        /**
         * 获取有效弧度(0~Math.PI*2)
         * @param angle_
         */
        M.getValidHu = function (hu_) {
            return M.toHu(M.getValidAngle(M.toAngle(hu_)));
        };
        /**
         * 阻止冒泡
         * @param mc
         */
        M.stopPropagation = function (mc) {
            var pFunc = function (evt) {
                evt.stopPropagation();
            };
            M.addTouch(mc, {
                tab: pFunc,
                begin: pFunc,
                move: pFunc,
                end: pFunc
            });
        };
        /**
         * 获取html 标签的绝对坐标
         * @param ATarget   普通dom对象
         * @returns {Point}
         */
        M.GetObjPos = function (ATarget) {
            var target = ATarget;
            var pos = new Point(target.offsetLeft - target.scrollLeft, target.offsetTop - target.scrollTop);
            target = target.offsetParent;
            while (target) {
                pos.x += target.offsetLeft - target.scrollLeft;
                pos.y += target.offsetTop - target.scrollTop;
                target = target.offsetParent;
            }
            return pos;
        };
        /**
         * 判断点是否在sp内
         * @param sp
         * @param point sp的本地坐标
         * @returns {boolean}
         */
        M.containsPoint = function (sp, point) {
            var rect = sp.getBounds();
            if (rect.contains(point.x, point.y)) {
                return true;
            }
            return false;
        };
        /**
         * 获取鼠标全局坐标(在鼠标事件内部调用)
         * @deprecated 修改为TouchUtil.getMouseXY(此函数将在v0.1.0移除)
         * @param evt
         * @param touchType touch的三个列表touches, changedTouches, targetTouches;
         */
        M.getMouseXY = function (evt, identifier, touchType) {
            if (identifier === undefined) {
                identifier = 0;
            }
            if (!touchType) {
                touchType = "changedTouches";
            }
            var p;
            if (evt.data && evt.data.global) {
                p = M.getSPPoint(evt.data.global);
            }
            else if (evt.clientX === undefined) {
                // 为移动端
                var index = void 0;
                if (evt[touchType]) {
                    index = this.getIndexFromIdentifier(evt[touchType], identifier);
                    p = new Point(evt[touchType][index].clientX, evt[touchType][index].clientY);
                }
                else {
                    index = this.getIndexFromIdentifier(evt.originalEvent[touchType], identifier);
                    p = new Point(evt.originalEvent[touchType][index].clientX, evt.originalEvent[touchType][index].clientY);
                }
            }
            else {
                // 为pc端
                p = new Point(evt.clientX, evt.clientY);
            }
            return p;
        };
        /**
         * 通过id查找touch索引
         * @param list
         * @param id
         * @returns {number}
         */
        M.getIndexFromIdentifier = function (list, id) {
            var i = 0;
            for (i = 0; i < list.length; i++) {
                if (id === list[i].identifier) {
                    return i;
                }
            }
            return 0;
        };
        /**
         * 将Canvas的坐标转为pixi内的坐标格式
         * @deprecated 修改为TouchUtil.getCanvasPToMouseP(此函数将在v0.1.0移除)
         * @param touch
         * @returns {}
         */
        M.getCanvasPToMouseP = function (touch) {
            var p = M.getCanvasP(touch);
            var evt = {};
            evt.data = {};
            evt.data.global = new Point(p.x, p.y);
            evt.type = touch.type;
            return evt;
        };
        M.getMousePToCanvasP = function (touch) {
            var p = M.getMouseXY(touch);
            var offObj = $("#canvasID").offset();
            var canvasP = new Point(offObj.left, offObj.top);
            var para = window.nb.PhysicsMain.ToolScale;
            var toP = new Point(p.x * para, p.y * para);
            toP.x += canvasP.x;
            toP.y += canvasP.y;
            var evt = {};
            evt.data = {};
            evt.data.global = new Point(toP.x, toP.y);
            evt.type = touch.type;
            return evt;
        };
        /**
         *获取 canvas 上鼠标点
         * @deprecated 修改为TouchUtil.getCanvasP(此函数将在v0.1.0移除
         * @param evt  为 touch/mouse 的参数
         * @returns {*}
         */
        M.getCanvasP = function (evt, identifier, touchType) {
            // 相对到canvas里的坐标
            var offObj = $("#canvasID").offset();
            var canvasP = new Point(offObj.left, offObj.top);
            // 相对于canvas的外部坐标
            var p = M.getMouseXY(evt, identifier, touchType);
            var toP = new Point(p.x - canvasP.x, p.y - canvasP.y);
            // 转换为canvas的内部坐标
            var nb = window.nb;
            toP.x = toP.x / nb.PhysicsMain.ToolScale;
            toP.y = toP.y / nb.PhysicsMain.ToolScale;
            return toP;
        };
        /**
         *获取 canvas 上鼠标点
         * @param evt  为 touch/mouse 的参数
         * @returns {*}
         */
        M.getCanvasP_sdk = function (evt, identifier, touchType) {
            // 相对到canvas里的坐标
            // let offObj = $("#canvasID").offset();
            // let canvasP = new Point(offObj.left, offObj.top);
            var canvasP = new Point(0, 0);
            // 相对于canvas的外部坐标
            var p = M.getMouseXY(evt, identifier, touchType);
            var toP = new Point(p.x - canvasP.x, p.y - canvasP.y);
            return toP;
        };
        /**
         * 判断浏览器类型
         * 如果要判断系统是否是iPad，只需要判断if(os.isIpad) {}.
         */
        M.os = function () {
            var UserAgent = navigator.userAgent.toLowerCase();
            return {
                isIpad: /ipad/.test(UserAgent),
                isIphone: /iphone os/.test(UserAgent),
                isAndroid: /android/.test(UserAgent),
                isWindowsCe: /windows ce/.test(UserAgent),
                isWindowsMobile: /windows mobile/.test(UserAgent),
                isWin2K: /windows nt 5.0/.test(UserAgent),
                isXP: /windows nt 5.1/.test(UserAgent),
                isVista: /windows nt 6.0/.test(UserAgent),
                isWin7: /windows nt 6.1/.test(UserAgent),
                isWin8: /windows nt 6.2/.test(UserAgent),
                isWin81: /windows nt 6.3/.test(UserAgent),
                isWinPC: /windows nt/.test(UserAgent)
            };
        };
        /**
         * "rgb(81, 167, 249)" 转 16进制 (仅数字,"0x"或"#"自己添加)
         * @param rgbStr
         * @returns {string}
         * @constructor
         */
        M.RGBToHex = function (rgbStr) {
            var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
            var that = rgbStr;
            if (/^(rgb|RGB)/.test(that)) {
                var aColor = that.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
                var strHex = "";
                for (var i = 0; i < aColor.length; i++) {
                    var hex = Number(aColor[i]).toString(16);
                    if (hex.length === 1) {
                        hex = "0" + hex;
                    }
                    strHex += hex;
                }
                return strHex;
            }
            else if (reg.test(that)) {
                var aNum = that.replace(/#/, "").split("");
                if (aNum.length === 6) {
                    return that;
                }
                else if (aNum.length === 3) {
                    var numHex = "";
                    for (var i = 0; i < aNum.length; i += 1) {
                        numHex += (aNum[i] + aNum[i]);
                    }
                    return numHex;
                }
            }
            else {
                return that;
            }
        };
        /**
         * 判断颜色是否为深色
         * @param color_
         */
        M.isColorDeep = function (color_) {
            var rgbArr = M.retrieveRGBComponent(color_);
            var grayLevel = rgbArr[0] * 0.299 + rgbArr[1] * 0.587 + rgbArr[2] * 0.114;
            if (grayLevel >= 192) {
                return false;
            }
            else {
                return true;
            }
        };
        /**
         * 0xFF0000 转换为如 #FF0000
         * @deprecated ColorUtil.getDomColor(此函数将在v0.1.0移除)
         * @param color_
         * @returns {string}
         */
        M.getDomColor = function (color_) {
            var hex = Number(color_).toString(16) + '';
            while (hex.length < 6) {
                hex = '0' + hex;
            }
            var s = "#" + hex;
            return s;
        };
        /**
         * 绘制点路径
         * @param g  PIXI.Graphics
         * @param pArr点 集合
         * @param isSeal_ 是否为封闭图形(默认true)
         * @returns PIXI.Graphics
         */
        M.linePath = function (g, pArr, isSeal_) {
            if (isSeal_ === undefined) {
                isSeal_ = true;
            }
            if (!g || !pArr || pArr.length < 3) {
                return null;
            }
            g.moveTo(pArr[0].x, pArr[0].y);
            var i, len = pArr.length;
            for (i = 1; i < len; i++) {
                g.lineTo(pArr[i].x, pArr[i].y);
            }
            if (isSeal_) {
                g.lineTo(pArr[0].x, pArr[0].y);
            }
            return g;
        };
        /**
         * 通过3个点获取拐弯的点(解决直线材质直接绘制的bug)
         * @param p1
         * @param p2 为中间的点
         * @param p3
         */
        M.getRoundP = function (p1, p2, p3) {
            var r = 10;
            var cp1 = M.getXianDianByDis(r, true, p2, p1);
            var cp2 = M.getXianDianByDis(r, true, p2, p3);
            var angle_ = M.toHu(M.getAngleByP(p1, p2, p3));
            var rpArr = [p1, cp1, cp2, p3];
            return rpArr;
            // return [p1, cp1, cp2, p3];
        };
        /**
         * 添加定时器
         * @param func_
         * @param _this
         * @param isStart_ 默认为true
         */
        M.addTicker = function (func_, _this, isStart_) {
            if (isStart_ === undefined) {
                isStart_ = true;
            }
            var ticker;
            if (PIXI) {
                ticker = new PIXI.ticker.Ticker();
                ticker.$this = _this;
                ticker.add(function (timer_) {
                    if (ticker.$this) {
                        func_.call(ticker.$this);
                    }
                    else {
                        func_();
                    }
                });
                if (isStart_) {
                    ticker.start();
                }
            }
            return ticker;
        };
        /**
         * 移除ticker
         * @param ticker_
         */
        M.removeTicker = function (ticker_) {
            if (ticker_) {
                ticker_.stop();
                ticker_.$this = null;
                delete ticker_.$this;
                ticker_ = null;
            }
        };
        /**
         * 延迟执行
         * @param conditionFunc_  条件函数(返回true则执行resultFunc_)
         * @param resultFunc_     结果要执行的函数
         * @param _this           作用域
         * @param delayTime_      延迟时间(毫秒)
         */
        M.delayCallFunc = function (conditionFunc_, resultFunc_, _this, delayTime_) {
            if (delayTime_ === undefined) {
                delayTime_ = 50;
            }
            if (!_this) {
                _this = this;
            }
            if (conditionFunc_.call(_this)) {
                resultFunc_.call(_this);
            }
            else {
                setTimeout(function () {
                    M.delayCallFunc(conditionFunc_, resultFunc_, _this, delayTime_);
                }, delayTime_);
            }
        };
        /**
         * 字符串异或加密/解密
         * @param key_ 秘钥
         * @param text_ 要处理的字符串
         */
        M.makeOrStr = function (key_, text_) {
            var i, j, len1 = text_.length, len2 = key_.length, last = "";
            var mKey_;
            var text2;
            for (i = 0; i < len1; i++) {
                for (j = 0; j < len2; j++) {
                    mKey_ = key_.charCodeAt(j);
                    text2 = text_.charCodeAt(i) ^ mKey_;
                }
                last += String.fromCharCode(text2);
            }
            return last;
        };
        /**
         * 求一组数据的标准方差 </br>公式:s^2=[(x1-x)^2+(x2-x)^2+...(xn-x)^2]/n, Math.sqrt(s^2)
         * @param arr {Array}
         * @returns {number}
         */
        M.standardletiance = function (arr) {
            var i;
            var len = arr.length;
            var num = 0;
            for (i = 0; i < len; i++) {
                num += arr[i];
            }
            var average = num / len;
            var s2num = 0;
            for (i = 0; i < len; i++) {
                var a = arr[i] - average;
                s2num += a * a;
            }
            var s2 = s2num / len;
            return Math.sqrt(s2);
        };
        /**
         * 检测是否与点碰撞
         * @param target {*} 目标对象
         * @param point {Point} 检测的点
         * @param isglobal {Boolean} point是否为全局坐标系的点
         * @returns {boolean} false
         */
        M.hitTestPoint = function (target, point, isglobal) {
            var rect = target.getBounds();
            if (!isglobal) {
                point = target.toGlobal(point);
            }
            return rect.contains(point.x, point.y);
        };
        /**
         * 调整target的注册点布局
         * @param target
         * @param pivotx {String} x的位置left,center,right
         * @param pivoty {String} y的位置top, center, bottom
         */
        M.alignPivot = function (target, pivotx, pivoty) {
            var l = pivotx || "center";
            var r = pivoty || "center";
            if (l === "left") {
                target.pivot.x = 0;
            }
            else if (l === "center") {
                target.pivot.x = target.width / 2;
            }
            else if (l === "right") {
                target.pivot.x = target.width;
            }
            if (r === "top") {
                target.pivot.y = 0;
            }
            else if (r === "center") {
                target.pivot.y = target.height / 2;
            }
            else if (r === "bottom") {
                target.pivot.y = target.height;
            }
        };
        /**
         * 对象深度复制
         * @param obj
         * @returns {*}
         */
        M.clone = function (obj) {
            // Handle the 3 simple types, and null or undefined
            if (null === obj || "object" !== typeof obj)
                return obj;
            // Handle Date
            if (obj instanceof Date) {
                var copy = new Date();
                copy.setTime(obj.getTime());
                return copy;
            }
            // Handle Array
            if (obj instanceof Array) {
                var copy = [];
                var i = void 0, len = obj.length;
                for (i = 0; i < len; ++i) {
                    copy[i] = M.clone(obj[i]);
                }
                return copy;
            }
            // Handle Object
            if (obj instanceof Object) {
                var copy = {};
                for (var attr in obj) {
                    if (obj.hasOwnProperty(attr))
                        copy[attr] = M.clone(obj[attr]);
                }
                return copy;
            }
            throw new Error("Unable to copy obj! Its type isn't supported.");
        };
        /**
         * 判断两个Object是否相等
         * @param obj0_
         * @param obj
         * @returns {boolean}
         */
        M.equals = function (obj0_, obj) {
            if (obj0_ === obj)
                return true;
            if (typeof (obj) === "undefined" || obj === null || typeof (obj) !== "object")
                return false;
            var length = 0;
            var length1 = 0;
            for (var ele in obj0_) {
                length++;
            }
            for (var ele in obj) {
                length1++;
            }
            if (length !== length1)
                return false;
            if (obj.constructor === obj0_.constructor) {
                for (var ele in obj0_) {
                    if (typeof (obj0_[ele]) === "object") {
                        if (!M.equals(obj0_[ele], obj[ele]))
                            return false;
                    }
                    else if (typeof (obj0_[ele]) === "function") {
                        if (!M.equals(obj0_[ele].toString(), obj[ele].toString()))
                            return false;
                    }
                    else if (obj0_[ele] !== obj[ele])
                        return false;
                }
                return true;
            }
            return false;
        };
        /**
         * 获取dom下第一级所有元素
         * @param obj  dom元素
         * @returns {Array}
         */
        M.getFirstChildren = function (obj) {
            var objChild = [];
            var objs = obj.getElementsByTagName('*');
            for (var i = 0, j = objs.length; i < j; ++i) {
                if (objs[i].nodeType !== 1) {
                    continue;
                }
                var temp = objs[i].parentNode;
                if (temp.nodeType === 1) {
                    if (temp === obj) {
                        objChild[objChild.length] = objs[i];
                    }
                }
                else if (temp.parentNode === obj) {
                    objChild[objChild.length] = objs[i];
                }
            }
            return objChild;
        };
        // /**
        //  * 设置dom标签input的正则表达式限制
        //  * @param id_
        //  * @param reg_  反的,前面要加^
        //  */
        // static setInputReg(id_, reg_) {
        //   $("#" + id_).keyup((evt) => {
        //     let value_ = this.value.replace(reg_, '');
        //     $(this).val(value_);
        //   });
        // }
        /**
         * 监听scroll防抖函数,如:
         *  let myEfficientFn = M.debounce(function() {
          // 滚动中的真正的操作
        }, 200);
         // 绑定监听
         window.addEventListener('resize', myEfficientFn);
         * @param func
         * @param wait  多少毫秒执行一次
         * @param immediate 启动的时候是否回调一次func
         * @returns {Function}
         */
        M.debounce = function (func, wait, immediate, context) {
            if (wait === undefined)
                wait = 250;
            var timeout;
            var context_ = context || this;
            return function () {
                var $context = context_ || this;
                var args = arguments;
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    timeout = null;
                    if (!immediate)
                        func.apply($context, args);
                }, wait);
                if (callNow)
                    func.apply($context, args);
            };
        };
        /**
         * 如果直接由fla里添加图片bmp,导入PIXI,则此方法可根据PIXI名字找到桌面的那个图片所属sp
         * @param parent_
         * @param BMPName
         * @returns {*}
         */
        M.getAddPIXIBMP = function (parent_, BMPName) {
            if (!parent_ || !parent_.children || !BMPName || BMPName.length === 0)
                return null;
            var reSP = null;
            window.each(parent_.children, function (i, item) {
                if (item && item._nbData_ && item._nbData_.libName === BMPName) {
                    reSP = item;
                    return false;
                }
            });
            return reSP;
        };
        /**
         * 监控mouse/touch有效性
         * @param evt
         * @returns {boolean}
         */
        M.checkValidMT = function (evt) {
            if (!evt.type || evt.type.indexOf("touch") > -1)
                return true;
            return false;
        };
        /**
         *  全屏
         */
        M.fullScreen = function () {
            var el = document.documentElement;
            var rfs = el.requestFullScreen || el.webkitRequestFullScreen ||
                el.mozRequestFullScreen || el.msRequestFullScreen;
            if (typeof rfs !== "undefined" && rfs) {
                rfs.call(el);
            }
            else if (typeof window.ActiveXObject !== "undefined") {
                //for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏
                var wscript = new window.ActiveXObject("WScript.Shell");
                if (wscript !== null) {
                    wscript.SendKeys("{F11}");
                }
            }
        };
        /**
         * 退出全屏
         */
        M.exitFullScreen = function () {
            var el = document;
            var cfs = el.cancelFullScreen || el.webkitCancelFullScreen ||
                el.mozCancelFullScreen || el.exitFullScreen;
            if (typeof cfs !== "undefined" && cfs) {
                cfs.call(el);
            }
            else if (typeof window.ActiveXObject !== "undefined") {
                //for IE，这里和fullScreen相同，模拟按下F11键退出全屏
                var wscript = new window.ActiveXObject("WScript.Shell");
                if (wscript !== null) {
                    wscript.SendKeys("{F11}");
                }
            }
        };
        /**
         * 监听全屏状态
         * @param callBackFunc_  返回是否为全屏状态
         * @param _this_
         */
        M.listenFullscreen = function (callBackFunc_, _this_) {
            var _this = _this_ !== undefined ? _this_ : this;
            var el = document.documentElement;
            if (el.requestFullscreen) { //W3C
                document.addEventListener("fullscreenchange", function () {
                    callBackFunc_.call(_this, document.fullscreen);
                }, false);
            }
            else if (el.mozRequestFullScreen) { //FireFox
                document.addEventListener("mozfullscreenchange", function () {
                    callBackFunc_.call(_this, document.mozFullScreen);
                }, false);
            }
            else if (el.webkitRequestFullscreen) { //Chrome
                document.addEventListener("webkitfullscreenchange", function () {
                    callBackFunc_.call(_this, document.webkitIsFullScreen);
                }, false);
            }
            else if (el.msRequestFullscreen) { //IE11
                document.addEventListener("msfullscreenchange", function () {
                    callBackFunc_.call(_this, document.msFullscreenElement);
                }, false);
            }
        };
        /**
         * 重新设置Rope的点集合
         * @param rope
         * @param points
         */
        M.setRopePoints = function (rope, points) {
            rope.points = points;
            rope.vertices = new Float32Array(points.length * 4);
            rope.uvs = new Float32Array(points.length * 4);
            rope.colors = new Float32Array(points.length * 2);
            rope.indices = new Uint16Array(points.length * 2);
            (rope._refresh || rope.refresh).call(rope); // 兼容v4
        };
        /**
         * 检测是否为XP系统
         * @returns {boolean}
         */
        M.checkIsWinXP = function () {
            var isWin = (navigator.platform === "Win32") || (navigator.platform === "Windows");
            var isWinXP = false;
            var sUserAgent = navigator.userAgent;
            if (isWin) {
                isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows Xp") > -1; //winxp
            }
            return isWinXP;
        };
        /**
         * 检测是否为 IE 浏览器
         * @returns {boolean}
         */
        M.checkIsIE = function () {
            return !!window['ActiveXObject'] || 'ActiveXObject' in window;
        };
        /**
         * 销毁TweenMax
         * tween = TweenMax.to()
         * @param tween
         */
        M.killTweenMax = function (tween, isNotDestroy) {
            if (!tween)
                return;
            if (tween instanceof Array) {
                // 如果同时缓动一个以上的对象时 TweenMax.allTo([obj1, obj2], 0.5, {});
                while (tween.length) {
                    M.killTweenMax(tween.pop());
                }
            }
            else {
                window.TweenMax.killTweensOf(tween.target, false, null);
                if (!isNotDestroy) {
                    tween.prevNode = null;
                    tween.nextNode = null;
                    tween.target = null;
                    for (var t in tween.vars) {
                        if (tween.vars[t].this)
                            tween.vars[t].this = null; // 移除引用
                        tween.vars[t] = null; // 移除参数
                    }
                    tween.data = null;
                    tween = null;
                }
            }
        };
        /**
         * 将json字符串格式化为对象
         * @param data  string | object
         * @returns {*}
         * @private
         */
        M.getObjFromJsonStr = function (data) {
            var jsonObj = null;
            try {
                var obj = Object.prototype.toString.call(data) === '[object String]' ? JSON.parse(data) : data;
                if (Object.prototype.toString.call(obj) === '[object Object]') {
                    jsonObj = obj;
                }
            }
            catch (err) {
                jsonObj = null;
            }
            return jsonObj;
        };
        M.getUrlPara = function (name) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
            var r = location.href.substring(location.href.indexOf('?') + 1).match(reg);
            if (r != null)
                return (r[2]);
            return null;
        };
        /**
         * 求矩形与圆形的相交
         * 参考: https://blog.csdn.net/noahzuo/article/details/52037151
         * 注: 将圆转移到第一象限: 圆心减矩形心并取绝对值
         * @param rect {x,y,width,height} 矩形Rectangle
         * @param circle {point:Point, radus}  圆心与半径
         * @return {boolean}
         */
        M.checkRCIntersection = function (rect, circle) {
            var p0 = new Point(rect.x, rect.y); // 左上角
            var p3 = new Point(p0.x + rect.width, p0.y + rect.height); // 右下角
            // 矩形心
            var rectCenP = M.getCenP(p0, p3);
            // 圆心
            var cirCenP = circle.point;
            // 新圆心: 圆心减矩形心并取绝对值(将圆映射到第一象限)
            var v = new Point(Math.abs(cirCenP.x - rectCenP.x), Math.abs(cirCenP.y - rectCenP.y));
            // 右下角向量(矩形第一象限的角坐标,此角的点向量减去矩形中心)
            var h = new Point(Math.abs(p3.x - rectCenP.x), Math.abs(p3.y - rectCenP.y));
            // 矩形右上角到圆心的向量(不能小于0): v-h
            var u = new Point(Math.max(0, v.x - h.x), Math.max(0, v.y - h.y));
            // 小于等于则合法 (小于相交, 等于为相切, 大于相离)
            return u.x * u.x + u.y * u.y <= circle.raduis * circle.raduis;
        };
        /**
         * 延迟函数
         * @param num 延迟的毫秒数
         */
        M.sleep = function (num) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new Promise(function (resolve) { return setTimeout(resolve, num); })];
                });
            });
        };
        M.MIN = 0.000001;
        M.__bdArr = [];
        M.__isDenyDB = false;
        return M;
    }());

    /**
     * new SVGLoad().load().then(obj)  // 返回(原对象添加了g) [{path:XXX, g:XXX}]
     */
    var SVGLoad = /** @class */ (function () {
        function SVGLoad() {
        }
        /**
         * new SVGLoad().load([{path:XXX}]).then(arr=>{})
         *
         * @param arr_  [{path:XXX}]
         */
        SVGLoad.prototype.load = function (arr_) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                _this._loadNextSVG(resolve, arr_, []);
            });
        };
        SVGLoad.prototype._loadNextSVG = function (resolve, _loadAllSVGArr, _reArr) {
            var _this = this;
            if (_loadAllSVGArr.length === 0) {
                // 结束
                resolve(_reArr);
                return;
            }
            var _nextObj = _loadAllSVGArr.shift();
            Snap.load(_nextObj.path, function (f) {
                // 获取组(svg文件需处理:如果原文件未用组包围则先用组包围一下)
                _nextObj.g = f.select("g");
                _reArr.push(_nextObj);
                // 递归加载
                _this._loadNextSVG(resolve, _loadAllSVGArr, _reArr);
            }, this);
        };
        return SVGLoad;
    }());

    /**
     * Matrix.js
     * http://github.com/sjkaliski/numbers.js
     *
     * Copyright 2012 Stephen Kaliski
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    var Matrix = /** @class */ (function () {
        function Matrix() {
        }
        /**
         * Check to see if a point is 2D. Used in all 2D vector functions.
         * Throw error if it's not.
         *
         * @param {Array} point in question.
         * @return {undefined} nothing is returned.
         */
        Matrix._check2DVector = function (point) {
            if (point.length !== 2) {
                throw new Error(Matrix.ERROR_VECTOR_NOT_2D);
            }
        };
        /**
         * 矩阵克隆
         *
         * @param {Array} matrix to copy.
         * @return {Array} copied Matrix.
         */
        Matrix.deepCopy = function (arr) {
            if (!Array.isArray(arr)) {
                throw new Error('Input must be a Matrix.');
            }
            else if (arr[0][0] === undefined) {
                throw new Error('Input cannot be a vector.');
            }
            var result = new Array(arr.length);
            for (var i = 0; i < arr.length; i++) {
                result[i] = arr[i].slice();
            }
            return result;
        };
        /**
         * 判断矩阵是否为正方形矩阵
         *
         * @param {Array} arr
         * @return {Boolean}
         */
        Matrix.isSquare = function (arr) {
            if (!Array.isArray(arr)) {
                throw new Error('Input must be a Matrix.');
            }
            else if (arr[0][0] === undefined) {
                throw new Error('Input cannot be a vector.');
            }
            var rows = arr.length;
            for (var i = 0; i < rows; i++) {
                if (arr[i].length !== rows)
                    return false;
            }
            return true;
        };
        /**
         * 矩阵加法,并返回(必须同纬)
         *
         * @param {Array} matrix A.
         * @param {Array} matrix B.
         * @return {Array} summed Matrix.
         */
        Matrix.addition = function (arrA, arrB) {
            if (arrA.length !== arrB.length || arrA[0].length !== arrB[0].length) {
                throw new Error('Matrix mismatch');
            }
            var result = new Array(arrA.length);
            var i;
            if (!arrA[0].length) {
                // The arrays are vectors.
                for (i = 0; i < arrA.length; i++) {
                    result[i] = arrA[i] + arrB[i];
                }
            }
            else {
                for (i = 0; i < arrA.length; i++) {
                    result[i] = new Array(arrA[i].length);
                    for (var j = 0; j < arrA[i].length; j++) {
                        result[i][j] = arrA[i][j] + arrB[i][j];
                    }
                }
            }
            return result;
        };
        /**
         * 矩阵输出
         *
         */
        Matrix.traceMatrix = function (arrA) {
            if (!arrA)
                return;
            if (!arrA.length)
                return;
            var i, str;
            if (!arrA[0].length) {
                str = "";
                for (i = 0; i < arrA.length; i++) {
                    str += arrA[i] + "\t";
                }
                console.log(str);
            }
            else {
                for (i = 0; i < arrA.length; i++) {
                    str = "";
                    for (var j = 0; j < arrA[i].length; j++) {
                        str += arrA[i][j] + "\t";
                    }
                    console.log(str);
                }
            }
        };
        /**
         * 矩阵减法
         *
         * @param {Array} matrix A.
         * @param {Array} matrix B.
         * @return {Array} subtracted Matrix.
         */
        Matrix.subtraction = function (arrA, arrB) {
            if (arrA.length !== arrB.length || arrA[0].length !== arrB[0].length) {
                throw new Error("Matrix mismatch");
            }
            var result = new Array(arrA.length);
            var i;
            if (!arrA[0].length) {
                // The arrays are vectors.
                for (i = 0; i < arrA.length; i++) {
                    result[i] = arrA[i] - arrB[i];
                }
            }
            else {
                for (i = 0; i < arrA.length; i++) {
                    result[i] = new Array(arrA[i].length);
                    for (var j = 0; j < arrA[i].length; j++) {
                        result[i][j] = arrA[i][j] - arrB[i][j];
                    }
                }
            }
            return result;
        };
        /**
         * 矩形乘以标量(矩阵点乘)
         *
         * @param {Array} Matrix.
         * @param {Number} scalar.
         * @return {Array} updated Matrix.
         */
        Matrix.scalar = function (arr, val) {
            for (var i = 0; i < arr.length; i++) {
                for (var j = 0; j < arr[i].length; j++) {
                    arr[i][j] = val * arr[i][j];
                }
            }
            return arr;
        };
        /**
         * 矩阵转置
         *
         * @param {Array} Matrix.
         * @return {Array} transposed Matrix.
         */
        Matrix.transpose = function (arr) {
            var result = new Array(arr[0].length);
            for (var i = 0; i < arr[0].length; i++) {
                result[i] = new Array(arr.length);
                for (var j = 0; j < arr.length; j++) {
                    result[i][j] = arr[j][i];
                }
            }
            return result;
        };
        /**
         * 创建 n*n 的单位矩阵
         *
         * @param {Number} dimension of the identity array to be returned.
         * @return {Array} n x n identity Matrix.
         */
        Matrix.identity = function (n) {
            var result = new Array(n);
            for (var i = 0; i < n; i++) {
                result[i] = new Array(n);
                for (var j = 0; j < n; j++) {
                    result[i][j] = (i === j) ? 1 : 0;
                }
            }
            return result;
        };
        /**
         * 检查矩阵 m 从左上角开始 rowNum x colNum 是否为单位矩阵
         * 如果 rowNum 与 colNum 为空则默认为 m 整个矩阵
         * @param m 矩阵m
         * @param rowNum 检查的行数
         * @param colNum 检查的列数
         * @param threshold 阀值
         * @returns
         */
        Matrix.isIdentity = function (m, rowNum, colNum, threshold) {
            if (rowNum === void 0) { rowNum = 0; }
            if (colNum === void 0) { colNum = 0; }
            if (threshold === void 0) { threshold = 0; }
            var row = rowNum || m.length;
            var col = colNum || m[0].length;
            for (var i = 0; i < row; i++) {
                for (var j = 0; j < col; j++) {
                    if (i === j) {
                        if (Math.abs(m[i][j] - 1) > threshold)
                            return false;
                    }
                    else {
                        if (Math.abs(m[i][j]) > threshold)
                            return false;
                    }
                }
            }
            return true;
        };
        /**
         * 两个向量的点积
         *
         * @param {Array} vector.
         * @param {Array} vector.
         * @return {Array} dot product.
         */
        Matrix.dotproduct = function (vectorA, vectorB) {
            if (vectorA.length !== vectorB.length) {
                throw new Error("Vector mismatch");
            }
            var result = 0;
            for (var i = 0; i < vectorA.length; i++) {
                result += vectorA[i] * vectorB[i];
            }
            return result;
        };
        /**
         * 两个矩阵相乘(矩阵叉乘)
         *
         * e.g. A x B = (m x n) x (n x m), where n, m are integers who define
         * the dimensions of matrices A, B.
         *
         * @param {Array} Matrix.
         * @param {Array} Matrix.
         * @return {Array} result of multiplied matrices.
         */
        Matrix.multiply = function (arrA, arrB) {
            if (arrA[0].length !== arrB.length) {
                throw new Error("Matrix mismatch");
            }
            var result = new Array(arrA.length);
            for (var x = 0; x < arrA.length; x++) {
                result[x] = new Array(arrB[0].length);
            }
            var arrB_T = Matrix.transpose(arrB);
            for (var i = 0; i < result.length; i++) {
                for (var j = 0; j < result[i].length; j++) {
                    result[i][j] = Matrix.dotproduct(arrA[i], arrB_T[j]);
                }
            }
            return result;
        };
        /**
         * 返回矩阵的行列式
         *
         * @param {Array} Matrix.
         * @return {Number} determinant.
         */
        Matrix.determinant = function (m) {
            var numRow = m.length;
            var numCol = m[0].length;
            var det = 0;
            var row, col;
            var diagLeft, diagRight;
            if (!Matrix.isSquare(m)) {
                throw new Error(Matrix.ERROR_MATRIX_NOT_SQUARE);
            }
            if (numRow === 1) {
                return m[0][0];
            }
            else if (numRow === 2) {
                return m[0][0] * m[1][1] - m[0][1] * m[1][0];
            }
            for (col = 0; col < numCol; col++) {
                diagLeft = m[0][col];
                diagRight = m[0][col];
                for (row = 1; row < numRow; row++) {
                    diagRight *= m[row][(((col + row) % numCol) + numCol) % numCol];
                    diagLeft *= m[row][(((col - row) % numCol) + numCol) % numCol];
                }
                det += diagRight - diagLeft;
            }
            return det;
        };
        /**
         * LU分解法
         * Returns a LUP decomposition of the given matrix such that:
         *
         * A*P = L*U
         *
         * Where
         * A is the input matrix
         * P is a pivot matrix
         * L is a lower triangular matrix
         * U is a upper triangular matrix
         *
         * This method returns an array of three matrices such that:
         *
         * Matrix.luDecomposition(array) = [L, U, P]
         *
         * @param {Array} arr
         * @return {Array} array of matrices [L, U, P]
         */
        Matrix.lupDecomposition = function (arr) {
            if (!Matrix.isSquare(arr)) {
                throw new Error(Matrix.ERROR_MATRIX_NOT_SQUARE);
            }
            var size = arr.length;
            var LU = Matrix.deepCopy(arr);
            var P = Matrix.transpose(Matrix.identity(size));
            var currentRow;
            var currentColumn = new Array(size);
            var getL = function (a) {
                var m = a[0].length;
                var L = Matrix.identity(m);
                for (var i = 0; i < m; i++) {
                    for (var j = 0; j < m; j++) {
                        if (i > j) {
                            L[i][j] = a[i][j];
                        }
                    }
                }
                return L;
            };
            var getU = function (a) {
                var m = a[0].length;
                var U = Matrix.identity(m);
                for (var i = 0; i < m; i++) {
                    for (var j = 0; j < m; j++) {
                        if (i <= j) {
                            U[i][j] = a[i][j];
                        }
                    }
                }
                return U;
            };
            for (var j = 0; j < size; j++) {
                var i = void 0;
                for (i = 0; i < size; i++) {
                    currentColumn[i] = LU[i][j];
                }
                for (i = 0; i < size; i++) {
                    currentRow = LU[i];
                    var minIndex = Math.min(i, j);
                    var s = 0;
                    for (var k = 0; k < minIndex; k++) {
                        s += currentRow[k] * currentColumn[k];
                    }
                    currentRow[j] = currentColumn[i] -= s;
                }
                //Find pivot
                var pivot = j;
                for (i = j + 1; i < size; i++) {
                    if (Math.abs(currentColumn[i]) > Math.abs(currentColumn[pivot])) {
                        pivot = i;
                    }
                }
                if (pivot !== j) {
                    LU = Matrix.rowSwitch(LU, pivot, j);
                    P = Matrix.rowSwitch(P, pivot, j);
                }
                if (j < size && LU[j][j] !== 0) {
                    for (i = j + 1; i < size; i++) {
                        LU[i][j] /= LU[j][j];
                    }
                }
            }
            return [getL(LU), getU(LU), P];
        };
        /**
         * 矩阵旋转
         * Rotate a two dimensional vector by degree.
         *
         * @param {Array} point.
         * @param {Number} degree.
         * @param {String} direction - clockwise or counterclockwise.
         * @return {Array} vector.
         */
        Matrix.rotate = function (point, degree, direction) {
            Matrix._check2DVector(point);
            var negate = direction === 'clockwise' ? -1 : 1;
            var radians = degree * (Math.PI / 180);
            var transformation = [
                [Math.cos(radians), -1 * negate * Math.sin(radians)],
                [negate * Math.sin(radians), Math.cos(radians)]
            ];
            return Matrix.multiply(transformation, point);
        };
        /**
         * 矩阵缩放
         * Scale a two dimensional vector by scale factor x and scale factor y.
         *
         * @param {Array} point.
         * @param {Number} sx.
         * @param {Number} sy.
         * @return {Array} vector.
         */
        Matrix.scale = function (point, sx, sy) {
            Matrix._check2DVector(point);
            var transformation = [
                [sx, 0],
                [0, sy]
            ];
            return Matrix.multiply(transformation, point);
        };
        /**
         * Shear a two dimensional vector by shear factor k.
         *
         * @param {Array} point.
         * @param {Number} k.
         * @param {String} direction - xaxis or yaxis.
         * @return {Array} vector.
         */
        Matrix.shear = function (point, k, direction) {
            Matrix._check2DVector(point);
            var xplaceholder = direction === 'xaxis' ? k : 0;
            var yplaceholder = direction === 'yaxis' ? k : 0;
            var transformation = [
                [1, xplaceholder],
                [yplaceholder, 1]
            ];
            return Matrix.multiply(transformation, point);
        };
        /**
         * Perform an affine transformation on the given vector.
         *
         * @param {Array} point.
         * @param {Number} tx.
         * @param {Number} ty.
         * @return {Array} vector.
         */
        Matrix.affine = function (point, tx, ty) {
            Matrix._check2DVector(point);
            var transformation = [
                [1, 0, tx],
                [0, 1, ty],
                [0, 0, 1]
            ];
            var newpoint = [
                [point[0][0]],
                [point[1][0]],
                [1]
            ];
            var transformed = Matrix.multiply(transformation, newpoint);
            return [
                [transformed[0][0]],
                [transformed[1][0]]
            ];
        };
        /**
         * Scales a row of a matrix by a factor and returns the updated Matrix.
         * Used in row reduction functions.
         *
         * @param {Array} Matrix.
         * @param {Number} row.
         * @param {Number} scale.
         */
        Matrix.rowScale = function (m, row, scale) {
            var result = new Array(m.length);
            for (var i = 0; i < m.length; i++) {
                result[i] = new Array(m[i].length);
                for (var j = 0; j < m[i].length; j++) {
                    if (i === row) {
                        result[i][j] = scale * m[i][j];
                    }
                    else {
                        result[i][j] = m[i][j];
                    }
                }
            }
            return result;
        };
        /**
         * 矩阵交换两个行
         * Swaps two rows of a matrix  and returns the updated Matrix.
         * Used in row reduction functions.
         *
         * @param {Array} Matrix.
         * @param {Number} row1.
         * @param {Number} row2.
         */
        Matrix.rowSwitch = function (m, row1, row2) {
            var result = new Array(m.length);
            for (var i = 0; i < m.length; i++) {
                result[i] = new Array(m[i].length);
                for (var j = 0; j < m[i].length; j++) {
                    if (i === row1) {
                        result[i][j] = m[row2][j];
                    }
                    else if (i === row2) {
                        result[i][j] = m[row1][j];
                    }
                    else {
                        result[i][j] = m[i][j];
                    }
                }
            }
            return result;
        };
        /**
         * Adds a multiple of one row to another row
         * in a matrix and returns the updated Matrix.
         * Used in row reduction functions.
         *
         * @param {Array} Matrix.
         * @param {Number} row1.
         * @param {Number} row2.
         */
        Matrix.rowAddMultiple = function (m, from, to, scale) {
            var result = new Array(m.length);
            for (var i = 0; i < m.length; i++) {
                result[i] = new Array(m[i].length);
                for (var j = 0; j < m[i].length; j++) {
                    if (i === to) {
                        result[to][j] = m[to][j] + scale * m[from][j];
                    }
                    else {
                        result[i][j] = m[i][j];
                    }
                }
            }
            return result;
        };
        /**
         * 高斯消元法
         * Gauss-Jordan Elimination
         *
         * @param {Array} Matrix.
         * @param {Number} epsilon.
         * @return {Array} RREF Matrix.
         */
        Matrix.GaussJordanEliminate = function (m, epsilon) {
            // Translated from:
            // http://elonen.iki.fi/code/misc-notes/python-gaussj/index.html
            var eps = (typeof epsilon === 'undefined') ? 1e-10 : epsilon;
            var h = m.length;
            var w = m[0].length;
            var y = -1;
            var y2, x, c;
            while (++y < h) {
                // Pivot.
                var maxrow = y;
                y2 = y;
                while (++y2 < h) {
                    if (Math.abs(m[y2][y]) > Math.abs(m[maxrow][y]))
                        maxrow = y2;
                }
                var tmp = m[y];
                m[y] = m[maxrow];
                m[maxrow] = tmp;
                // Singular
                if (Math.abs(m[y][y]) <= eps) {
                    return m;
                }
                // Eliminate column
                y2 = y;
                while (++y2 < h) {
                    c = m[y2][y] / m[y][y];
                    x = y - 1;
                    while (++x < w) {
                        m[y2][x] -= m[y][x] * c;
                    }
                }
            }
            // Backsubstitute.
            y = h;
            while (--y >= 0) {
                c = m[y][y];
                y2 = -1;
                while (++y2 < y) {
                    x = w;
                    while (--x >= y) {
                        m[y2][x] -= m[y][x] * m[y2][y] / c;
                    }
                }
                m[y][y] /= c;
                // Normalize row
                x = h - 1;
                while (++x < w) {
                    m[y][x] /= c;
                }
            }
            return m;
        };
        /**
         * 高斯消元法
         * Alias to Gauss-Jordan Elimination
         *
         * @param {Array} Matrix.
         * @param {Number} epsilon.
         * @return {Array} RREF Matrix.
         */
        Matrix.rowReduce = function (m, epsilon) {
            return Matrix.GaussJordanEliminate(m, epsilon);
        };
        /**
         * 矩阵求逆
         * nxn matrix inversion
         *
         * @param {Array} Matrix.
         * @return {Array} inverted Matrix.
         */
        Matrix.inverse = function (m) {
            if (!Matrix.isSquare(m)) {
                throw new Error(Matrix.ERROR_MATRIX_NOT_SQUARE);
            }
            var n = m.length;
            var identity = Matrix.identity(n);
            var i;
            // AI
            for (i = 0; i < n; i++) {
                m[i] = m[i].concat(identity[i]);
            }
            // inv(IA)
            m = Matrix.GaussJordanEliminate(m);
            // inv(A)
            for (i = 0; i < n; i++) {
                m[i] = m[i].slice(n);
            }
            return m;
        };
        /**
         * 获取矩阵的某一列
         * Get a column of a matrix as a vector.
         *
         * @param {Array} matrix
         * @param {Int} column number
         * @return {Array} column
         */
        Matrix.getCol = function (M, n) {
            var result = new Array(M.length);
            if (n < 0) {
                throw new Error('The specified column must be a positive integer.');
            }
            else if (n >= M[0].length) {
                throw new Error('The specified column must be between 0 and the number of columns - 1.');
            }
            for (var i = 0; i < M.length; i++) {
                result[i] = M[i][n];
            }
            return result;
        };
        /**
         * 获取矩阵的某一行
         * Reorder the rows of a matrix based off an array of numbers.
         *
         * @param {Array} matrix
         * @param {Array} desired re-ordering
         * @return {Array} reordered matrix
         */
        Matrix.reorderRows = function (M, L) {
            var result = [];
            if (L === undefined) {
                throw new Error('A reordering array must be entered.');
            }
            else if (L.length !== M.length) {
                throw new Error('The reordered matrix must have the same number of rows as the original Matrix.');
            }
            for (var i = 0; i < L.length; i++) {
                if (L[i] < 0) {
                    throw new Error('The desired order of the rows must be positive integers.');
                }
                else if (L[i] >= L.length) {
                    throw new Error('The desired order of the rows must start at 0 and end at the number of rows - 1.');
                }
                else {
                    result.push(M[L[i]]);
                }
            }
            return result;
        };
        /**
         * Reorder the columns of a matrix based off an array of numbers.
         *
         * @param {Array} matrix
         * @param {Array} desired re-ordering
         * @return {Array} reordered matrix
         */
        Matrix.reorderCols = function (M, L) {
            var result = [];
            if (L === undefined) {
                throw new Error('Please enter a desired reordering array.');
            }
            else if (L.length !== M[0].length) {
                throw new Error('The reordered matrix must have the same number of columns as the original Matrix.');
            }
            for (var i = 0; i < L.length; i++) {
                if (L[i] < 0) {
                    throw new Error('The desired order of the columns must be positive integers.');
                }
                else if (L[i] >= L.length) {
                    throw new Error('The desired order of the columns must start at 0 and end at the number of columns - 1.');
                }
                else {
                    result.push(Matrix.getCol(M, L[i]));
                }
            }
            return Matrix.transpose(result);
        };
        /**
         * Reverse the rows of a Matrix.
         *
         * @param {Array} matrix
         * @return {Array} reversed matrix
         */
        Matrix.reverseRows = function (M) {
            var L = [];
            for (var i = M.length - 1; i > -1; i--) {
                L.push(i);
            }
            return Matrix.reorderRows(M, L);
        };
        /**
         * Reverse the columns of a Matrix.
         *
         * @param {Array} matrix
         * @return {Array} reversed matrix
         */
        Matrix.reverseCols = function (M) {
            var L = [];
            for (var i = M.length - 1; i > -1; i--) {
                L.push(i);
            }
            return Matrix.reorderCols(M, L);
        };
        /**
         * 创建 n*m 的0矩阵
         * Create a n x m matrix of zeros.
         *
         * @param {Int} number of rows
         * @param {Int} number of columns
         * @return {Array} matrix
         */
        Matrix.zeros = function (n, m) {
            var M = new Array(n);
            if (n < 1 || m < 1) {
                throw new Error('The matrix dimensions must be positive integers.');
            }
            n = Math.ceil(n);
            m = Math.ceil(m);
            for (var i = 0; i < n; i++) {
                var empty = new Array(m);
                for (var j = 0; j < m; j++) {
                    empty[j] = 0;
                }
                M[i] = empty;
            }
            return M;
        };
        /**
         * Create a zigzag Matrix. point represents the starting corner,
         * dir represents which direction to begin moving in. There are
         * 8 possible permutations for this. Rounds dimension upwards.
         *
         * @param {Int} size of (square) matrix
         * @param {String} corner (TL,TR,BL,BR)
         * @param {String} direction (V,H)
         * @return {Array} zigzag Matrix.
         */
        Matrix.zigzag = function (n, point, dir) {
            if (n <= 1) {
                throw new Error('Matrix size must be at least 2x2.');
            }
            n = Math.ceil(n);
            var mat = Matrix.zeros(n, n);
            //create one kind of permutation - all other permutations can be
            //created from this particular permutation through transformations
            var BRH = function (M) {
                var jump = false, tl = n * n, br = 1, inc = 1, row, col, val, i, j;
                M[0][0] = tl;
                M[n - 1][n - 1] = br;
                for (i = 1; i < n; i++) {
                    //generate top/bottom row
                    if (jump) {
                        tl -= 4 * inc;
                        br += 4 * inc;
                        inc++;
                    }
                    else {
                        tl--;
                        br++;
                    }
                    M[0][i] = tl;
                    M[n - 1][n - 1 - i] = br;
                    jump = !jump;
                }
                var dec = true;
                for (i = 1; i < n; i++) {
                    //iterate diagonally from top row
                    row = 0;
                    col = i;
                    val = M[row][col];
                    for (j = 1; j < i + 1; j++) {
                        if (dec) {
                            val -= 1;
                        }
                        else {
                            val += 1;
                        }
                        row++;
                        col--;
                        M[row][col] = val;
                    }
                    dec = !dec;
                }
                if (n % 2 === 0) {
                    dec = true;
                }
                else {
                    dec = false;
                }
                for (i = 1; i < n - 1; i++) {
                    //iterate diagonally from bottom row
                    row = n - 1;
                    col = i;
                    val = M[row][col];
                    for (j = 1; j < n - i; j++) {
                        if (dec) {
                            val--;
                        }
                        else {
                            val++;
                        }
                        row--;
                        col++;
                        M[row][col] = val;
                    }
                    dec = !dec;
                }
                return M;
            };
            var BRV = function (M) {
                return Matrix.transpose(BRH(M));
            };
            var BLH = function (M) {
                return Matrix.reverseCols(BRH(M));
            };
            var BLV = function (M) {
                return Matrix.reverseRows(TLV(BLH(M)));
            };
            var TRH = function (M) {
                return Matrix.reverseRows(BRH(M));
            };
            var TRV = function (M) {
                return Matrix.reverseRows(BRV(M));
            };
            var TLH = function (M) {
                return Matrix.reverseCols(Matrix.reverseRows(BRH(M)));
            };
            var TLV = function (M) {
                return Matrix.transpose(TLH(M));
            };
            if ((point === 'BR') && (dir === 'H')) {
                return (BRH(mat));
            }
            else if ((point === 'BR') && (dir === 'V')) {
                return (BRV(mat));
            }
            else if ((point === 'BL') && (dir === 'H')) {
                return (BLH(mat));
            }
            else if ((point === 'BL') && (dir === 'V')) {
                return (BLV(mat));
            }
            else if ((point === 'TR') && (dir === 'H')) {
                return (TRH(mat));
            }
            else if ((point === 'TR') && (dir === 'V')) {
                return (TRV(mat));
            }
            else if ((point === 'TL') && (dir === 'H')) {
                return (TLH(mat));
            }
            else if ((point === 'TL') && (dir === 'V')) {
                return (TLV(mat));
            }
            else {
                throw new Error('Enter the direction (V,H) and corner (BR,BL,TR,TL) correctly.');
            }
        };
        /**
         * Calculate the p-norm of a vector. Specific cases include:
         *   - Infinity (largest absolute entry)
         *   - -Infinity (smallest absolute entry)
         *
         * @param {Array} vector
         * @param {Number} the value of p (norm order)
         * @return {Number} the p-norm of v
         */
        Matrix.vectorNorm = function (v, p) {
            // calculate the p'th norm of a vector v
            if (!(Array.isArray(v)) || (v.length === 0)) {
                throw new Error('Vector must be an array of at least length 1.');
            }
            else if ((typeof p !== 'undefined') && (typeof p !== 'number')) {
                throw new Error('Norm order must be a number.');
            }
            p = (typeof p === 'undefined') ? 2 : p;
            var n = v.length;
            var ans = 0;
            var term;
            var i;
            switch (p) {
                case Infinity:
                    for (i = 0; i < n; i++) {
                        term = Math.abs(v[i]);
                        if (term > ans) {
                            ans = term;
                        }
                    }
                    break;
                case -Infinity:
                    ans = Infinity;
                    for (i = 0; i < n; i++) {
                        term = Math.abs(v[i]);
                        if (term < ans) {
                            ans = term;
                        }
                    }
                    break;
                default:
                    for (i = 0; i < n; i++) {
                        ans += Math.pow(Math.abs(v[i]), p);
                    }
                    ans = Math.pow(ans, 1 / p);
                    break;
            }
            return ans;
        };
        /**
         * Calculate the p-norm of a Matrix. Specific cases include:
         *   - Infinity (largest absolute row)
         *   - -Infinity (smallest absolute row)
         *   - 1 (largest absolute column)
         *   - -1 (smallest absolute column)
         *   - 2 (largest singular value)
         *   - -2 (smallest singular value)
         *   - null (Frobenius norm)
         *
         * @param {Array} vector
         * @param {Number} the value of p (norm order)
         * @return {Number} the p-norm of M
         */
        Matrix.matrixNorm = function (M, p) {
            if (!(Array.isArray(M)) || (M.length === 0) || !Array.isArray(M[0])) {
                throw new Error('Matrix must be an array of at least length 1.');
            }
            else if ((typeof p !== 'undefined') && (typeof p !== 'number') && (p !== null)) {
                throw new Error('Norm order must be a number or null.');
            }
            p = (typeof p === 'undefined') ? null : p;
            var //number of rows
            m = M.length;
            var //number of cols
            n = M[0].length;
            var ans = 0;
            var term;
            var i;
            var j;
            switch (p) {
                // the largest value when absolute-ing and summing each row
                case Infinity:
                    for (i = 0; i < m; i++) {
                        term = 0;
                        for (j = 0; j < n; j++) {
                            term += Math.abs(M[i][j]);
                        }
                        if (term > ans) {
                            ans = term;
                        }
                    }
                    break;
                // the smallest value when absolute-ing and summing each row
                case -Infinity:
                    ans = Infinity;
                    for (i = 0; i < m; i++) {
                        term = 0;
                        for (j = 0; j < n; j++) {
                            term += Math.abs(M[i][j]);
                        }
                        if (term < ans) {
                            ans = term;
                        }
                    }
                    break;
                // the largest value when absolute-ing and summing each column
                case 1:
                    for (i = 0; i < n; i++) {
                        term = 0;
                        for (j = 0; j < m; j++) {
                            term += Math.abs(M[j][i]);
                        }
                        if (term > ans) {
                            ans = term;
                        }
                    }
                    break;
                // the smallest value when absolute-ing and summing each column
                case -1:
                    ans = Infinity;
                    for (i = 0; i < n; i++) {
                        term = 0;
                        for (j = 0; j < m; j++) {
                            term += Math.abs(M[j][i]);
                        }
                        if (term < ans) {
                            ans = term;
                        }
                    }
                    break;
                // the Frobenius norm
                case null:
                    for (i = 0; i < m; i++) {
                        for (j = 0; j < n; j++) {
                            ans += Math.pow(M[i][j], 2);
                        }
                    }
                    ans = Math.pow(ans, 0.5);
                    break;
                // largest singular value
                case 2:
                    throw new Error("Singular values are not yet supported in numbers.js.");
                // smallest singular value
                case -2:
                    throw new Error("Singular values are not yet supported in numbers.js.");
                // entry-wise norm; analogous to that of the entry-wise vector norm.
                default:
                    for (i = 0; i < m; i++) {
                        for (j = 0; j < n; j++) {
                            ans += Math.pow(Math.abs(M[i][j]), p);
                        }
                    }
                    ans = Math.pow(ans, 1 / p);
            }
            return ans;
        };
        /**
         * Determines if a matrix has an upper bandwidth of q.
         *
         * @param {Array} matrix
         * @param {Number} upper bandwidth
         * @return {Boolean} true if upper bandwidth is q; false otherwise
         */
        Matrix.isUpperBand = function (M, q) {
            if (!Array.isArray(M) || !Array.isArray(M[0]) || M.length < 2) {
                throw new Error('Matrix must be an array of at least dimension 2.');
            }
            else if (typeof q !== 'number' || q < 0 || (q % 1) !== 0) {
                throw new Error('Upper bandwidth must be a nonzero integer.');
            }
            var result = true;
            var n = M[0].length;
            var cnt = 0;
            for (var i = q + 1; i < n; i++) {
                if (M[cnt][i] !== 0) {
                    result = false;
                    break;
                }
                cnt++;
            }
            return result;
        };
        /**
         * Determines if a matrix has an lower bandwidth of p.
         *
         * @param {Array} matrix
         * @param {Number} lower bandwidth
         * @return {Boolean} true if lower bandwidth is p; false otherwise
         */
        Matrix.isLowerBand = function (M, p) {
            if (!Array.isArray(M) || !Array.isArray(M[0]) || M.length < 2) {
                throw new Error('Matrix must be an array of at least dimension 2.');
            }
            else if (typeof p !== 'number' || p < 0 || (p % 1) !== 0) {
                throw new Error('Lower bandwidth must be a nonzero integer.');
            }
            var result = true;
            var m = M.length;
            var cnt = 0;
            for (var i = p + 1; i < m; i++) {
                if (M[i][cnt] !== 0) {
                    result = false;
                    break;
                }
                cnt++;
            }
            return result;
        };
        /**
         * Determines if a matrix is (weak) row diagonally-dominant.
         *
         * @param {Array} matrix
         * @return {Boolean} true if so, false otherwise.
         */
        Matrix.isRowDD = function (M) {
            var n = M.length;
            if (!Matrix.isSquare(M)) {
                throw new Error(Matrix.ERROR_MATRIX_NOT_SQUARE);
            }
            for (var i = 0; i < n; i++) {
                var row = M[i], diag = row[i], sum = sumNondiagonalElements(row, i);
                if (Math.abs(diag) < sum) {
                    return false;
                }
            }
            return true;
        };
        /**
         * Determines if a matrix is strictly row diagonally-dominant.
         *
         * @param {Array} matrix
         * @return {Boolean} true if so, false otherwise.
         */
        Matrix.isStrictlyRowDD = function (M) {
            if (!Matrix.isSquare(M)) {
                throw new Error(Matrix.ERROR_MATRIX_NOT_SQUARE);
            }
            var n = M.length;
            for (var i = 0; i < n; i++) {
                var row = M[i], diag = row[i], sum = sumNondiagonalElements(row, i);
                if (Math.abs(diag) <= sum) {
                    return false;
                }
            }
            return true;
        };
        /**
         * Determines if a matrix is (weak) column diagonally-dominant.
         *
         * @param {Array} matrix
         * @return {Boolean} true if so, false otherwise.
         */
        Matrix.isColumnDD = function (M) {
            if (!Matrix.isSquare) {
                throw new Error(Matrix.ERROR_MATRIX_NOT_SQUARE);
            }
            var n = M.length;
            for (var i = 0; i < n; i++) {
                var col = Matrix.getCol(M, i), diag = col[i], sum = sumNondiagonalElements(col, i);
                if (Math.abs(diag) < sum) {
                    return false;
                }
            }
            return true;
        };
        /**
         * Determines if a matrix is strictly column diagonally-dominant.
         *
         * @param {Array} matrix
         * @return {Boolean} true if so, false otherwise.
         */
        Matrix.isStrictlyColumnDD = function (M) {
            if (!Matrix.isSquare(M)) {
                throw new Error(Matrix.ERROR_MATRIX_NOT_SQUARE);
            }
            var n = M.length;
            for (var i = 0; i < n; i++) {
                var col = Matrix.getCol(M, i), diag = col[i], sum = sumNondiagonalElements(col, i);
                if (Math.abs(diag) <= sum) {
                    return false;
                }
            }
            return true;
        };
        Matrix.ERROR_MATRIX_NOT_SQUARE = 'Matrix must be square.';
        Matrix.ERROR_VECTOR_NOT_2D = 'Only two dimensional operations are supported at this time.';
        /**
       * 矩阵克隆
       * @param arr
       */
        Matrix.clone = Matrix.deepCopy;
        Matrix.add = Matrix.addition;
        return Matrix;
    }());
    /**
     * Add all of the elements in an array together except for the i'th one.
     * This is a helper function for determining diagonal dominance, and it
     * should be noted that each element is passed to Math.abs() beforehand.
     *
     * @param {Array} array
     * @param {Int} index of element to ignore.
     * @return {Number} sum.
     */
    var sumNondiagonalElements = function (arr, i) {
        var sum = 0, j;
        for (j = 0; j < i; j++) {
            sum += Math.abs(arr[j]);
        }
        for (j = i + 1; j < arr.length; j++) {
            sum += Math.abs(arr[j]);
        }
        return sum;
    };

    /**
     * 向量工具类
     */
    var Vector2DMath = /** @class */ (function () {
        function Vector2DMath(x, y) {
            if (x === void 0) { x = 0; }
            if (y === void 0) { y = 0; }
            this._x = x;
            this._y = y;
        }
        /**
         * 克隆
         * copy of the vector
         * @return	copy of the vector
         */
        Vector2DMath.prototype.clone = function () {
            return new Vector2DMath(this._x, this._y);
        };
        /**
         * 矢量的缩放
         * scaling of the vector
         * @param	k - scale coefficient
         * @return	scaled vector
         */
        Vector2DMath.prototype.scale = function (k) {
            this._x *= k;
            this._y *= k;
            return this;
        };
        /**
         * 向量加法
         * vector addition
         * @param	v	vector to add
         * @return	addition result
         */
        Vector2DMath.prototype.add = function (v) {
            this._x += v.x;
            this._y += v.y;
            return this;
        };
        /**
         * 矢量减法
         * vector substraction
         * @param	v	vector to substract
         * @return	substraction result
         */
        Vector2DMath.prototype.substract = function (v) {
            this._x -= v.x;
            this._y -= v.y;
            return this;
        };
        /**
         * 点积
         * dot product
         * @param	v	vector to multiply
         * @return	dot product of two vectors
         */
        Vector2DMath.prototype.dotProduct = function (v) {
            return this._x * v.x + this._y * v.y;
        };
        /**
         *
         * dot product of vectors with normalization of the second vector
         * @param	v	vector to multiply
         * @return	dot product of two vectors
         */
        Vector2DMath.prototype.dotProdWithNormalizing = function (v) {
            var normalized = v.clone().normalize();
            return this._x * normalized.x + this._y * normalized.y;
        };
        /**
         * 检查两个向量的垂直
         * check the perpendicularity of two vectors
         * @param	v	vector to check
         * @return	true - if they are perpendicular
         */
        Vector2DMath.prototype.isPerpendicular = function (v) {
            return Math.abs(this.dotProduct(v)) < Vector2DMath.EPSILON_SQUARED;
        };
        /**
         * 叉积
         * cross product
         * @param	v	vector to multiply
         * @return	the length of cross product of two vectors
         */
        Vector2DMath.prototype.crossProduct = function (v) {
            return this._x * v.y - this._y * v.x;
        };
        /**
         * 检查向量的并行
         * Check for parallelism of the vectors
         * @param	v	vector to check
         * @return	true - if they are parallel
         */
        Vector2DMath.prototype.isParallel = function (v) {
            return Math.abs(this.crossProduct(v)) < Vector2DMath.EPSILON_SQUARED;
        };
        /**
         * 检查矢量是否为0
         * Checking the vector for zero-length
         * @return	true - if the vector is zero
         */
        Vector2DMath.prototype.isZero = function () {
            return (Math.abs(this._x) < Vector2DMath.EPSILON && Math.abs(this._y) < Vector2DMath.EPSILON);
        };
        /**
         * 矢量初始化
         * Vector reset
         */
        Vector2DMath.prototype.zero = function () {
            this._x = this._y = 0;
        };
        /**
         * 矢量正常化（减少以单位长度）
         * Normalization of the vector (reduction to unit length)
         */
        Vector2DMath.prototype.normalize = function () {
            if (this.isZero()) {
                this._x = 1;
                return this;
            }
            return this.scale(1 / this.length);
        };
        /**
         * 检查向量单位长度
         * Check the vector for unit length
         */
        Vector2DMath.prototype.isNormalized = function () {
            return Math.abs(this.lengthSquared - 1) < Vector2DMath.EPSILON_SQUARED;
        };
        /**
         * 检查向量的平等
         * Checking for equality of vectors
         * @return	true - if the vectors are equal
         */
        Vector2DMath.prototype.equals = function (v) {
            return (Math.abs(this._x - v.x) < Vector2DMath.EPSILON && Math.abs(this._y - v.y) < Vector2DMath.EPSILON);
        };
        /**
         * 检查矢量的有效性
         * Checking the validity of the vector
         * @return	true - if the vector is valid
         */
        Vector2DMath.prototype.isValid = function () {
            return !isNaN(this._x) && !isNaN(this._y) && isFinite(this._x) && isFinite(this._y);
        };
        /**
         * 旋转向量对于给定的角
         * Rotate the vector for a given angle
         * @param	rads	angle to rotate
         * @return	rotated vector
         */
        Vector2DMath.prototype.rotate = function (rads) {
            var s = Math.sin(rads);
            var c = Math.cos(rads);
            var tempX = this._x;
            this._x = tempX * c - this._y * s;
            this._y = tempX * s + this._y * c;
            return this;
        };
        /**
         * 旋转与正弦旋转角的余弦和的值的矢量的矢量
         * Rotate the vector vector with the values of sine and cosine of the angle of rotation
         * @param	sin	the value of sine of the angle of rotation
         * @param	cos	the value of cosine of the angle of rotation
         * @return	rotated vector
         */
        Vector2DMath.prototype.rotateWithTrig = function (sin, cos) {
            var tempX = this._x;
            this._x = tempX * cos - this._y * sin;
            this._y = tempX * sin + this._y * cos;
            return this;
        };
        /**
         * 该向量相反的方向变化
         * Change direction of the vector to opposite
         */
        Vector2DMath.prototype.negate = function () {
            this._x *= -1;
            this._y *= -1;
            return this;
        };
        /**
         * 这一载体，以载体的投影被作为参数传递
         * The projection of this vector to vector that is passed as an argument
         * (without modifying the original Vector!)
         * @param	v	vector to project
         * @return	projection of the vector
         */
        Vector2DMath.prototype.projectTo = function (v) {
            var dp = this.dotProduct(v);
            var lenSq = v.lengthSquared;
            return new Vector2DMath(dp * v.x / lenSq, dp * v.y / lenSq);
        };
        /**
         * 投影这一载体上的归一化向量v
         * Projecting this vector on the normalized vector v
         * @param	v	this vector has to be normalized, ie have unit length
         * @return	projection of the vector
         */
        Vector2DMath.prototype.projectToNormalized = function (v) {
            var dp = this.dotProduct(v);
            return new Vector2DMath(dp * v.x, dp * v.y);
        };
        /**
         * perproduct - 左法线矢量和矢量v的内积
         * perproduct - dot product of left the normal vector and vector v
         */
        Vector2DMath.prototype.perpProduct = function (v) {
            return this.lx * v.x + this.ly * v.y;
        };
        /**
         * 发现这个矢量和v矢量的perpProducts之间的比率。这有助于找到交点
         * Find the ratio between the perpProducts of this vector and v vector. This helps to find the intersection point
         * @param	a	start point of the vector
         * @param	b	start point of the v vector
         * @param	v	the second vector
         * @return	the ratio between the perpProducts of this vector and v vector
         */
        Vector2DMath.prototype.ratio = function (a, b, v) {
            // Убеждаемся, что векторы this и v не параллельны
            if (this.isParallel(v))
                return NaN;
            // Убеждаемся, что оба вектора не нулевые
            if (this.lengthSquared < Vector2DMath.EPSILON_SQUARED || v.lengthSquared < Vector2DMath.EPSILON_SQUARED)
                return NaN;
            // Создаем третий вектор, соединяющий точки a и b
            var v3 = b.clone().substract(a);
            // находим и возвращаем ratio
            return v3.perpProduct(v) / this.perpProduct(v);
        };
        /**
         * 查找矢量交点
         * Finding the point of intersection of vectors
         * @param	a	start point of the vector
         * @param	b	start point of the v vector
         * @param	v	the second vector
         * @return the point of intersection of vectors
         */
        Vector2DMath.prototype.findIntersection = function (a, b, v) {
            var t = this.ratio(a, b, v);
            if (isNaN(t)) {
                // Векторы не пересекаются
                return new Vector2DMath(NaN, NaN);
            }
            return new Vector2DMath(a.x + t * this.x, a.y + t * this.y);
        };
        /**
         * 查找矢量交点，如果它是在载体的“界限”
         * Finding the point of intersection of vectors if it is in the "bounds" of the vectors
         * @param	a	start point of the vector
         * @param	b	start point of the v vector
         * @param	v	the second vector
         * @return the point of intersection of vectors if it is in the "bounds" of the vectors
         */
        Vector2DMath.prototype.findIntersectionInBounds = function (a, b, v) {
            var v4 = a.clone().substract(b);
            var t1 = this.ratio(a, b, v);
            var t2 = v.ratio(b, a, this);
            if (!isNaN(t1) && !isNaN(t2) && t1 > 0 && t1 <= 1 && t2 > 0 && t2 <= 1) {
                return new Vector2DMath(a.x + t1 * this.x, a.y + t1 * this.y);
            }
            return new Vector2DMath(NaN, NaN);
        };
        /**
         * 向量长度的限制
         * Length limit of the vector
         * @param	max	maximum length of this vector
         */
        Vector2DMath.prototype.truncate = function (max) {
            this.length = Math.min(max, this.length);
            return this;
        };
        /**
         * 向量之间的角度
         * The angle between vectors
         * @param	v	second vector, which we find the angle
         * @return	the angle in radians
         */
        Vector2DMath.prototype.angleBetween = function (v) {
            var v1 = this.clone();
            var v2 = v.clone();
            if (!this.isNormalized()) {
                v1.normalize();
            }
            if (!v.isNormalized()) {
                v2.normalize();
            }
            return Math.acos(v1.dotProduct(v2));
        };
        /**
         * 设置vectorat的两个分量一次
         * Set both components of the vectorat once
         * @param	a	horizontal component of the vector
         * @param	b	vertical component of the vector
         */
        Vector2DMath.prototype.setXY = function (a, b) {
            this._x = a;
            this._y = b;
        };
        /**
         * 半平面的角度相对于通过所述a和b点的符号的向量
         * The sign of half-plane of point with respect to the vector through the a and b points
         * @param	a	start point of the wall-vector
         * @param	b	end point of the wall-vector
         */
        Vector2DMath.prototype.sign = function (a, b) {
            return (a.x - this.x) * (b.y - this.y) - (a.y - this.y) * (b.x - this.x);
        };
        /**
         * 点之间的距离
         * The distance between points
         */
        Vector2DMath.prototype.dist = function (v) {
            return Math.sqrt(this.distSquared(v));
        };
        Vector2DMath.prototype.dist_XY = function (x_, y_) {
            var dx = x_ - this._x;
            var dy = y_ - this._y;
            return Math.sqrt(dx * dx + dy * dy);
        };
        /**
         * 点之间的平方距离
         * The squared distance between points
         */
        Vector2DMath.prototype.distSquared = function (v) {
            var dx = v.x - this._x;
            var dy = v.y - this._y;
            return (dx * dx + dy * dy);
        };
        /**
         * 点之间的平方距离
         * @param x_
         * @param y_
         * @return
         *
         */
        Vector2DMath.prototype.distSquared_XY = function (x_, y_) {
            var dx = x_ - this._x;
            var dy = y_ - this._y;
            return (dx * dx + dy * dy);
        };
        /**
         * Reflect the vector with respect to the normal of the "wall"
         * @param normal left normal of the "wall". It must be normalized (no checks)
         * @param bounceCoeff bounce coefficient (0 <= bounceCoeff <= 1)
         * @return reflected vector (angle of incidence equals to angle of reflection)
         */
        Vector2DMath.prototype.bounce = function (normal, bounceCoeff) {
            if (bounceCoeff === void 0) {
                bounceCoeff = 1;
            }
            var d = (1 + bounceCoeff) * this.dotProduct(normal);
            this._x -= d * normal.x;
            this._y -= d * normal.y;
            return this;
        };
        /**
         * 反映相对于所述正常的向量。此操作需要“摩擦”考虑
         * Reflect the vector with respect to the normal. This operation takes "friction" into account
         * @param normal left normal of the "wall". It must be normalized (no checks)
         * @param bounceCoeff bounce coefficient (0 <= bounceCoeff <= 1)
         * @param friction friction coefficient
         * @return reflected vector
         */
        Vector2DMath.prototype.bounceWithFriction = function (normal, bounceCoeff, friction) {
            if (bounceCoeff === void 0) {
                bounceCoeff = 1;
            }
            if (friction === void 0) {
                friction = 0;
            }
            var v1 = this.clone();
            var p1 = this.projectToNormalized(normal.rightNormal);
            var p2 = this.projectToNormalized(normal);
            var bounceX = -p2.x;
            var bounceY = -p2.y;
            var frictionX = p1.x;
            var frictionY = p1.y;
            this.x = bounceX * bounceCoeff + frictionX * friction;
            this.y = bounceY * bounceCoeff + frictionY * friction;
            return this;
        };
        Vector2DMath.prototype.toString = function () {
            return "[" + this._x + ", " + this._y + "]";
        };
        Object.defineProperty(Vector2DMath.prototype, "x", {
            /***************************************************
             *                              getter/setter
             ***************************************************/
            // 矢量的水平投影
            // horizontal projection of the vector
            get: function () {
                return this._x;
            },
            set: function (value) {
                this._x = value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Vector2DMath.prototype, "y", {
            // 该矢量的垂直投影
            // vertical projection of the vector
            get: function () {
                return this._y;
            },
            set: function (value) {
                this._y = value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Vector2DMath.prototype, "length", {
            // 该矢量的长度
            get: function () {
                return Math.sqrt(this._x * this._x + this._y * this._y);
            },
            set: function (len) {
                var a = this.angle;
                this._x = len * Math.cos(a);
                this._y = len * Math.sin(a);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Vector2DMath.prototype, "lengthSquared", {
            // 该矢量的长度的平方
            // length of the vector squared
            get: function () {
                return this._x * this._x + this._y * this._y;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Vector2DMath.prototype, "angle", {
            // 由矢量与水平轴线所成的角度
            // The angle formed by the vector with the horizontal axis
            get: function () {
                if (this.isZero())
                    return 0;
                return Math.atan2(this._y, this._x);
            },
            set: function (rads) {
                var len = this.length;
                this._x = len * Math.cos(rads);
                this._y = len * Math.sin(rads);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Vector2DMath.prototype, "dx", {
            // 单位矢量的水平分量
            get: function () {
                if (this.isZero())
                    return 0;
                return this._x / this.length;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Vector2DMath.prototype, "dy", {
            // 单位矢量的垂直分量
            get: function () {
                if (this.isZero())
                    return 0;
                return this._y / this.length;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Vector2DMath.prototype, "rightNormal", {
            // Right normal of the vector
            get: function () {
                return new Vector2DMath(-this._y, this._x);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Vector2DMath.prototype, "rx", {
            // The horizontal component of the right normal of the vector
            get: function () {
                return -this._y;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Vector2DMath.prototype, "ry", {
            // The vertical component of the right normal of the vector
            get: function () {
                return this._x;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Vector2DMath.prototype, "leftNormal", {
            // Left normal of the vector
            get: function () {
                return new Vector2DMath(this._y, -this._x);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Vector2DMath.prototype, "lx", {
            // 左侧正常矢量的水平分量
            // The horizontal component of the left normal of the vector
            get: function () {
                return this._y;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Vector2DMath.prototype, "ly", {
            // 左侧正常矢量的垂直分量
            // The vertical component of the left normal of the vector
            get: function () {
                return -this._x;
            },
            enumerable: false,
            configurable: true
        });
        Vector2DMath.EPSILON = 0.0000001;
        Vector2DMath.EPSILON_SQUARED = Vector2DMath.EPSILON * Vector2DMath.EPSILON;
        return Vector2DMath;
    }());

    var HashMap = /** @class */ (function () {
        function HashMap(dat) {
            this._data = {};
            this._data = dat !== null && dat !== void 0 ? dat : {};
        }
        HashMap.prototype.get = function (key) {
            var data = this._data[this._hash(key)];
            return data && data[1];
        };
        HashMap.prototype.find = function (key) {
            return this.get(key);
        };
        HashMap.prototype.set = function (key, value) {
            // Store original key as well (for iteration)
            this._data[this._hash(key)] = [key, value];
        };
        HashMap.prototype.insert = function (key, value) {
            this.set(key, value);
        };
        HashMap.prototype.put = function (key, value) {
            this.set(key, value);
        };
        HashMap.prototype.copy = function (other) {
            for (var key in other._data) {
                this._data[key] = other._data[key];
            }
        };
        HashMap.prototype.has = function (key) {
            return this._hash(key) in this._data;
        };
        HashMap.prototype.containsKey = function (key) {
            return this.has(key);
        };
        HashMap.prototype.search = function (value) {
            for (var key in this._data) {
                if (this._data[key][1] === value) {
                    return this._data[key][0];
                }
            }
            return null;
        };
        HashMap.prototype.remove = function (key) {
            delete this._data[this._hash(key)];
        };
        HashMap.prototype.type = function (key) {
            var str = Object.prototype.toString.call(key);
            var type = str.slice(8, -1).toLowerCase();
            // Some browsers yield DOMWindow for null and undefined, works fine on Node
            if (type === 'domwindow' && !key) {
                return key + '';
            }
            return type;
        };
        HashMap.prototype.keys = function () {
            var keys = [];
            this.forEach(function (value, key) { keys.push(key); });
            return keys;
        };
        HashMap.prototype.getKeySet = function () {
            return this.keys();
        };
        HashMap.prototype.values = function () {
            var values = [];
            this.forEach(function (value) { values.push(value); });
            return values;
        };
        HashMap.prototype.count = function () {
            return this.keys().length;
        };
        HashMap.prototype.size = function () {
            return this.count();
        };
        HashMap.prototype.clear = function () {
            this._data = {};
        };
        HashMap.prototype.clone = function () {
            return new HashMap(this._data);
        };
        /**
         *  (value, key)
         * @param func
         * @param ctx
         */
        HashMap.prototype.forEach = function (func, ctx) {
            for (var key in this._data) {
                var data = this._data[key];
                // data[1]为value, data[0]为key,  ctx作用域(如传入this)
                func.call(ctx || this, data[1], data[0]);
            }
        };
        HashMap.prototype.toString = function () {
            var str = "HashMap Content = \n";
            this.forEach(function (value, key) {
                str += key + " -> " + value + "\n";
            });
            return str;
        };
        HashMap.prototype.length = function () {
            return this.count();
        };
        HashMap.prototype.isEmpty = function () {
            return this.count() === 0;
        };
        HashMap.prototype.containsValue = function (value_) {
            var hasV_ = false;
            this.forEach(function (value, key) {
                if (value_ === value) {
                    hasV_ = true;
                    return false;
                }
            });
            return hasV_;
        };
        HashMap.prototype.getKeyValyeArray = function () {
            var arr_ = [];
            this.forEach(function (value, key) {
                arr_.push({ key: key, value: value });
            });
            return arr_;
        };
        HashMap.prototype._hash = function (key) {
            switch (this.type(key)) {
                case 'undefined':
                case 'null':
                case 'boolean':
                case 'number':
                case 'string':
                case 'regexp':
                    return key + '';
                case 'date':
                    return '♣' + key.getTime();
                case 'array':
                    var hashes = [];
                    for (var i = 0; i < key.length; i++) {
                        hashes[i] = this._hash(key[i]);
                    }
                    return '♥' + hashes.join('⁞');
                default:
                    if (!key.hasOwnProperty('_hmuid_')) {
                        key._hmuid_ = ++HashMap.uid;
                    }
                    return '♦' + key._hmuid_;
            }
        };
        return HashMap;
    }());

    /**
     * Created by wangchengjin on 16/5/11.
     * @class
     * @constructor
     */
    var MatrixMath = /** @class */ (function () {
        function MatrixMath(rows, cols) {
            /**
                   * Matrix array holder
                   */
            this.m = [];
            /**
             * Error flag
             */
            this.isError = false;
            /**
             * Error message holder
             */
            this.errorMes = "";
            /**
             * Helper variable. Used for calculation of determinant
             */
            this._det = 0.0;
            this.rows = rows;
            this.columns = cols;
            var numElements = rows * cols;
            var i;
            for (i = 0; i < numElements; i++) {
                this.m.push(0);
            }
        }
        /**
         * 定义为单位矩阵<br>
         * Defines this instance as an identity matrix
         */
        MatrixMath.prototype.identity = function () {
            this.isError = false;
            this.errorMes = "";
            if (this.rows != this.columns) {
                this.isError = true;
                this.errorMes = "Number of rows doesn't match number of columns";
                return;
            }
            var i;
            var j;
            for (i = 0; i < this.rows; i++) {
                for (j = 0; j < this.columns; j++) {
                    if (i == j)
                        this.m[j + i * this.columns] = 1;
                    else
                        this.m[j + i * this.columns] = 0;
                }
            }
        };
        /**
         * 矩阵乘法<br>
         * Matrices multiplication.
         * Resets this instance's _m property with the multiplication results
         * of this Matrix object and the passed Matrix object.
         * Number of columns of this matrix must be equal to number of rows of the second matrix.
         * Otherwise there will be error.
         * @param	m2 matrix-multiplier
         */
        MatrixMath.prototype.multiply = function (m2) {
            this.isError = false;
            this.errorMes = "";
            if (this.columns != m2.rows) {
                this.isError = true;
                this.errorMes = "Number of columns of the first matrix doesn't match with number of rows of the second matrix";
                return;
            }
            var m2NumCols2 = m2.columns;
            var tempMatr = new MatrixMath(this.rows, m2NumCols2);
            var i;
            var j;
            var k;
            for (i = 0; i < this.rows; i++) {
                for (j = 0; j < m2NumCols2; j++) {
                    for (k = 0; k < this.columns; k++) {
                        tempMatr.m[j + i * m2NumCols2] += this.m[k + i * this.columns] * m2.m[j + k * m2NumCols2];
                    }
                }
            }
            this.columns = m2NumCols2;
            this.m = tempMatr.m;
        };
        /**
         * 标量乘法<br>
         * Scalar multiplication
         * Scales this instance's _m elements by the passed value.
         */
        MatrixMath.prototype.scalar = function (s) {
            var numElements = this.rows * this.columns;
            var i;
            for (i = 0; i < numElements; i++) {
                this.m[i] *= s;
            }
        };
        /**
         * 矩阵加法<br>
         * Maxtrix addition.
         * Resets this instance's _m property with the addition results
         * of this Matrix object and the passed Matrix object.
         * Numbers of columns and rows of this matrix must be equal to numbers of columns and rows of the second matrix.
         * Otherwise there will be error.
         * @param	m2 matrix to add
         */
        MatrixMath.prototype.add = function (m2) {
            this.isError = false;
            this.errorMes = "";
            if (this.rows != m2.rows || this.columns != m2.columns) {
                this.isError = true;
                this.errorMes = "Number of columns and rows of the first matrix doesn't match with number of columns and rows of the second matrix";
                return;
            }
            var numElements = this.rows * this.columns;
            var i;
            for (i = 0; i < numElements; i++) {
                this.m[i] += m2.m[i];
            }
        };
        /**
         * 矩阵减法<br>
         * Maxtrix substraction.
         * Resets this instance's _m property with the substraction results
         * of this Matrix object and the passed Matrix object.
         * Numbers of columns and rows of this matrix must be equal to numbers of columns and rows of the second matrix.
         * Otherwise there will be error.
         * @param	m2 matrix to substract
         */
        MatrixMath.prototype.substract = function (m2) {
            this.isError = false;
            this.errorMes = "";
            if (this.rows != m2.rows || this.columns != m2.columns) {
                this.isError = true;
                this.errorMes = "Number of columns and rows of the first matrix doesn't match with number of columns and rows of the second matrix";
                return;
            }
            var numElements = this.rows * this.columns;
            var i;
            for (i = 0; i < numElements; i++) {
                this.m[i] -= m2.m[i];
            }
        };
        /**
         * 转置矩阵
         * Transpose this Matrix object
         */
        MatrixMath.prototype.transpose = function () {
            var tempMatr = new MatrixMath(this.columns, this.rows);
            var i;
            var j;
            for (i = 0; i < this.rows; i++) {
                for (j = 0; j < this.columns; j++) {
                    tempMatr.m[i + j * this.rows] = this.m[j + i * this.columns];
                }
            }
            return tempMatr;
        };
        /**
         * 转变为上三角矩阵(高斯消去转换)<br>
         * Gaussian elimination process. Will transform this matrix to upper triangular matrix.
         */
        MatrixMath.prototype.gaussElimination = function () {
            this.isError = false;
            this.errorMes = "";
            var pivotRow;
            var temp;
            this._det = 1;
            if (this.rows > this.columns - 1) {
                this.isError = true;
                this.errorMes = "This matrix doesn't represent any system of equations";
                return;
            }
            var i;
            var j;
            var k;
            for (i = 0; i < this.rows - 1; i++) {
                pivotRow = i;
                for (j = i + 1; j < this.rows; j++) {
                    if (Math.abs(this.m[i + j * this.columns]) > Math.abs(this.m[i + pivotRow * this.columns])) {
                        pivotRow = j;
                    }
                }
                this.swapRows(i, pivotRow);
                for (j = i + 1; j < this.rows; j++) {
                    if (this.m[i * (1 + this.columns)] == 0) {
                        this.isError = true;
                        this.errorMes = "This system of equations doesn't have any solution";
                        return;
                    }
                    temp = this.m[i + j * this.columns] / this.m[i * (1 + this.columns)];
                    for (k = i; k < this.columns; k++) {
                        this.m[k + j * this.columns] -= this.m[k + i * this.columns] * temp;
                    }
                }
            }
            if (this.m[(this.rows - 1) * (1 + this.columns)] == 0) {
                this.isError = true;
                this.errorMes = "This system of equations doesn't have any solution";
                return;
            }
        };
        /**
         * 逆矩阵<br>
         * Inverse Matrix Calculation
         * @return Iverted Matrix
         */
        MatrixMath.prototype.inverse = function () {
            this.isError = false;
            this.errorMes = "";
            var numRows = this.rows;
            var I = new MatrixMath(numRows, numRows);
            if (this.rows != this.columns) {
                I.resize(0, 0);
                I.isError = true;
                I.errorMes = "Number of rows doesn't match number of columns";
                return I;
            }
            var sum;
            var A = this.merge(I);
            var numCols = A.columns;
            var i;
            for (i = 0; i < numRows; i++) {
                A.m[(i + numRows) + i * numCols] = 1;
            }
            A.gaussElimination();
            if (A.isError) {
                I.resize(0, 0);
                I.isError = true;
                I.errorMes = A.errorMes;
                return I;
            }
            var column;
            var j;
            for (column = 0; column < numRows; column++) {
                for (i = numRows - 1; i >= 0; i--) {
                    sum = 0;
                    for (j = i + 1; j < numRows; j++) {
                        sum += A.m[j + i * numCols] * I.m[column + j * numRows];
                    }
                    I.m[column + i * numRows] = (A.m[column + numRows + i * numCols] - sum) / A.m[i * (1 + numCols)];
                }
            }
            return I;
        };
        /**
         *
         * Calculation of the determinant of this matrix with Gaussian elimination method. Matrix must be square.
         * @return determinant value
         */
        MatrixMath.prototype.gaussDeterminant = function () {
            this.isError = false;
            this.errorMes = "";
            if (this.rows != this.columns) {
                this.isError = true;
                this.errorMes = "Number of rows doesn't match number of columns";
                return null;
            }
            var numRows = this.rows;
            var A = this.merge(new MatrixMath(numRows, 1));
            A.gaussElimination();
            if (A.isError) {
                this.isError = true;
                this.errorMes = "Some unexpected error";
                return 0;
            }
            this._det = A.detMultiplier;
            var Acols = A.columns;
            var i;
            for (i = 0; i < numRows; i++) {
                this._det *= A.m[i * (1 + Acols)];
            }
            return this._det;
        };
        /**
         * 递归法计算	矩阵的行列式值(这种方法非常消耗处理器资源，并且不建议超过8×8)<br>
         * Calculation of the determinant of this matrix with recursive method.
         * This method is very processor-intensive, and not recommended for use with matrices over 8x8 elements
         * @return determinant value
         */
        MatrixMath.prototype.recursiveDeterminant = function () {
            this.isError = false;
            this.errorMes = "";
            if (this.rows != this.columns) {
                this.isError = true;
                this.errorMes = "Number of rows doesn't match number of columns";
                return null;
            }
            var numRows = this.rows;
            var det = 0;
            var part1;
            var part2;
            var tempMatr;
            var mult;
            var element;
            var i;
            if (numRows > 1) {
                for (i = 0; i < numRows; i++) {
                    element = this.m[i];
                    if (element != 0) {
                        (i % 2 == 0) ? mult = 1 : mult = -1;
                        if (i == 0) {
                            tempMatr = this.fragment(1, 1, numRows - 1, this.columns - 1);
                        }
                        else if (i == numRows - 1) {
                            tempMatr = this.fragment(1, 0, numRows - 1, this.columns - 2);
                        }
                        else {
                            part1 = this.fragment(1, 0, numRows - 1, i - 1);
                            part2 = this.fragment(1, i + 1, numRows - 1, this.columns - 1);
                            tempMatr = part1.merge(part2);
                        }
                        det += mult * element * tempMatr.recursiveDeterminant();
                    }
                }
            }
            else {
                det = this.m[0];
            }
            return det;
        };
        /**
         * 这个矩阵中指定位置插入一个矩阵<br>
         * Insertion of matrix in specified position of this matrix
         * @param	mat matrix to insert
         * @param	row row-position to insert the matrix
         * @param	col column-position to insert the matrix
         * @param	resize resize flag. Matrix size will be enhanced (when there is such need) if this parameter is true
         */
        MatrixMath.prototype.insert = function (mat, row, col, resize) {
            var oldRows = this.rows;
            var oldCols = this.columns;
            if (row >= oldRows || col >= oldCols)
                return;
            var newRows = row + mat.rows;
            var newCols = col + mat.columns;
            newRows = (newRows > oldRows) ? newRows : oldRows;
            newCols = (newCols > oldCols) ? newCols : oldCols;
            if (resize) {
                this.resize(newRows, newCols);
            }
            // Вставка значений из вставляемой матрицы
            newRows = row + mat.rows;
            newCols = col + mat.columns;
            var maxRow = (newRows <= this.rows) ? newRows : this.rows;
            var maxCol = (newCols <= this.columns) ? newCols : this.columns;
            var i;
            var j;
            for (i = row; i < maxRow; i++) {
                for (j = col; j < maxCol; j++) {
                    this.m[j + i * this.columns] = mat.m[(j - col) + (i - row) * mat.columns];
                }
            }
        };
        /**
         * 调整矩阵的大小<br>
         * Matrix resize method
         * @param	newRows new number of rows of this matrix
         * @param	newCols new number of columns of this matrix
         */
        MatrixMath.prototype.resize = function (newRows, newCols) {
            var oldRows = this.rows;
            var oldCols = this.columns;
            var tempMatr = new MatrixMath(newRows, newCols);
            var i, j;
            for (i = 0; i < newRows; i++) {
                if (i < oldRows) {
                    for (j = 0; j < newCols; j++) {
                        if (j < oldCols) {
                            tempMatr.m[j + i * newCols] = this.m[j + i * oldCols];
                        }
                    }
                }
            }
            this.rows = newRows;
            this.columns = newCols;
            this.m = tempMatr.m;
        };
        /**
         * 复制这个矩阵的一些片段<br>
         * Copy some fragment of this matrix
         */
        MatrixMath.prototype.fragment = function (startRow, startCol, endRow, endCol) {
            if (startRow > this.rows)
                startRow = this.rows;
            if (startCol > this.columns)
                startCol = this.columns;
            if (endRow > this.rows)
                endRow = this.rows;
            if (endCol > this.columns)
                endCol = this.columns;
            var tempNum;
            if (startRow > endRow) {
                tempNum = startRow;
                startRow = endRow;
                endRow = tempNum;
            }
            if (startCol > endCol) {
                tempNum = startCol;
                startCol = endCol;
                endCol = tempNum;
            }
            var tempMatrCols = endCol - startCol + 1;
            var tempMatr = new MatrixMath(endRow - startRow + 1, tempMatrCols);
            var i;
            var j;
            for (i = startRow; i <= endRow; i++) {
                for (j = startCol; j <= endCol; j++) {
                    tempMatr.m[j - startCol + (i - startRow) * tempMatrCols] = this.m[j + i * this.columns];
                }
            }
            return tempMatr;
        };
        /**
         * 合并矩阵<br>
         * Merge this matrix with matrix m2
         * @param	m2 matrix to merge
         * @return merged matrix
         */
        MatrixMath.prototype.merge = function (m2) {
            var secondRows = m2.rows;
            var secondCols = m2.columns;
            var firstRows = this.rows;
            var firstCols = this.columns;
            var tempMatrCols = firstCols + secondCols;
            var tempMatr = new MatrixMath(Math.max(firstRows, secondRows), tempMatrCols);
            var i;
            var j;
            for (i = 0; i < firstRows; i++) {
                for (j = 0; j < firstCols; j++) {
                    tempMatr.m[j + i * tempMatrCols] = this.m[j + i * firstCols];
                }
            }
            for (i = 0; i < secondRows; i++) {
                for (j = 0; j < secondCols; j++) {
                    tempMatr.m[j + firstCols + i * tempMatrCols] = m2.m[j + i * secondCols];
                }
            }
            return tempMatr;
        };
        /**
         * 把矩阵中的两行互换位置<br>
         * Swap two rows of this matrix
         */
        MatrixMath.prototype.swapRows = function (row1, row2) {
            if (row1 > this.rows || row2 > this.rows)
                return;
            if (row1 != row2) {
                this._det = -this._det;
                var tempNum = void 0;
                var j = void 0;
                for (j = 0; j < this.columns; j++) {
                    tempNum = this.m[j + row1 * this.columns];
                    this.m[j + row1 * this.columns] = this.m[j + row2 * this.columns];
                    this.m[j + row2 * this.columns] = tempNum;
                }
            }
        };
        /**
         * Defines each matrix element as a random number clamped between passed min-max values.
         */
        MatrixMath.prototype.random = function (a, b) {
            var numElements = this.rows * this.columns;
            var i;
            for (i = 0; i < numElements; i++) {
                this.m[i] = Math.round(Math.random() * (Math.max(a, b) - Math.min(a, b))) + Math.min(a, b);
            }
        };
        /**
         * 复制矩阵<br>
         * Copy this matrix
         */
        MatrixMath.prototype.clone = function () {
            var numElements = this.rows * this.columns;
            var tempMatr = new MatrixMath(this.rows, this.columns);
            var i;
            for (i = 0; i < numElements; i++) {
                tempMatr.m[i] = this.m[i];
            }
            return tempMatr;
        };
        /**
         * 设置指定位置的值<br>
         * Sets the element with specified value
         */
        MatrixMath.prototype.setElement = function (row, col, value) {
            if (row >= this.rows || col >= this.columns)
                return;
            this.m[col + row * this.columns] = value;
        };
        /**
         * 返回指定位置的值<br>
         * Gets the value of specified element
         */
        MatrixMath.prototype.getElement = function (row, col) {
            if (row >= this.rows || col >= this.columns)
                return NaN;
            return this.m[col + row * this.columns];
        };
        /**
         * 将二维向量转换为矩阵<br>
         * Sets the Matrix Object properties from two-dimensional Vector
         */
        MatrixMath.prototype.setMatrixFromRows = function (rowsVector) {
            var numRows = rowsVector.length;
            var numCols = rowsVector[0].length;
            var i;
            var j;
            for (i = 0; i < numRows; i++) {
                if (rowsVector[i].length != numCols)
                    return;
            }
            this.m.length = numRows * numCols;
            for (i = 0; i < numRows; i++) {
                for (j = 0; j < numCols; j++) {
                    this.m[j + i * numCols] = rowsVector[i][j];
                }
            }
            this.rows = numRows;
            this.columns = numCols;
        };
        /**
         * 把一维向量转换为矩阵<br>
         * Sets the Matrix Object properties from one-dimensional Vector and numbers of rows and columns
         */
        MatrixMath.prototype.setMatrixFromVector = function (matrixVector, numRows, numCols) {
            var numElements = numRows * numCols;
            if (numElements != matrixVector.length)
                return;
            var i;
            for (i = 0; i < numElements; i++) {
                this.m[i] = matrixVector[i];
            }
            this.rows = numRows;
            this.columns = numCols;
        };
        /**
         * 用于调试 - 跟踪Matrix对象<br>
         * Used for debugging -- traces the Matrix object.
         */
        MatrixMath.prototype.traceMatrix = function () {
            var row;
            var i;
            var j;
            for (i = 0; i < this.rows; i++) {
                row = "";
                for (j = 0; j < this.columns; j++) {
                    row += this.m[j + i * this.columns];
                    if (j < this.columns - 1)
                        row += "\t";
                }
            }
        };
        /**
         * 高斯法求解线性方程组<br>
         * Gaussian method for solving systems of linear equations.
         * @param	A matrix with variable's coefficients
         * @param	B matrix-row with free coefficients
         * @return matrix-row which contains values of variables
         */
        MatrixMath.GaussSolution = function (A, B) {
            var numRows = A.rows;
            var sum;
            // Матрица-столбец решения
            var x = new MatrixMath(numRows, 1);
            if (A.rows != A.columns || A.rows != B.rows || B.columns > 1 || B.columns == 0) {
                x.resize(0, 0);
                x.isError = true;
                x.errorMes = "Can't solve this system of equations";
                return x;
            }
            // Создание новой матрицы для преобразования к верхнетреугольному виду
            var tempMatr = A.merge(B);
            var tempMatrCols = tempMatr.columns;
            // Прямой ход метода Гаусса
            tempMatr.gaussElimination();
            if (tempMatr.isError) {
                x.resize(0, 0);
                x.isError = true;
                x.errorMes = tempMatr.errorMes;
                return x;
            }
            var i;
            var j;
            // Обратный ход метода Гаусса
            for (i = numRows - 1; i >= 0; i--) {
                sum = 0;
                for (j = i + 1; j < numRows; j++) {
                    sum += tempMatr.m[j + i * tempMatrCols] * x.m[j];
                }
                x.m[i] = (tempMatr.m[numRows + i * tempMatrCols] - sum) / tempMatr.m[i * (1 + tempMatrCols)];
            }
            return x;
        };
        /**
         * LUP分解法求解线性方程组<br>
         * LUP Decomposition method for solving systems of linear equations.
         * @param	A matrix with variable's coefficients
         * @param	P permutation matrix-row
         */
        MatrixMath.LUPDecomposition = function (A, P) {
            if (A.rows != A.columns)
                return;
            var numRows = A.rows;
            P.resize(numRows, 1);
            var i;
            var j;
            var k;
            for (i = 0; i < numRows; i++) {
                P.m[i] = i;
            }
            for (k = 0; k < numRows; k++) {
                var p = 0;
                var kk = void 0;
                for (i = k; i < numRows; i++) {
                    if (Math.abs(A.m[k + i * numRows]) > p) {
                        p = Math.abs(A.m[k + i * numRows]);
                        kk = i;
                    }
                }
                if (p == 0) {
                    A.isError = true;
                    A.errorMes = "Can't solve this system of equations";
                    return;
                }
                P.swapRows(k, kk);
                A.swapRows(k, kk);
                for (i = k + 1; i < numRows; i++) {
                    A.m[k + i * numRows] /= A.m[k * (1 + numRows)];
                    for (j = k + 1; j < numRows; j++) {
                        A.m[j + i * numRows] -= A.m[k + i * numRows] * A.m[j + k * numRows];
                    }
                }
            }
        };
        /**
         * LUP 解线性方程组
         * LUP Solution method for solving systems of linear equations. Must be used after LUP Decomposition method
         * @param	A matrix with variable's coefficients after decomposition
         * @param	P permutation matrix-row after decomposition
         * @param	B matrix-row with free coefficients of this system of linear equations
         * @return matrix-row which contains values of variables
         */
        MatrixMath.LUPSolution = function (A, P, B) {
            var numRows = A.rows;
            var sum;
            var i, j;
            var x = new MatrixMath(numRows, 1);
            if (A.isError || numRows != A.columns || numRows != P.rows || P.columns != 1 || numRows != B.rows || B.columns != 1) {
                x.resize(0, 0);
                x.isError = true;
                x.errorMes = "Can't solve this system of equations";
                return x;
            }
            for (i = 0; i < numRows; i++) {
                sum = 0;
                for (j = 0; j < i; j++) {
                    sum += A.m[j + i * numRows] * x.m[j];
                }
                x.m[i] = B.m[P.m[i]] - sum;
            }
            for (i = numRows - 1; i >= 0; i--) {
                sum = 0;
                for (j = i + 1; j < numRows; j++) {
                    sum += A.m[j + i * numRows] * x.m[j];
                }
                x.m[i] = (x.m[i] - sum) / A.m[i * (1 + numRows)];
            }
            return x;
        };
        /**
         * 克拉默法求解线性方程组(这种方法非常消耗处理器资源，并且不建议超过8×8)<br>
         * Cramer's method for solving systems of linear equations.
         * This method is very processor-intensive, and not recommended for use with matrices over 8x8 elements
         * @param	A matrix with variable's coefficients
         * @param	B matrix-row with free coefficients
         * @return matrix-row which contains values of variables
         */
        MatrixMath.CramerSolution = function (A, B) {
            var numRows = A.rows;
            var x = new MatrixMath(numRows, 1);
            var tempMatr;
            if (A.rows != A.columns || A.rows != B.rows || B.columns != 1) {
                x.resize(0, 0);
                x.isError = true;
                x.errorMes = "Can't solve this system of equations";
                return x;
            }
            var detA = A.recursiveDeterminant();
            if (detA == 0) {
                x.resize(0, 0);
                x.isError = true;
                x.errorMes = "The A matrix is not invertible. So I can't solve this system of equations";
                return x;
            }
            else {
                var i = void 0;
                for (i = 0; i < numRows; i++) {
                    tempMatr = A.clone();
                    tempMatr.insert(B, 0, i);
                    x.m[i] = tempMatr.recursiveDeterminant() / detA;
                }
            }
            return x;
        };
        return MatrixMath;
    }());

    var Mesh = global.PIXI ? global.PIXI.mesh.Mesh : function () {
    };
    /**
     * @class 绘制图形类,专为Bitmap填充
     * @param texture {String|Texture} 填充纹理
     * @param drawType_ 绘制的类型,如circle, rect
     * @param mess 跟drawType_关联的参数
     * @constructor
     */
    var GraphicsTexture = /** @class */ (function (_super) {
        __extends(GraphicsTexture, _super);
        function GraphicsTexture(texture, drawType_, mess_) {
            var _this = _super.call(this, texture) || this;
            _this.mess = mess_ || {};
            /***
             * 当drawtype为polygon时,的数据点
             * @type {Array}
             */
            _this.points = [];
            _this._ready = true;
            /**
             * 当drawtype为Rect时,图形的宽
             * @type {number}
             */
            _this.rectW = 10;
            /**
             * 当drawtype为Rect时,图形的高
             * @type {number}
             */
            _this.rectH = 10;
            /**
             * 当drawType为Circle时的半径
             * @type {number}
             */
            _this.radius = 10;
            /**
             * 画圆的切分精度
             * @type {number}
             */
            _this.total = 36;
            _this.drawType = drawType_ || GraphicsTexture.RECT;
            _this.drawMode = Mesh.DRAW_MODES.TRIANGLES;
            if (_this.drawType === GraphicsTexture.CRICLE) {
                _this.radius = _this.mess.r || 10;
                if (_this.radius > 300) {
                    _this.total *= 2;
                }
            }
            else if (_this.drawType === GraphicsTexture.RECT) {
                _this.rectW = _this.mess.w || 10;
                _this.rectH = _this.mess.h || 10;
            }
            else if (_this.drawType === GraphicsTexture.POLYGON) {
                if (!mess_ || !mess_.points || mess_.points.length < 3) {
                    throw new Error("输入数据有误");
                }
                _this.points = mess_.points;
            }
            _this.refresh();
            return _this;
        }
        /**
         * 更新绘制数据
         */
        GraphicsTexture.prototype.updateData = function () {
        };
        GraphicsTexture.prototype.drawCircle = function (r) {
            this.drawType = GraphicsTexture.CRICLE;
            this.radius = r;
        };
        GraphicsTexture.prototype.drawRect = function (w_, h_) {
            this.drawType = GraphicsTexture.RECT;
            this.rectW = w_;
            this.rectH = h_;
        };
        /**
         * Refreshes
         *
         */
        GraphicsTexture.prototype.refresh = function () {
            var verts = [0, 0]; //实际显示图像的坐标数组
            var colors = [];
            var uvs = []; //图像在贴图中的相对坐标点
            var indices = []; //分割的三角形数据
            var texture = this.texture;
            texture._updateUvs();
            if (this.drawType === GraphicsTexture.RECT) {
                $.each(texture._uvs, function (key, item) {
                    uvs.push(item);
                });
                //verts = [0, 0, this.rectW, 0, this.rectW, this.rectH, 0, this.rectH];
                verts = [0, 0, this.rectW, 0, 0, this.rectH, this.rectW, this.rectH];
                indices = [0, 1, 2, 1, 3, 2];
            }
            else if (this.drawType === GraphicsTexture.CRICLE) {
                var i;
                var ran = 0;
                var tuvs = texture._uvs;
                //var tw = tuvs.x1 - tuvs.x0;
                //var th = tuvs.y2 - tuvs.y0;
                var per = this.radius * 2 / texture.width;
                var tw = tuvs.x1 * per;
                var th = tuvs.y2 * per;
                var c = {
                    x: tuvs.x0 + tw / 2,
                    y: tuvs.y0 + th / 2
                }; //uvs圆心
                uvs.push(c.x, c.y);
                var r = tw / 2;
                var anc = Math.PI * 2 / this.total;
                for (i = 0; i < this.total; i++) {
                    var angle = ran;
                    var dx = this.radius * Math.cos(angle);
                    var dy = this.radius * Math.sin(angle);
                    var ux = r * Math.cos(angle);
                    var uy = r * Math.sin(angle);
                    ran += anc;
                    verts.push(dx, dy);
                    uvs.push((c.x + ux), (c.y + uy));
                    if (i > 1) {
                        indices.push(0, i - 1, i);
                    }
                }
                indices.push(0, this.total - 1, this.total, 0, this.total, 1);
            }
            else if (this.drawType == GraphicsTexture.POLYGON) {
                var top_1 = 1000000;
                var bottom = -1000000;
                var left = 10000000;
                var right = -100000;
                var i;
                /*if(this.points.length == 3){
                 var a = 10000; //上点
                 var b = 10000; //左点
                 var c =  -10000; //右点
                 var d = -10000; //下点
                 for(i = 0; i < this.points.length; i++){
                 var item = this.points[i];
                 verts.push(item.x, item.y);
                 if(item.y < a){
                 a = item.y;
                 }
                 if(item.y > d){
                 d = item.y;
                 }
                 if(item.x < b){
                 b = item.x;
                 }
                 if(item.x > c){
                 c = item.x;
                 }
                 }
                 top = a;

                 }else{*/
                //多边形上下左右的最高点
                verts = [];
                for (i = 0; i < this.points.length; i++) {
                    var obj = this.points[i];
                    obj.index = i;
                    verts.push(obj.x, obj.y);
                    if (i === 0) {
                        top_1 = bottom = obj.y;
                        left = right = obj.x;
                    }
                    else {
                        if (obj.x < left) {
                            left = obj.x;
                        }
                        if (obj.x > right) {
                            right = obj.x;
                        }
                        if (obj.y < top_1) {
                            top_1 = obj.y;
                        }
                        if (obj.y > bottom) {
                            bottom = obj.y;
                        }
                    }
                }
                //}
                //绘制图形的宽和高
                var pw = right - left;
                var ph = bottom - top_1;
                var tuvs = texture._uvs;
                var tw = tuvs.x1 - tuvs.x0;
                var th = tuvs.y2 - tuvs.y0;
                //根据比例计算uvs
                for (i = 0; i < this.points.length; i++) {
                    var obj = this.points[i];
                    var ux = (obj.x - left) / pw;
                    var uy = (obj.y - top_1) / ph;
                    uvs.push(tuvs.x0 + tw * ux, tuvs.y0 + th * uy);
                }
                if (this.points.length == 3) {
                    indices = [0, 1, 2];
                } /*else if(this.points.length == 4){
                 indices = [0, 1, 2, 1, 3, 2];
                 }*/
                else {
                    indices = this.createTriangles();
                }
            }
            this.vertices = new Float32Array(verts);
            this.uvs = new Float32Array(uvs);
            this.colors = new Float32Array(colors);
            this.indices = new Uint16Array(indices);
        };
        /**
         * 将多边形分割成三角形
         * @returns {Array}
         */
        GraphicsTexture.prototype.createTriangles = function () {
            var posArr = this.points.concat();
            var indices = [];
            var i = 0;
            var zheng = 0;
            var fu = 0;
            for (i = 0; i < posArr.length; i++) {
                var pa;
                var pb;
                var pc;
                if (i == 0) {
                    pa = posArr[posArr.length - 1];
                    pb = posArr[i];
                    pc = posArr[i + 1];
                }
                else if (i == posArr.length - 1) {
                    pa = posArr[i - 1];
                    pb = posArr[i];
                    pc = posArr[0];
                }
                else {
                    pa = posArr[i - 1];
                    pb = posArr[i];
                    pc = posArr[i + 1];
                }
                var value = this.cross(pa, pb, pc);
                if (!value) {
                    fu++;
                }
                else {
                    zheng++;
                }
            }
            //判断多边形方向
            var boo;
            if (zheng > fu) {
                boo = true;
            }
            else {
                boo = false;
            }
            i = 0;
            while (true) {
                if (posArr.length == 3) {
                    indices.push(posArr[0].index, posArr[1].index, posArr[2].index);
                    break;
                }
                if (i > posArr.length - 1) {
                    i = 0;
                }
                var pa;
                var pb;
                var pc;
                if (i == 0) {
                    pa = posArr[posArr.length - 1];
                    pb = posArr[i];
                    pc = posArr[i + 1];
                }
                else if (i == posArr.length - 1) {
                    pa = posArr[i - 1];
                    pb = posArr[i];
                    pc = posArr[0];
                }
                else {
                    pa = posArr[i - 1];
                    pb = posArr[i];
                    pc = posArr[i + 1];
                }
                var value = this.cross(pa, pb, pc);
                if (value != boo) {
                    i++;
                    continue;
                }
                //分割的三角形顶点
                var ta = void 0;
                var tb = void 0;
                var tc = void 0;
                if (i == 0) {
                    ta = posArr[posArr.length - 1];
                    tb = posArr[i];
                    tc = posArr[i + 1];
                }
                else if (i == posArr.length - 1) {
                    ta = posArr[i - 1];
                    tb = posArr[i];
                    tc = posArr[0];
                }
                else {
                    ta = posArr[i - 1];
                    tb = posArr[i];
                    tc = posArr[i + 1];
                }
                var j = void 0;
                var success = true;
                for (j = 0; j < posArr.length; j++) {
                    if (posArr[j] == ta || posArr[j] == tb || posArr[j] == tc)
                        continue;
                    if (this.isInsideTriangle(ta, tb, tc, posArr[j])) {
                        success = false;
                        i++;
                        break;
                    }
                }
                if (success) {
                    indices.push(ta.index, tb.index, tc.index);
                    posArr.splice(i, 1);
                }
            }
            return indices;
        };
        /**
         * p点是否包含在A,B,C点围成的三角形内
         * @param A
         * @param B
         * @param C
         * @param P
         * @returns {boolean}
         */
        GraphicsTexture.prototype.isInsideTriangle = function (A, B, C, P) {
            var planeAB = (A.x - P.x) * (B.y - P.y) - (B.x - P.x) * (A.y - P.y);
            var planeBC = (B.x - P.x) * (C.y - P.y) - (C.x - P.x) * (B.y - P.y);
            var planeCA = (C.x - P.x) * (A.y - P.y) - (A.x - P.x) * (C.y - P.y);
            return this.sign(planeAB) === this.sign(planeBC) && this.sign(planeBC) === this.sign(planeCA);
        };
        GraphicsTexture.prototype.sign = function (n) {
            return Math.abs(n) / n;
        };
        /**
         * 相邻两点的向量叉乘求点的凹凸性
         * @param pa
         * @param pb
         * @param pc
         * @returns {number}
         */
        GraphicsTexture.prototype.cross = function (pa, pb, pc) {
            return ((pb.x - pa.x) * (pc.y - pa.y) - (pb.y - pa.y) * (pc.x - pa.x)) > 0 ? true : false;
        };
        /**
         * Clear texture UVs when new texture is set
         *
         * @private
         */
        GraphicsTexture.prototype._onTextureUpdate = function () {
            _super.prototype._onTextureUpdate.call(this);
            // wait for the Plane ctor to finish before calling refresh
            if (this._ready) {
                this.refresh();
            }
        };
        GraphicsTexture.CRICLE = "circle";
        GraphicsTexture.RECT = "rect";
        GraphicsTexture.POLYGON = "polygon";
        return GraphicsTexture;
    }(Mesh));

    /**
     * Created by wangchengjin on 17/7/18.
     * class PIXI绘制扩展
     */
    var GraphicsUtil = /** @class */ (function () {
        function GraphicsUtil() {
        }
        /**
         * 画弧/扇形
         * @param g  PIXI.Graphics
         * @param x  圆心X
         * @param y  圆心Y
         * @param r  圆心半径
         * @param angle 圆心角
         * @param angleOfSlope起始点与最右端(X轴)的角度差 (默认为从最右端开始)
         */
        GraphicsUtil.drawArc = function (g, x, y, r, angle, angleOfSlope) {
            var newDot = [x, y];
            if (!angleOfSlope) {
                angleOfSlope = 0;
            }
            var aos = angleOfSlope * Math.PI / 180;
            var aos2 = (angleOfSlope + angle) * Math.PI / 180;
            var pstart = [newDot[0] + r * Math.cos(aos), newDot[1] + r * Math.sin(aos)]; //弧线的起点
            g.moveTo(pstart[0], pstart[1]);
            var pend = [newDot[0] + r * Math.cos(aos2), newDot[1] + r * Math.sin(aos2)]; //弧线的终点
            var pre = pstart;
            for (var i = 0; i < angle; i += 2) { //在angle范围内画弧
                var rad = (i + angleOfSlope) * Math.PI / 180;
                var cur = [r * Math.cos(rad) + newDot[0], r * Math.sin(rad) + newDot[1]];
                //
                g.moveTo(pre[0], pre[1]);
                g.lineTo(cur[0], cur[1]);
                if (g.filling) {
                    g.lineTo(newDot[0], newDot[1]);
                    g.lineTo(pre[0], pre[1]);
                }
                pre = cur;
            }
            g.lineTo(pend[0], pend[1]);
            if (g.filling) {
                g.lineTo(newDot[0], newDot[1]);
                g.lineTo(pre[0], pre[1]);
            }
        };
        return GraphicsUtil;
    }());

    var PromiseQueue = /** @class */ (function () {
        function PromiseQueue(promiseArr) {
            this.resultArr = [];
            this.__queuePromiseArr = promiseArr.slice();
        }
        PromiseQueue.prototype.run = function () {
            var _this = this;
            return new Promise(function (resolve, reject) {
                _this.resolve = resolve;
                _this.reject = reject;
                _this.__queueNext();
            });
        };
        PromiseQueue.prototype.__queueNext = function () {
            var _this = this;
            if (!this.__queuePromiseArr.length) {
                this.resolve(this.resultArr);
                return;
            }
            var onePromise = this.__queuePromiseArr.shift();
            onePromise.then(function (result) {
                _this.resultArr.push(result);
                _this.__queueNext();
            }).catch(this.reject);
        };
        return PromiseQueue;
    }());

    /**
     * dom工具类
     */
    var DomUtil = /** @class */ (function () {
        function DomUtil() {
        }
        /**
         * 检测 node 对象及其向根节点递归的对象是否包含 classname 类名
         * 一般用于判断是否点击在弹窗外面,如
         * M.addDomTouch(this.$dom, {
         *      end: (evt) => {
         *          const hasFlag = M.checkHasFlag(evt.target);
         *          if (!hasFlag) {
         *              // 点击在外面,进行隐藏
         *          }
         *      }
         *});
         * @param node  dom对象 | jquery对象
         * @param classname 类名字符串
         * @returns {boolean} 是否包含
         */
        DomUtil.checkHasFlag = function (node, classname) {
            node = node instanceof $ ? node : $(node);
            var hasFlag = false;
            var i = 0;
            while (i++ < 20) {
                var tagName = node && node[0] ? node[0].tagName : null;
                tagName = tagName ? tagName.toLowerCase() : tagName;
                if (!node || tagName === 'phy-app' || tagName === 'body') {
                    break;
                }
                else if (node.hasClass(classname)) {
                    hasFlag = true;
                    break;
                }
                else {
                    node = node.parent();
                }
            }
            return hasFlag;
        };
        return DomUtil;
    }());

    var FullscreenTool = /** @class */ (function () {
        function FullscreenTool() {
        }
        /**
         * 全屏功能
         * 整个网页: setFullscreen(document.documentElement)
         * 某个页面元素: setFullscreen(document.getElementById('videoElement'))
         * @param element 要放大的元素
         */
        FullscreenTool.setFullscreen = function (element) {
            if (!FullscreenTool.isFullscreenEnabled())
                return;
            // console.log('~~~~~setFullscreen');
            var el = element instanceof HTMLElement ? element : document.documentElement;
            var rfs = el.requestFullscreen ||
                el.webkitRequestFullscreen ||
                el.mozRequestFullScreen ||
                el.msRequestFullscreen;
            if (rfs) {
                rfs.call(el);
            }
            else if (window.ActiveXObject) {
                var ws = new window.ActiveXObject('WScript.Shell');
                if (ws)
                    ws.SendKeys('{F11}');
            }
            else {
                console.log('~~~Your browser is not supported setFullscreen');
            }
        };
        /**
         * 退出全屏
         */
        FullscreenTool.exitFullscreen = function () {
            if (!FullscreenTool.isFullscreenEnabled())
                return;
            // console.log('~~~~~exitFullscreen');
            var efs = document.exitFullscreen ||
                document.webkitExitFullscreen ||
                document.mozCancelFullScreen ||
                document.msExitFullscreen;
            if (efs) {
                efs.call(document);
            }
            else if (window.ActiveXObject) {
                var ws = new window.ActiveXObject('WScript.Shell');
                if (ws)
                    ws.SendKeys('{F11}');
            }
        };
        /**
         * isFullScreen 函数调用,检测全屏
         * @param element
         * @param method
         * @returns {*}
         */
        FullscreenTool._invokeFieldOrMethod = function (element, method) {
            var usablePrefixMethod;
            ['webkit', 'moz', 'ms', 'o', ''].forEach(function (prefix) {
                if (usablePrefixMethod)
                    return;
                if (prefix === '') {
                    // 无前缀，方法首字母小写
                    method = method.slice(0, 1).toLowerCase() + method.slice(1);
                }
                var typePrefixMethod = typeof element[prefix + method];
                if (typePrefixMethod + '' !== 'undefined') {
                    if (typePrefixMethod === 'function') {
                        usablePrefixMethod = element[prefix + method]();
                    }
                    else {
                        usablePrefixMethod = element[prefix + method];
                    }
                }
            });
            return usablePrefixMethod;
        };
        /**
         * 当前是否处于全屏
         * @returns {boolean}
         * @constructor
         */
        FullscreenTool.isFullScreen = function () {
            return FullscreenTool._invokeFieldOrMethod(document, 'FullScreen')
                || FullscreenTool._invokeFieldOrMethod(document, 'IsFullScreen')
                || document.IsFullScreen;
        };
        /**
         * 全屏/退出 切换
         * @param element 要全屏的元素
         * @returns {boolean} 返回当前状态
         */
        FullscreenTool.toggle = function (element) {
            var isFull = FullscreenTool.isFullScreen();
            if (isFull) {
                FullscreenTool.exitFullscreen();
            }
            else {
                FullscreenTool.setFullscreen(element);
            }
            return !isFull;
        };
        /**
         * 监听 dom 的全屏
         * 如:
         * 整个页面 FullscreenTool.addFullListener(document, ()=>{ ...})
         * 某一个div FullscreenTool.addFullListener(div, ()=>{ ...})
         *
         * @param dom
         * @param func
         * @returns {null}
         */
        FullscreenTool.addFullListener = function (dom, func) {
            if (!dom || !func) {
                console.error('~~~~dom 或者 func 为空');
                return null;
            }
            var id = NumberUtilities.getUnique();
            FullscreenTool._fullListenerMap[id] = {
                dom: dom,
                func: func
            };
            dom.addEventListener('webkitfullscreenchange', func);
            dom.addEventListener('mozfullscreenchange', func);
            dom.addEventListener('fullscreenchange', func);
            dom.addEventListener('MSFullscreenChange', func);
            return id;
        };
        /**
         * 移除指定 id 对应的全屏监听
         * 如 FullscreenTool.removeFullListener(xxxx)
         * @param id
         * @returns {boolean}
         */
        FullscreenTool.removeFullListener = function (id) {
            if (!FullscreenTool._fullListenerMap[id])
                return false;
            var _a = FullscreenTool._fullListenerMap[id], dom = _a.dom, func = _a.func;
            dom.removeEventListener('webkitfullscreenchange', func);
            dom.removeEventListener('mozfullscreenchange', func);
            dom.removeEventListener('fullscreenchange', func);
            dom.removeEventListener('MSFullscreenChange', func);
            delete FullscreenTool._fullListenerMap[id];
            return true;
        };
        /**
         * 是否存在指定 id 的全屏监听
         * @param id
         * @returns {boolean}
         */
        FullscreenTool.hasFullListener = function (id) {
            return !!FullscreenTool._fullListenerMap[id];
        };
        /************************************************************
         *                          假全屏功能(通过scale放大)
         * **********************************************************/
        /**
         * 全屏(假全屏功能专用)
         * @param element 要全屏的元素
         */
        FullscreenTool.setFullscreenFix = function (element) {
            var tempFullData = window.__temp_fix_full_data;
            if (!element)
                return;
            if (tempFullData)
                return;
            window.__temp_fix_full_data = {
                element: element,
                style: {
                    zIndex: element.style.zIndex || 'unset',
                    position: element.style.position || 'unset',
                    left: element.style.position || 'unset',
                    top: element.style.top || 'unset',
                    width: element.style.width || 'unset',
                    height: element.style.height || 'unset'
                },
                parent: $(element).parent()
            };
            var node = $(element).detach();
            // 放到body里
            $(document.body).append(node);
            // 计算其父节点缩放值
            $(element).css({
                zIndex: 9999,
                position: 'fixed',
                left: '0px',
                top: '0px',
                width: $(window).width() + 'px',
                height: $(window).height() + 'px'
            });
        };
        /**
         * 退出全屏(假全屏功能专用)
         */
        FullscreenTool.exitFullscreenFix = function () {
            var tempFullData = window.__temp_fix_full_data;
            if (!tempFullData)
                return;
            var style = tempFullData.style;
            var element = tempFullData.element;
            var parent = tempFullData.parent;
            var node = $(element).detach();
            parent.append(node);
            if (style && element)
                $(element).css(style);
            delete window.__temp_fix_full_data;
        };
        /**
         * 切换全屏(假全屏功能专用)
         * @param element
         */
        FullscreenTool.toggleFix = function (element) {
            if (!element)
                return;
            if (window.__temp_fix_full_data) {
                FullscreenTool.exitFullscreenFix();
            }
            else {
                FullscreenTool.setFullscreenFix(element);
            }
        };
        /**
         * 判断是否可以全屏
         */
        FullscreenTool.isFullscreenEnabled = function () {
            return (document['fullscreenEnabled'] ||
                document['mozFullScreenEnabled'] ||
                document['webkitFullscreenEnabled'] ||
                document['msFullscreenEnabled']);
        };
        FullscreenTool._fullListenerMap = {};
        return FullscreenTool;
    }());

    /*
     * File Created: Saturday, 29th August 2020 1:51:22 pm
     * Author: 王盛金 (wangshengjin@nobook.com)
     * ------------
     * 处理与touch相关的操作
     */
    var TouchUtil = /** @class */ (function () {
        function TouchUtil() {
        }
        /**
         * 获取鼠标全局坐标(在鼠标事件内部调用)
         * @param evt
         * @param touchType touch的三个列表touches, changedTouches, targetTouches;
         */
        TouchUtil.getMouseXY = function (evt, identifier, touchType) {
            if (identifier === undefined) {
                identifier = 0;
            }
            if (!touchType) {
                touchType = "changedTouches";
            }
            var p;
            if (evt.data && evt.data.global) {
                p = evt.data.global;
            }
            else if (evt.clientX === undefined) {
                // 为移动端
                var index = void 0;
                if (evt[touchType]) {
                    index = this.getIndexFromIdentifier(evt[touchType], identifier);
                    p = new Point(evt[touchType][index].clientX, evt[touchType][index].clientY);
                }
                else {
                    index = this.getIndexFromIdentifier(evt.originalEvent[touchType], identifier);
                    p = new Point(evt.originalEvent[touchType][index].clientX, evt.originalEvent[touchType][index].clientY);
                }
            }
            else {
                // 为pc端
                p = new Point(evt.clientX, evt.clientY);
            }
            return p.clone();
        };
        /**
         * 通过id查找touch索引
         * @param list
         * @param id
         * @returns {number}
         */
        TouchUtil.getIndexFromIdentifier = function (list, id) {
            var i = 0;
            for (i = 0; i < list.length; i++) {
                if (id === list[i].identifier) {
                    return i;
                }
            }
            return 0;
        };
        /**
         * 将Canvas的坐标转为pixi内的坐标格式
         * @param touch
         * @returns {}
         */
        TouchUtil.getCanvasPToMouseP = function (touch) {
            var p = this.getCanvasP(touch);
            var evt = {};
            evt.data = {};
            evt.data.global = new Point(p.x, p.y);
            evt.type = touch.type;
            return evt;
        };
        TouchUtil.getMousePToCanvasP = function (touch) {
            var p = this.getMouseXY(touch);
            var offObj = $("#canvasID").offset();
            var canvasP = new Point(offObj.left, offObj.top);
            var para = window.nb.PhysicsMain.ToolScale;
            var toP = new Point(p.x * para, p.y * para);
            toP.x += canvasP.x;
            toP.y += canvasP.y;
            var evt = {};
            evt.data = {};
            evt.data.global = new Point(toP.x, toP.y);
            evt.type = touch.type;
            return evt;
        };
        /**
         *获取 canvas 上鼠标点
         * @param evt  为 touch/mouse 的参数
         * @returns {*}
         */
        TouchUtil.getCanvasP = function (evt, identifier, touchType) {
            // 相对到canvas里的坐标
            var offObj = $("#canvasID").offset();
            var canvasP = new Point(offObj.left, offObj.top);
            // 相对于canvas的外部坐标
            var p = this.getMouseXY(evt, identifier, touchType);
            var toP = new Point(p.x - canvasP.x, p.y - canvasP.y);
            // 转换为canvas的内部坐标
            var nb = window.nb;
            toP.x = toP.x / nb.PhysicsMain.ToolScale;
            toP.y = toP.y / nb.PhysicsMain.ToolScale;
            return toP;
        };
        /**
         *获取 canvas 上鼠标点
         * @param evt  为 touch/mouse 的参数
         * @returns {*}
         */
        TouchUtil.getCanvasP_sdk = function (evt, identifier, touchType) {
            // 相对到canvas里的坐标
            // let offObj = $("#canvasID").offset();
            // let canvasP = new Point(offObj.left, offObj.top);
            var canvasP = new Point(0, 0);
            // 相对于canvas的外部坐标
            var p = this.getMouseXY(evt, identifier, touchType);
            var toP = new Point(p.x - canvasP.x, p.y - canvasP.y);
            return toP;
        };
        /**
         * 移除事件
         * @param funcObj
         */
        TouchUtil.removeTouch = function (funcObj) {
            if (funcObj && funcObj.target) {
                funcObj.target.removeEventListener('pointermove', funcObj.pointerMove);
                funcObj.target.removeEventListener('pointerup', funcObj.pointerUp);
                funcObj.target.removeEventListener('pointerdown', funcObj.pointerDown);
                funcObj.target.removeEventListener('click', funcObj.click);
            }
        };
        /**
         * 添加touch事件
         * @param target
         * @param options
         */
        TouchUtil.addTouch = function (target, options) {
            var funcObj = {
                target: target,
                pointerDown: function (evt) {
                    if (options.begin) {
                        options.begin(evt);
                    }
                    target.addEventListener('pointermove', funcObj.pointerMove);
                    target.addEventListener('pointerup', funcObj.pointerUp);
                },
                pointerMove: function (evt) {
                    if (options.move) {
                        options.move(evt);
                    }
                },
                pointerUp: function (evt) {
                    target.removeEventListener('pointermove', funcObj.pointerMove);
                    target.removeEventListener('pointerup', funcObj.pointerUp);
                    if (options.end) {
                        options.end(evt);
                    }
                },
                click: function (evt) {
                    if (options.click) {
                        options.click(evt);
                    }
                }
            };
            target.addEventListener('pointerdown', funcObj.pointerDown);
            target.addEventListener('click', funcObj.click);
            return funcObj;
        };
        return TouchUtil;
    }());

    /*
     * File Created: Saturday, 29th August 2020 3:34:40 pm
     * Author: 王盛金 (wangshengjin@nobook.com)
     * ------------
     * 操作颜色相关
     */
    var ColorUtil = /** @class */ (function () {
        function ColorUtil() {
        }
        /**
        * 0xFF0000 转换为如 #FF0000
        * @param color_
        * @returns {string}
        */
        ColorUtil.getDomColor = function (color_) {
            var hex = Number(color_).toString(16);
            var s = "#" + hex;
            return s;
        };
        return ColorUtil;
    }());

    /**
     * 曲线采样点压缩工具
     * 将曲线近似表示为一系列点，并减少点的数量
     */
    var CompressPointUtil = /** @class */ (function () {
        function CompressPointUtil() {
        }
        /**
         * 检查距离算法
         * @param param {坐标集合 points:[{x,y}],  追踪距离的阈值 epsilon}
         * @private
         */
        CompressPointUtil.traceDistance = function (param) {
            var points = param.points, epsilon = param.epsilon;
            if (points.length < 3)
                return points;
            var resArr = [points[0]];
            for (var i = 1; i < points.length - 1; i++) {
                var p = points[i];
                var len_ = M.getPointLen(resArr[resArr.length - 1], p);
                if (len_ > epsilon) {
                    resArr.push(p);
                }
            }
            resArr.push(points[points.length - 1]);
            return resArr;
        };
        /**
         * 道格拉斯-普克算法
         * @param param  {坐标集合 points:[{x,y}],  垂直检测距离的阈值 epsilon}
         * @private
         */
        CompressPointUtil.douglas = function (param) {
            var points = param.points, epsilon = param.epsilon;
            if (points.length < 3)
                return points;
            // 将曲线的首尾两点进行连线, 求中间的每一个点与这条直线的距离, 寻找最大距离
            // 遍历第2个点到倒数第2个点
            var disMax = 0; // 最大距离点
            var disMaxInd = 0; // 最大距离点的索引
            for (var i = 1; i < points.length - 3; i++) {
                if (!points[i] || !points[0] || !points[points.length - 1]) {
                    debugger;
                }
                var dis = M.getDisFrom3Dian(points[i], points[0], points[points.length - 1]); // 点到直线的距离
                if (dis > disMax) {
                    disMax = dis;
                    disMaxInd = i;
                }
            }
            // 分2中情况:
            //  1、若 disMax < epsilon，这条曲线上的中间点全部舍去
            //  2、若 disMax ≥ epsilon，则以该点为界，把曲线分为两部分,
            //     对这两部分曲线重复上述过程，直至所有的点都被处理完成
            if (disMax >= epsilon) {
                var resArr1 = CompressPointUtil.douglas({
                    points: points.slice(0, disMaxInd + 1),
                    epsilon: epsilon
                });
                var resArr2 = CompressPointUtil.douglas({
                    points: points.slice(disMaxInd, points.length),
                    epsilon: epsilon
                });
                return resArr1.slice(0, resArr1.length - 1).concat(resArr2);
            }
            return [points[0], points[points.length - 1]];
        };
        return CompressPointUtil;
    }());

    /**
     * 曼哈顿路由
     * 参考 https://www.processon.com/diagraming/5fa39c081e08534d5568a7e8
     * 使用方式:
     * const router = new ManhattanConnectionRouter();
     * const arr = router.caculate({
     *      fromPt: {x:10, y:10},
     *      fromDir: ManhattanConnectionRouter.RIGHT,
     *      toPt: {x:50, y:50},
     *      toDir: ManhattanConnectionRouter.LEFT
     *  });
     *  console.log(arr);
     */
    var ManhattanConnectionRouter = /** @class */ (function () {
        function ManhattanConnectionRouter() {
            this.MINDIST = 20; // 拐弯时与本地的间隔
            this.TOL = 0.01; // 判断2个点的x或y是否相等的阈值
        }
        /**
         * 曼哈顿路由路径
         * @param param {fromPt 起始点, fromDir 起始方向, toPt 终止点, toDir 终止方向}
         * @return arr 路径点数组
         */
        ManhattanConnectionRouter.prototype.caculate = function (param) {
            if (!param.fromPt || !param.toPt)
                return null;
            param.fromPt = M.getSPPoint(param.fromPt);
            param.toPt = M.getSPPoint(param.toPt);
            //
            var arr = [];
            var fromPt = param.fromPt, fromDir = param.fromDir, toPt = param.toPt, toDir = param.toDir;
            this.route(arr, fromPt, fromDir, toPt, toDir);
            return arr;
        };
        /**
         * 递归前进,每次前进一步
         * @param arr 经过计算返回的路径点
         * @param fromPt 起始点
         * @param fromDir 起始方向
         * @param toPt 终止点
         * @param toDir 终止方向
         * @private
         */
        ManhattanConnectionRouter.prototype.route = function (arr, fromPt, fromDir, toPt, toDir) {
            var result = this.routeBody(arr, M.getSPPoint(fromPt), fromDir, M.getSPPoint(toPt), toDir);
            if (!result)
                return;
            var point = result.point, dir = result.dir;
            // 递归调用
            this.route(arr, point, dir, toPt, toDir);
        };
        /**
         * 算法主体,前进一步
         * @param arr
         * @param fromPt
         * @param fromDir
         * @param toPt
         * @param toDir
         * @private
         */
        ManhattanConnectionRouter.prototype.routeBody = function (arr, fromPt, fromDir, toPt, toDir) {
            var _a = ManhattanConnectionRouter.DIRECTION, UP = _a.UP, RIGHT = _a.RIGHT, DOWN = _a.DOWN, LEFT = _a.LEFT;
            var xDiff = fromPt.x - toPt.x;
            var yDiff = fromPt.y - toPt.y;
            var point = null;
            var dir = null;
            var pos = null;
            if (((xDiff * xDiff) < (this.TOL)) && ((yDiff * yDiff) < (this.TOL))) {
                // 到达终点则结束
                arr.push(toPt);
                return null;
            }
            if (fromDir === LEFT) {
                if ((xDiff > 0) && ((yDiff * yDiff) < this.TOL) && (toDir === RIGHT)) {
                    point = toPt;
                    dir = toDir;
                }
                else {
                    if (xDiff < 0) {
                        point = new Point(fromPt.x - this.MINDIST, fromPt.y);
                    }
                    else if (((yDiff > 0) && (toDir === DOWN)) || ((yDiff < 0) && (toDir === UP))) {
                        point = new Point(toPt.x, fromPt.y);
                    }
                    else if (fromDir === toDir) {
                        //
                        pos = Math.min(fromPt.x, toPt.x) - this.MINDIST;
                        point = new Point(pos, fromPt.y);
                    }
                    else {
                        point = new Point(fromPt.x - (xDiff / 2), fromPt.y);
                    }
                    if (yDiff > 0) {
                        dir = UP;
                    }
                    else {
                        dir = DOWN;
                    }
                }
            }
            else if (fromDir === RIGHT) {
                if ((xDiff < 0) && ((yDiff * yDiff) < this.TOL) && (toDir === LEFT)) {
                    point = toPt;
                    dir = toDir;
                }
                else {
                    if (xDiff > 0) {
                        point = new Point(fromPt.x + this.MINDIST, fromPt.y);
                    }
                    else if (((yDiff > 0) && (toDir === DOWN)) || ((yDiff < 0) && (toDir === UP))) {
                        point = new Point(toPt.x, fromPt.y);
                    }
                    else if (fromDir === toDir) {
                        pos = Math.max(fromPt.x, toPt.x) + this.MINDIST;
                        point = new Point(pos, fromPt.y);
                    }
                    else {
                        point = new Point(fromPt.x - (xDiff / 2), fromPt.y);
                    }
                    if (yDiff > 0) {
                        dir = UP;
                    }
                    else {
                        dir = DOWN;
                    }
                }
            }
            else if (fromDir === DOWN) {
                if (((xDiff * xDiff) < this.TOL) && (yDiff < 0) && (toDir === UP)) {
                    point = toPt;
                    dir = toDir;
                }
                else {
                    if (yDiff > 0) {
                        point = new Point(fromPt.x, fromPt.y + this.MINDIST);
                    }
                    else if (((xDiff > 0) && (toDir === RIGHT)) || ((xDiff < 0) && (toDir === LEFT))) {
                        point = new Point(fromPt.x, toPt.y);
                    }
                    else if (fromDir === toDir) {
                        pos = Math.max(fromPt.y, toPt.y) + this.MINDIST;
                        point = new Point(fromPt.x, pos);
                    }
                    else {
                        point = new Point(fromPt.x, fromPt.y - (yDiff / 2));
                    }
                    if (xDiff > 0) {
                        dir = LEFT;
                    }
                    else {
                        dir = RIGHT;
                    }
                }
            }
            else if (fromDir === UP) {
                if (((xDiff * xDiff) < this.TOL) && (yDiff > 0) && (toDir === DOWN)) {
                    point = toPt;
                    dir = toDir;
                }
                else {
                    if (yDiff < 0) {
                        point = new Point(fromPt.x, fromPt.y - this.MINDIST);
                    }
                    else if (((xDiff > 0) && (toDir === RIGHT)) || ((xDiff < 0) && (toDir === LEFT))) {
                        point = new Point(fromPt.x, toPt.y);
                    }
                    else if (fromDir === toDir) {
                        pos = Math.min(fromPt.y, toPt.y) - this.MINDIST;
                        point = new Point(fromPt.x, pos);
                    }
                    else {
                        point = new Point(fromPt.x, fromPt.y - (yDiff / 2));
                    }
                    if (xDiff > 0) {
                        dir = LEFT;
                    }
                    else {
                        dir = RIGHT;
                    }
                }
            }
            // 先放入保证顺序正确
            arr.push(fromPt);
            return {
                point: point,
                dir: dir
            };
        };
        Object.defineProperty(ManhattanConnectionRouter, "UP", {
            // 方向: 向上
            get: function () {
                return 0;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ManhattanConnectionRouter, "RIGHT", {
            // 方向: 向右
            get: function () {
                return 1;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ManhattanConnectionRouter, "DOWN", {
            // 方向: 向下
            get: function () {
                return 2;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ManhattanConnectionRouter, "LEFT", {
            // 方向: 向左
            get: function () {
                return 3;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ManhattanConnectionRouter, "DIRECTION", {
            // 获取四个方向
            get: function () {
                return {
                    UP: ManhattanConnectionRouter.UP,
                    RIGHT: ManhattanConnectionRouter.RIGHT,
                    DOWN: ManhattanConnectionRouter.DOWN,
                    LEFT: ManhattanConnectionRouter.LEFT
                };
            },
            enumerable: false,
            configurable: true
        });
        return ManhattanConnectionRouter;
    }());

    /**
     * 三次样条插值
     * 插值（interpolation）是在已知部分数据节点（knots）的情况下，求解经过这些已知点的曲线，
     * 然后根据得到的曲线进行未知位置点函数值预测的方法（未知点在上述已知点自变量范围内）。
     * 参考: https://blog.csdn.net/daduzimama/article/details/90477388
     */
    var CubicSpline = /** @class */ (function () {
        function CubicSpline() {
        }
        /**
         * 执行计算
         * @param controlPoints 采样数据[Point]
         * @param parts 分的段数
         * @return 曲线点的数组
         */
        CubicSpline.prototype.generate = function (controlPoints, parts) {
            // 一个点不能计算
            if (!controlPoints || controlPoints.length === 1)
                return controlPoints;
            var cp = __spreadArrays([
                controlPoints[0]
            ], controlPoints, [
                controlPoints[controlPoints.length - 1]
            ]);
            var n = cp.length;
            var spline = [];
            spline.push(controlPoints[0]);
            spline.push(this.p(1, 0, cp));
            for (var i = 1; i < n - 2; i++) {
                for (var j = 1; j <= parts; j++) {
                    spline.push(this.p(i, j / parts, cp));
                }
            }
            spline.push(controlPoints[controlPoints.length - 1]);
            return spline;
        };
        CubicSpline.prototype.p = function (i, t, cp) {
            var x = 0.0;
            var y = 0.0;
            var k = i - 1;
            for (var j = -2; j <= 1; j++) {
                var b = this.blend(j, t);
                var p = cp[k++];
                x += b * p.x;
                y += b * p.y;
            }
            return new Point(x, y);
        };
        CubicSpline.prototype.blend = function (i, t) {
            if (i === -2)
                return (((-t + 3) * t - 3) * t + 1) / 6;
            else if (i === -1)
                return (((3 * t - 6) * t) * t + 4) / 6;
            else if (i === 0)
                return (((-3 * t + 3) * t + 3) * t + 1) / 6;
            return (t * t * t) / 6;
        };
        return CubicSpline;
    }());

    /**
     * 样条路由
     */
    var SplineConnectionRouter = /** @class */ (function (_super) {
        __extends(SplineConnectionRouter, _super);
        function SplineConnectionRouter() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.SPLINE_PARTS = 8; // 分几段
            _this.spline = new CubicSpline();
            return _this;
        }
        /**
         *
         * @param param {fromPt 起始点, fromDir 起始方向, toPt 终止点, toDir 终止方向}
         * @return 路径点数组
         */
        SplineConnectionRouter.prototype.caculate = function (param) {
            var fromPt = param.fromPt, fromDir = param.fromDir, toPt = param.toPt, toDir = param.toDir;
            var arr = [];
            // 先由曼哈顿路由计算出拐点
            this.route(arr, fromPt, fromDir, toPt, toDir);
            arr.reverse();
            //
            return this.spline.generate(arr, this.SPLINE_PARTS);
        };
        return SplineConnectionRouter;
    }(ManhattanConnectionRouter));

    /**
     * 曼哈顿避障路由(会改变终点方向)
     * 参考 https://www.processon.com/diagraming/5fa39c081e08534d5568a7e8
     * 使用方式:
     * const router = new ManhattanConnectionRouter();
     * const arr = router.caculate({
     *      fromPt: {x:10, y:10},
     *      fromDir: ManhattanConnectionRouter.RIGHT,
     *      toPt: {x:50, y:50},
     *      toDir: ManhattanConnectionRouter.LEFT,
     *      obstaclesRects: [
     *          new Rectangle(130, 30, 40, 40)
     *      ]
     *  });
     *  console.log(arr);
     */
    var BlockConnectionRouter = /** @class */ (function (_super) {
        __extends(BlockConnectionRouter, _super);
        function BlockConnectionRouter() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.DEBUG = false;
            return _this;
        }
        BlockConnectionRouter.prototype.print = function () {
            var rest = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                rest[_i] = arguments[_i];
            }
            if (this.DEBUG) {
                console.log.apply(console, rest);
            }
        };
        /**
         * 曼哈顿避障路由路径
         * @param param {fromPt 起始点, fromDir 起始方向, toPt 终止点, toDir 终止方向}
         * @return arr 路径点数组
         */
        BlockConnectionRouter.prototype.caculate = function (param) {
            var _this = this;
            if (!param.fromPt || !param.toPt)
                return null;
            param.fromPt = M.getSPPoint(param.fromPt);
            param.toPt = M.getSPPoint(param.toPt);
            //
            var arr = [];
            var fromPt = param.fromPt, fromDir = param.fromDir, toPt = param.toPt, toDir = param.toDir, obstaclesRects = param.obstaclesRects;
            this.print('---------------');
            this.print('formPt:', M.getSPPoint(fromPt).toString(), '  fromDir: ', fromDir);
            this.print('toPt: ', M.getSPPoint(toPt).toString(), '  toDir: ', toDir);
            var obs = [];
            if (obstaclesRects) {
                obstaclesRects.map(function (rect) {
                    if (!rect.containsPoint(fromPt) && !rect.containsPoint(toPt)) {
                        obs.push(rect);
                        _this.print('障碍矩形: ', rect.x, rect.y, rect.width, rect.height);
                    }
                });
            }
            this.route(arr, fromPt, fromDir, toPt, toDir, obs);
            return arr;
        };
        /**
         * 递归前进,每次前进一步
         * @param arr 经过计算返回的路径点
         * @param fromPt 起始点
         * @param fromDir 起始方向
         * @param toPt 终止点
         * @param toDir 终止方向
         * @param obstaclesRects 路障矩形数组[Rectangle]
         * @private
         */
        BlockConnectionRouter.prototype.route = function (arr, fromPt, fromDir, toPt, toDir, obstaclesRects) {
            this.print('~route: ', fromPt, fromDir, toPt, toDir);
            var result = _super.prototype.routeBody.call(this, arr, fromPt, fromDir, toPt, toDir);
            if (!result)
                return;
            var point = result.point, dir = result.dir;
            // 进行避障处理
            // 求此线与矩形的交点,返回交点与相交的矩形
            var _a = this.getInterP(fromPt, fromDir, point, dir, obstaclesRects), interP = _a.interP, obstaclesRect = _a.obstaclesRect;
            if (interP) {
                // 有交点,则执行绕过处理(添加2个拐点, 并改向)
                var result_1 = this.moveP(arr, interP, fromPt, fromDir, point, dir, toPt, obstaclesRect, obstaclesRects);
                dir = result_1.dir;
                point = result_1.point;
                toDir = result_1.endDir; // 改变终点方向
            }
            // 递归调用
            this.route(arr, point, dir, toPt, toDir, obstaclesRects);
        };
        /**
         * 获取直线 <fromPt,point> 与 obstaclesRects 的距离fromPt最近交点
         * @param fromPt
         * @param fromDir
         * @param point
         * @param dir
         * @param obstaclesRects
         */
        BlockConnectionRouter.prototype.getInterP = function (fromPt, fromDir, point, dir, obstaclesRects) {
            var _this = this;
            // 寻找距离起始点最短距离的矩形点
            var minLen = Number.MAX_VALUE;
            var minInterP = null;
            var obstaclesRect = null; // 相交的矩形
            obstaclesRects.map(function (rect) {
                // p1、p2、p3、p4顺序为左右上下四点
                var p1 = fromPt;
                var p2 = point;
                var p3;
                var p4;
                var interP;
                // 起始点方向
                switch (fromDir) {
                    case BlockConnectionRouter.LEFT:
                        // 起始点向左,取矩形右侧上下点
                        p3 = new Point(rect.x + rect.width, rect.y);
                        p4 = new Point(rect.x + rect.width, rect.y + rect.height);
                        interP = _this.getIntersection(p1, p2, p3, p4);
                        break;
                    case BlockConnectionRouter.RIGHT:
                        // 起始点向右,取矩形左侧上下点
                        p3 = new Point(rect.x, rect.y);
                        p4 = new Point(rect.x, rect.y + rect.height);
                        interP = _this.getIntersection(p1, p2, p3, p4);
                        break;
                    case BlockConnectionRouter.DOWN:
                        // 起始点向下,取矩形上侧左右点
                        p3 = new Point(rect.x, rect.y);
                        p4 = new Point(rect.x + rect.width, rect.y);
                        interP = _this.getIntersection(p3, p4, p1, p2);
                        break;
                    case BlockConnectionRouter.UP:
                        // 起始点向上,取矩形下侧左右点
                        p3 = new Point(rect.x, rect.y + rect.height);
                        p4 = new Point(rect.x + rect.width, rect.y + rect.height);
                        interP = _this.getIntersection(p3, p4, p1, p2);
                        break;
                }
                if (!interP)
                    return;
                var len = M.getPointLen(p1, interP);
                if (len < minLen) {
                    minLen = len;
                    minInterP = interP;
                    obstaclesRect = rect;
                }
            });
            return {
                interP: minInterP,
                obstaclesRect: obstaclesRect
            };
        };
        /**
         * 对曼哈顿中的一步进行跨步计算
         * 平移 fromPt 及重新设定 point,暂不考虑多个矩形的迭代检测
         * 如果一个矩形不能穿透,则认为失败,使用原来的曼哈顿算法(虽然重叠,起码能用,让用户手动改吧)
         * @param arr 计算的结果路径点
         * @param interP 交点
         * @param fromPt  当前步出发点
         * @param fromDir 当前步出发方向
         * @param point 当前步结束点
         * @param dir 当前步结束方向
         * @param toPt 最后的终点
         * @param interRect
         * @param obstaclesRects
         */
        BlockConnectionRouter.prototype.moveP = function (arr, interP, fromPt, fromDir, point, dir, toPt, interRect, obstaclesRects) {
            var _a = BlockConnectionRouter.DIRECTION, UP = _a.UP, RIGHT = _a.RIGHT, DOWN = _a.DOWN, LEFT = _a.LEFT;
            // 起始点方向的矩形间距是否小于 MINDIST (如果起始点与交点间距小于间隔,则直接取间隔)
            var isFromDisMin = false; // 起始间距小于 MINDIST
            var isEndDisMin = false; // 终止间距小于 MINDIST
            this.print('->move: ', fromPt.toString(), interP.toString(), fromDir);
            var xp1; // 交点距离矩形逆时针第一个矩形角的点
            var xp2; // 交点距离矩形逆时针第二个矩形角的点
            var xp3; // 交点距离矩形逆时针第三个矩形角的点
            var xp4; // 交点距离矩形逆时针第四个矩形角的点
            // 起始点方向
            switch (fromDir) {
                case LEFT:
                    // 起始点朝左
                    // 如果起始间距小于 MINDIST, 取最小间距
                    isFromDisMin = fromPt.x - interP.x < this.MINDIST;
                    // 如果终止间距小于 MINDIST, 取最小间距
                    isEndDisMin = interRect.x - point.x < this.MINDIST;
                    // 起始点朝左,交点向右移动间隔 fromDIS
                    if (isFromDisMin) {
                        // 不向右移动间隔了,直接使用起始点
                        xp1 = new Point(fromPt.x, interRect.y - this.MINDIST);
                    }
                    else {
                        // 起始点朝左,交点向右移动 MINDIST
                        xp1 = new Point(interP.x + this.MINDIST, interRect.y - this.MINDIST);
                    }
                    if (isEndDisMin) {
                        // 直接使用终止点
                        xp2 = new Point(point.x, xp1.y);
                    }
                    else {
                        xp2 = new Point(interRect.x - this.MINDIST, xp1.y);
                    }
                    xp3 = new Point(xp2.x, interRect.y + interRect.height + this.MINDIST);
                    xp4 = new Point(xp1.x, xp3.y);
                    break;
                case RIGHT:
                    // 起始点朝右
                    // 如果起始间距小于 MINDIST, 取最小间距
                    isFromDisMin = interP.x - fromPt.x < this.MINDIST;
                    // 如果终止间距小于 MINDIST, 取最小间距
                    isEndDisMin = point.x - (interRect.x + interRect.width) < this.MINDIST;
                    if (isFromDisMin) {
                        xp1 = new Point(fromPt.x, interRect.y + interRect.height + this.MINDIST);
                    }
                    else {
                        xp1 = new Point(interP.x - this.MINDIST, interRect.y + interRect.height + this.MINDIST);
                    }
                    if (isEndDisMin) {
                        // 直接使用终止点
                        xp2 = new Point(point.x, xp1.y);
                    }
                    else {
                        xp2 = new Point(interRect.x + interRect.width + this.MINDIST, xp1.y);
                    }
                    xp3 = new Point(xp2.x, interRect.y - this.MINDIST);
                    xp4 = new Point(xp1.x, xp3.y);
                    break;
                case DOWN:
                    // 起始点朝下
                    // 如果起始间距小于 MINDIST, 取最小间距
                    isFromDisMin = interP.y - fromPt.y < this.MINDIST;
                    // 如果终止间距小于 MINDIST, 取最小间距
                    isEndDisMin = point.y - (interRect.y + interRect.height) < this.MINDIST;
                    if (isFromDisMin) {
                        xp1 = new Point(interRect.x - this.MINDIST, fromPt.y);
                    }
                    else {
                        xp1 = new Point(interRect.x - this.MINDIST, interP.y - this.MINDIST);
                    }
                    if (isEndDisMin) {
                        // 直接使用终止点
                        xp2 = new Point(xp1.x, point.y);
                    }
                    else {
                        xp2 = new Point(xp1.x, interRect.y + interRect.height + this.MINDIST);
                    }
                    xp3 = new Point(interRect.x + interRect.width + this.MINDIST, xp2.y);
                    xp4 = new Point(xp3.x, xp1.y);
                    break;
                case UP:
                    // 起始点朝上
                    // 如果起始间距小于 MINDIST, 取最小间距
                    isFromDisMin = fromPt.y - interP.y < this.MINDIST;
                    // 如果终止间距小于 MINDIST, 取最小间距
                    isEndDisMin = interRect.y - point.y < this.MINDIST;
                    if (isFromDisMin) {
                        xp1 = new Point(interRect.x + interRect.width + this.MINDIST, fromPt.y);
                    }
                    else {
                        xp1 = new Point(interRect.x + interRect.width + this.MINDIST, interP.y + this.MINDIST);
                    }
                    if (isEndDisMin) {
                        // 直接使用终止点
                        xp2 = new Point(xp1.x, point.y);
                    }
                    else {
                        xp2 = new Point(xp1.x, interRect.y - this.MINDIST);
                    }
                    xp3 = new Point(interRect.x - this.MINDIST, xp2.y);
                    xp4 = new Point(xp3.x, xp1.y);
                    break;
            }
            var len12 = M.getPointLen(toPt, xp1); // 第1个点距离终点的距离(权重)
            var len43 = M.getPointLen(toPt, xp4); // 第4个点距离终点的距离(权重)
            var inter12 = this.checkIntersectLR(xp1, xp2, obstaclesRects); // 检测线段<xp1, xp2>是否与其他矩形有交点
            var inter43 = this.checkIntersectLR(xp4, xp3, obstaclesRects); // 检测线段<xp4, xp3>是否与其他矩形有交点
            var type = -1; // 1 选上方, 2 先下方
            if (inter12 && inter43) {
                // TODO 两边都没通过,则不做处理, 待游湖
                return {
                    point: point,
                    dir: dir
                };
            }
            else if (inter43) {
                // 12方向绕过
                type = 1;
            }
            else if (inter12) {
                // 43方向绕过
                type = 2;
            }
            else {
                // 12,43方向绕过(选距离小的)
                type = len12 <= len43 ? 1 : 2;
            }
            if (type === 1) {
                // 12方向绕过
                if (!isFromDisMin)
                    arr.push(interP);
                arr.push(xp1);
                point = xp2;
                dir = fromDir - 1 < 0 ? 3 : fromDir - 1;
            }
            else {
                // 43方向绕过
                if (!isFromDisMin)
                    arr.push(interP);
                arr.push(xp4);
                point = xp3;
                dir = fromDir + 1 > 3 ? 0 : fromDir + 1;
            }
            var endDir = dir > 1 ? dir - 2 : dir + 2; // 将终点方向改为相对
            return {
                point: point,
                dir: dir,
                endDir: endDir
            };
        };
        /**
         * 检测直线 <p1, p2> 是否与矩形数组 rects 中的矩形有交点
         * @param p1
         * @param p2
         * @param rects
         */
        BlockConnectionRouter.prototype.checkIntersectLR = function (p1, p2, rects) {
            // 是否为纵向直线
            var isV = (p1.x - p2.x) * (p1.x - p2.x) < this.TOL;
            var isInter = false;
            for (var _i = 0, rects_1 = rects; _i < rects_1.length; _i++) {
                var rect = rects_1[_i];
                if (isV) {
                    isInter = isInter && this.getIntersection(new Point(rect.x, rect.y), new Point(rect.x + rect.width, rect.y), p1, p2);
                    isInter = isInter && this.getIntersection(new Point(rect.x, rect.y + rect.height), new Point(rect.x + rect.width, rect.y + rect.height), p1, p2);
                }
                else {
                    isInter = isInter && this.getIntersection(p1, p2, new Point(rect.x, rect.y), new Point(rect.x, rect.y + rect.height));
                    isInter = isInter && this.getIntersection(p1, p2, new Point(rect.x + rect.width, rect.y), new Point(rect.x + rect.width, rect.y + rect.height));
                }
                if (isInter)
                    break;
            }
            return isInter;
        };
        /**
         * 返回两条正交直线 <p1,p2>与<p3,p4> 的交点
         * <p1,p2> 为横线, <p3,p4> 为竖线
         * p1、p2、p3、p4顺序为左右上下四点(不分顺序)
         * @param p1
         * @param p2
         * @param p3
         * @param p4
         */
        BlockConnectionRouter.prototype.getIntersection = function (p1, p2, p3, p4) {
            // 如果相交,则交点为 interP
            var interP = new Point(p3.x, p1.y);
            // interP 的 y 不在直线 <p3,p4> 之间, 则交点无效
            if (!this.inMid(interP.y, p3.y, p4.y))
                return null;
            // interP 的 x 不在直线 <p1,p2> 之间, 则交点无效
            if (!this.inMid(interP.x, p1.x, p2.x))
                return null;
            return interP;
        };
        /**
         * a 是否在 b,c 之间
         * @param a
         * @param b
         * @param c
         */
        BlockConnectionRouter.prototype.inMid = function (a, b, c) {
            return (a < b && a > c) || (a < c && a > b);
        };
        return BlockConnectionRouter;
    }(ManhattanConnectionRouter));

    /*
     * @module:
     * @Descripttion:
     * @Author: jinxueqiang
     * @Date: 2021-12-03 14:01:38
     * @LastEditors: jinxueqiang
     * @LastEditTime: 2021-12-06 09:56:44
     * 参考
     * 		 https://blog.csdn.net/daduzimama/article/details/90477388 (高次有龙格现象现象)
     *     https://blog.csdn.net/daduzimama/article/details/90477388
     *     https://www.cnblogs.com/xpvincent/archive/2013/01/26/2878092.html
     * 使用方式
     * const sl = new Spline([points]);
     * x处y值: sl.get(x);
     *
     * 三次样条原理:
     * 假设4个点, (x0,y0)、(x1,y1)、(x2,y2)、(x3,y3)、, 有3个区间, 需要3个三次样条, 每个三次样条为  ax^3+bx^2+cx+d=0, 故总计12个未知数。
     * 		a1x^3+b1x^2+c1x+d1 = 0  1导 3a1x^2+2b1x+c1 2导 6a1x+2b1
     * 		a2x^3+b2x^2+c2x+d2 = 0  1导 3a2x^2+2b2x+c2 2导 6a2x+2b2
     * 		a3x^3+b3x^2+c3x+d3 = 0  1导 3a3x^2+2b3x+c3 2导 6a3x+2b3
     *
     * 1. 内部节点处的函数值应该相等，这里一共是4个方程 (x1与x2各2个方程, 共4个方程)
     * 2. 函数的第一个端点和最后一个端点，应该分别在第一个方程和最后一个方程中(x0与x3各1个方程, 共2个方程)
     * 3. 两个函数在节点处的一阶导数应该相等。这里是两个方程。(中间点处必须连续，需要保证左右二次函数一阶导相等) (2个方程)
     * 		3a1x^2+2b1x+c1 = 3a2x^2+2b2x+c2
     * 		3a2x^2+2b2x+c2 = 3a3x^2+2b3x+c3
     *
     * 4. 两个函数在节点处的二阶导数应该相等(一阶导数的变化率、即函数图像的凹凸性) (2个方程)
     * 		6a1x+2b1 = 6a2x+2b2
     * 		6a2x+2b2 = 6a3x+2b3
     *
     * 5. 假设端点处的二阶导数为零,即此处为函数凹凸拐点 (2个方程)
     *    a1=0
     *    b1=0
     *
     *    总共 4+2+2+2+2 = 12 个方程
     */
    var Spline = /** @class */ (function () {
        /**
         * 坐标数组(数组会按照x升序排列)
         * @param points [{x, y}]
         */
        function Spline(points) {
            var _this = this;
            this.xs = [];
            this.ys = [];
            points.sort(function (a, b) { return a.x - b.x; }).map(function (p, i) {
                _this.xs[i] = p.x;
                _this.ys[i] = p.y;
            });
            this.ks = this.getNaturalKs(new Float64Array(this.xs.length));
        }
        Spline.prototype.getNaturalKs = function (ks) {
            var n = this.xs.length - 1;
            var A = this.zerosMat(n + 1, n + 2);
            for (var i = 1; i < n; i++ // rows
            ) {
                A[i][i - 1] = 1 / (this.xs[i] - this.xs[i - 1]);
                A[i][i] =
                    2 *
                        (1 / (this.xs[i] - this.xs[i - 1]) + 1 / (this.xs[i + 1] - this.xs[i]));
                A[i][i + 1] = 1 / (this.xs[i + 1] - this.xs[i]);
                A[i][n + 1] =
                    3 *
                        ((this.ys[i] - this.ys[i - 1]) /
                            ((this.xs[i] - this.xs[i - 1]) * (this.xs[i] - this.xs[i - 1])) +
                            (this.ys[i + 1] - this.ys[i]) /
                                ((this.xs[i + 1] - this.xs[i]) * (this.xs[i + 1] - this.xs[i])));
            }
            A[0][0] = 2 / (this.xs[1] - this.xs[0]);
            A[0][1] = 1 / (this.xs[1] - this.xs[0]);
            A[0][n + 1] =
                (3 * (this.ys[1] - this.ys[0])) /
                    ((this.xs[1] - this.xs[0]) * (this.xs[1] - this.xs[0]));
            A[n][n - 1] = 1 / (this.xs[n] - this.xs[n - 1]);
            A[n][n] = 2 / (this.xs[n] - this.xs[n - 1]);
            A[n][n + 1] =
                (3 * (this.ys[n] - this.ys[n - 1])) /
                    ((this.xs[n] - this.xs[n - 1]) * (this.xs[n] - this.xs[n - 1]));
            return this.solve(A, ks);
        };
        /**
         * 参考 https://stackoverflow.com/a/40850313/4417327
         */
        Spline.prototype.getIndexBefore = function (target) {
            var low = 0;
            var high = this.xs.length;
            var mid = 0;
            while (low < high) {
                mid = Math.floor((low + high) / 2);
                if (this.xs[mid] < target && mid !== low) {
                    low = mid;
                }
                else if (this.xs[mid] >= target && mid !== high) {
                    high = mid;
                }
                else {
                    high = low;
                }
            }
            return low + 1;
        };
        /**
         * 获取x坐标处的y值
         * @param x 坐标x
         * @returns
         */
        Spline.prototype.at = function (x) {
            var i = this.getIndexBefore(x);
            var t = (x - this.xs[i - 1]) / (this.xs[i] - this.xs[i - 1]);
            var a = this.ks[i - 1] * (this.xs[i] - this.xs[i - 1]) -
                (this.ys[i] - this.ys[i - 1]);
            var b = -this.ks[i] * (this.xs[i] - this.xs[i - 1]) +
                (this.ys[i] - this.ys[i - 1]);
            var q = (1 - t) * this.ys[i - 1] +
                t * this.ys[i] +
                t * (1 - t) * (a * (1 - t) + b * t);
            return q;
        };
        Spline.prototype.solve = function (A, ks) {
            var m = A.length;
            var h = 0;
            var k = 0;
            while (h < m && k <= m) {
                var i_max = 0;
                var max = -Infinity;
                for (var i = h; i < m; i++) {
                    var v_1 = Math.abs(A[i][k]);
                    if (v_1 > max) {
                        i_max = i;
                        max = v_1;
                    }
                }
                if (A[i_max][k] === 0) {
                    k++;
                }
                else {
                    this.swapRows(A, h, i_max);
                    for (var i = h + 1; i < m; i++) {
                        var f = A[i][k] / A[h][k];
                        A[i][k] = 0;
                        for (var j = k + 1; j <= m; j++)
                            A[i][j] -= A[h][j] * f;
                    }
                    h++;
                    k++;
                }
            }
            for (var i = m - 1; i >= 0; i-- // rows = columns
            ) {
                var v = 0;
                if (A[i][i]) {
                    v = A[i][m] / A[i][i];
                }
                ks[i] = v;
                for (var j = i - 1; j >= 0; j-- // rows
                ) {
                    A[j][m] -= A[j][i] * v;
                    A[j][i] = 0;
                }
            }
            return ks;
        };
        Spline.prototype.zerosMat = function (r, c) {
            var A = [];
            for (var i = 0; i < r; i++)
                A.push(new Float64Array(c));
            return A;
        };
        Spline.prototype.swapRows = function (m, k, l) {
            var p = m[k];
            m[k] = m[l];
            m[l] = p;
        };
        return Spline;
    }());

    /**
     * 链表节点
     */
    var LinkedListNode = /** @class */ (function () {
        function LinkedListNode(userData) {
            this.next = null; // 后驱
            this.userData = userData;
        }
        LinkedListNode.prototype.connect = function (node) {
            this.next = node;
        };
        return LinkedListNode;
    }());

    /**
     * 并查集节点(适用于电学连接断开的拓扑图)
     * 解决图论中「动态连通性」问题,判断两个顶点p、q是否连通,可以用于检测图中是否存在环
     * 参考: https://zhuanlan.zhihu.com/p/98406740?from_voters_page=true
     * https://leetcode-cn.com/problems/satisfiability-of-equality-equations/solution/union-find-suan-fa-ying-yong-by-labuladong/
     */
    var UnionFindNode = /** @class */ (function () {
        function UnionFindNode(userData) {
            // 父节点,初始化时,父节点指向自己
            this.parent = this;
            this.userData = userData;
        }
        /**
         * 将当前节点与节点 q 连接
         * 会把两者的根节点连接,形成一个集合
         * 注: 请尽量让q节点为小树节点,因电路拓扑图涉及到节点断开,固此处
         *  不再做合并优化,优化会在调用 getRoot() 时处理
         * @param q 另一个并查集节点
         */
        UnionFindNode.prototype.connect = function (q) {
            var curRoot = this.getRoot();
            var qRoot = q.getRoot();
            qRoot.parent = curRoot;
        };
        /**
         * 断开与上一级的连接
         */
        UnionFindNode.prototype.disConnected = function () {
            this.parent = this;
        };
        /**
         * 判断当前节点与节点 q 是否连通
         * 判断两者是否为同一个集合
         * @param q 另一个并查集节点
         */
        UnionFindNode.prototype.checkConnected = function (q) {
            return this.getRoot() === q.getRoot();
        };
        /**
         * 判断当前节点是否为根节点
         */
        UnionFindNode.prototype.isRoot = function () {
            return this.getRoot() === this;
        };
        /**
         * 获取当前节点的根节点
         * 并在查找过程中,打平树的高度
         */
        UnionFindNode.prototype.getRoot = function () {
            // 自己就是根节点
            if (this === this.parent)
                return this.parent;
            // 自己不是根节点,则查找根节点
            var parent0 = this.parent.getRoot();
            this.parent = parent0; // 将自己指向根节点
            return this.parent;
        };
        return UnionFindNode;
    }());

    /**
     * 循环双向链表节点
     */
    var DoubleListNode = /** @class */ (function () {
        function DoubleListNode(userData) {
            this.pre = this; // 前驱
            this.next = this; // 后驱
            this.userData = userData;
            this.name = userData;
        }
        /**
         * 添加节点
         * node 为新节点, pre 与 next 都指向自己
         * @param node
         */
        DoubleListNode.prototype.connect = function (node) {
            var next1 = this.next; // 当前节点后驱
            var next2 = node.next; // node 后驱
            // 当前节点next <-> node.Next
            this.next = next2;
            next2.pre = this;
            // node.Next <-> 当前节点next
            node.next = next1;
            next1.pre = node;
        };
        /**
         * 删除当前节点
         */
        DoubleListNode.prototype.disConnect = function () {
            // 将 Prev 与 Next 两节点连接
            this.pre.next = this.next;
            this.next.pre = this.pre;
            // 修改自己的指向
            this.next = this;
            this.pre = this;
        };
        /**
         * 以此节点为始点,输出环状连接信息
         * [1→3→2*1]
         */
        DoubleListNode.prototype.print = function () {
            var node = this;
            var s = '[' + this.name;
            while (node.next != this) {
                node = node.next;
                s += '→' + node.name;
            }
            s += '*' + this.name;
            s += ']';
            console.log(s);
        };
        return DoubleListNode;
    }());

    /**
     * 双向链表(循环)
     */
    var DoubleList = /** @class */ (function () {
        function DoubleList() {
            this.endNode = null; // 链表末尾节点
        }
        /**
         * 添加一个新节点
         * @param node
         */
        DoubleList.prototype.add = function (node) {
            if (!this.endNode) {
                this.endNode = node;
            }
            else {
                this.endNode.connect(node);
            }
        };
        /**
         * 删除一个节点
         * @param node
         */
        DoubleList.prototype.remove = function (node) {
            if (this.endNode === node) {
                if (this.endNode === node.pre) {
                    // 说明 node 为最后一个节点
                    this.endNode = null;
                }
                else {
                    this.endNode = this.endNode.pre;
                }
            }
            node.disConnect();
        };
        /**
         * 获取链表大小
         */
        DoubleList.prototype.getSize = function () {
            if (!this.endNode)
                return 0;
            var num = 1;
            var node = this.endNode;
            while (node.pre != this.endNode) {
                node = node.pre;
                num++;
            }
            return num;
        };
        /**
         * 是否为空
         */
        DoubleList.prototype.isEmpty = function () {
            return this.getSize() === 0;
        };
        /**
         * 获取所有节点
         */
        DoubleList.prototype.getAll = function () {
            if (!this.endNode)
                return [];
            var arr = new Array();
            var node = this.endNode;
            arr.push(node);
            while (node.pre != this.endNode) {
                node = node.pre;
                arr.push(node);
            }
            return arr;
        };
        /**
         * 循环遍历node
         * @param callBack
         */
        DoubleList.prototype.each = function (callBack) {
            var node = this.endNode;
            if (!node)
                return;
            //
            callBack(node); // 少这一个
            while (node.next != this.endNode) {
                node = node.next;
                callBack(node);
            }
        };
        /**
         * 清空
         */
        DoubleList.prototype.clear = function () {
            this.endNode = null;
        };
        DoubleList.prototype.print = function () {
            var s = '';
            this.each(function (item) {
                s += item.name + ',';
            });
            console.log('~~~list: ', s);
        };
        return DoubleList;
    }());

    var LinkedList = /** @class */ (function () {
        function LinkedList() {
            // 大小
            this.size = 0;
        }
        /**
         * 在链表指定索引处插入节点
         * @param index
         * @param node
         */
        LinkedList.prototype.insert = function (index, node) {
            if (index < 0 || index > this.size) {
                throw new Error("add error. index < 0 or index > size");
            }
            // 第一个prev就是dummyHead
            var prev = this.headNode;
            //
            for (var i = 0; i < index; i++) {
                // 不停的切换引用，直到找到对应索引处节点的下一个节点
                prev = prev.next;
            }
            //
            node.next = prev.next;
            prev.next = node;
            this.size++;
        };
        /**
         * 获取指定索引位置的元素
         * @param index
         */
        LinkedList.prototype.get = function (index) {
            // 判断索引合法性
            if (index < 0 || index >= this.size) {
                throw new Error("get error. index < 0 or index >= size");
            }
            var node = this.headNode.next;
            for (var i = 0; i < index; i++) {
                node = node.next;
            }
            return node;
        };
        /**
         * 获取头节点的元素
         */
        LinkedList.prototype.getFirst = function () {
            return this.get(0);
        };
        /**
         * 获取尾节点的元素
         */
        LinkedList.prototype.getLast = function () {
            return this.get(this.size - 1);
        };
        /**
         * 添加节点
         * @param node
         */
        LinkedList.prototype.add = function (node) {
            this.insert(this.size, node);
        };
        /**
         * 删除节点
         * @param node
         */
        LinkedList.prototype.remove = function (node) {
            var prev = this.headNode;
            while (prev.next !== null) {
                if (prev.next === node)
                    break;
                prev = prev.next;
            }
            if (prev.next !== null) {
                var delNode = prev.next;
                prev.next = delNode.next;
                delNode = null;
                this.size--;
            }
        };
        /**
         * 获取链表长度
         */
        LinkedList.prototype.getSize = function () {
            return this.size;
        };
        /**
         * 链表是否为空
         */
        LinkedList.prototype.isEmpty = function () {
            return this.getSize() === 0;
        };
        /**
         * 获取所有链表元素
         */
        LinkedList.prototype.getAll = function () {
            if (!this.headNode)
                return [];
            var arr = new Array();
            var node = this.headNode;
            arr.push(node);
            while (node.next != null) {
                node = node.next;
                arr.push(node);
            }
            return arr;
        };
        /**
         * 链表遍历
         * @param callBack
         */
        LinkedList.prototype.each = function (callBack) {
            for (var node = this.headNode; node != null; node = node.next) {
                callBack(node);
            }
            // 或者如while格式
            // let node: LinkedListNode = this.headNode;
            // while (node.next != null) {
            //     node = node.next;
            //     callBack(node);
            // }
        };
        return LinkedList;
    }());

    exports.ArrayUtil = ArrayUtil;
    exports.BlockConnectionRouter = BlockConnectionRouter;
    exports.ColorUtil = ColorUtil;
    exports.CompressPointUtil = CompressPointUtil;
    exports.DomUtil = DomUtil;
    exports.DoubleList = DoubleList;
    exports.DoubleListNode = DoubleListNode;
    exports.FullscreenTool = FullscreenTool;
    exports.GlobalSetting = GlobalSetting;
    exports.GraphicsTexture = GraphicsTexture;
    exports.GraphicsUtil = GraphicsUtil;
    exports.HashMap = HashMap;
    exports.LinkedList = LinkedList;
    exports.LinkedListNode = LinkedListNode;
    exports.M = M;
    exports.ManhattanConnectionRouter = ManhattanConnectionRouter;
    exports.Matrix = Matrix;
    exports.MatrixMath = MatrixMath;
    exports.NumberUtilities = NumberUtilities;
    exports.ObjTree = ObjTree;
    exports.Point = Point;
    exports.PromiseQueue = PromiseQueue;
    exports.Rectangle = Rectangle;
    exports.SVGLoad = SVGLoad;
    exports.Spline = Spline;
    exports.SplineConnectionRouter = SplineConnectionRouter;
    exports.StringUtil = StringUtil;
    exports.TouchUtil = TouchUtil;
    exports.UnionFindNode = UnionFindNode;
    exports.Vector2DMath = Vector2DMath;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.umd.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@nobook/nb-utils/dist/index.umd.js
// module id = 817
// module chunks = 9